webpackJsonp([1],Array(20).concat([
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return globalFunctions; });

var globalFunctions = {

  ////////////////////////////////////
  //Returns True If Int Or Float
  ////////////////////////////////////

  isIntOrFloat: function isIntOrFloat(value) {
    if (/^-{0,1}\d*\.{0,1}\d+$/.test(value)) {
      return true;
    }
    return false;
  },


  ///////////////////////////////////////
  //Returns the Current Date
  ///////////////////////////////////////

  getCurrentDate: function getCurrentDate() {
    var currentdate = new Date();

    return currentdate.getDate() + "/" + (currentdate.getMonth() + 1) + "/" + currentdate.getFullYear();
  },


  ///////////////////////////////////////////
  //Returns The Current Date For DatePicker
  ///////////////////////////////////////////

  getCurrentDateForPicker: function getCurrentDateForPicker() {
    var date = new Date();

    var month = date.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }

    var day = date.getDate();
    if (day < 10) {
      day = "0" + day;
    }

    return date.getFullYear() + "-" + month + "-" + day;
  },


  //////////////////////////////////////////////
  //Returns The Current Time For TimePicker
  //////////////////////////////////////////////

  getCurrentTimeForPicker: function getCurrentTimeForPicker() {
    var date = new Date();

    return date.getHours() + ":" + date.getMinutes();
  },


  /////////////////////////////////////////
  //Returns Amount In Account
  /////////////////////////////////////////

  getAccountCurrentAmount: function getAccountCurrentAmount(account, acc) {

    for (var i = 0; i < acc.length; i++) {
      if (acc[i].accountName === account) {
        return acc[i].accountAmount;
      }
    }
  },

  /////////////////////////////////////////
  //Returns Amount In Budget
  /////////////////////////////////////////

  getBudgetCurrentAmount: function getBudgetCurrentAmount(budget, bud) {

    for (var i = 0; i < bud.length; i++) {
      if (bud[i].budgetName === budget) {
        return bud[i].budgetAmount;
      }
    }
  }

};

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTTP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_index__ = __webpack_require__(57);



var HTTP = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({

  //Enter Address for Api Here
  //baseURL: 'http://localhost:62805/api/',

  //Test Environment
  //baseURL: 'http://test.mywalletwatcher.com/api/',
  baseURL: 'https://testapi.mywalletwatcher.com/api/',

  //Production
  //baseURL: 'https://api.mywalletwatcher.com/api/',

  headers: {
    //Authorization: auth.getAuthHeader()
    Authorization: 'Bearer ' + localStorage.getItem('access_token')
  }

});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listItem_vue__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e1d7130_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listItem_vue__ = __webpack_require__(317);
function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e1d7130"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e1d7130_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins__ = __webpack_require__(333);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* state */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */],
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* getters */],
  actions: __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* actions */],
  plugins: [__WEBPACK_IMPORTED_MODULE_6__plugins__["a" /* plugins */]]
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return transactionManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_storeMain__ = __webpack_require__(51);


var transactionManager = {

  transactions: [],

  transactionObject: {
    id: 0,
    account: '',
    transactionName: '',
    transactionType: '',
    transactionAmount: 0,
    paymentType: '',
    budget: 'None',
    comment: '',
    category: '',
    currency: '',
    items: [],

    transactionDate: '',
    transactionTime: null,

    transferFrom: '',
    transferTo: '',

    recurringTransaction: false,

    //Recurring Transactions
    repeat: 1,
    cycle: '',
    period: 'Forever',
    numberOfCycles: 1,
    goesOffFirst: '',

    //State of Current Object
    objectState: 'New',
    show: false
  },

  getTransactions: function getTransactions() {
    this.transactions = __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].state.Transactions;
  },
  addTransaction: function addTransaction(transaction) {
    var newEntry = JSON.parse(JSON.stringify(transaction));

    this.addItem = false;

    newEntry.id = this.getLargestIdFromTransactions() + 1;

    this.addTransactionToStore(newEntry);

    this.adjustAccountWithTransactionAmount(transaction);
  },
  getLargestIdFromTransactions: function getLargestIdFromTransactions() {
    this.getTransactions();

    var largest = 0;
    for (var i = 0; i < this.transactions.length; i++) {
      if (this.transactions[i].id > largest) {
        largest = this.transactions[i].id;
      }
    }
    return largest;
  },
  addTransactionToStore: function addTransactionToStore(newEntry) {
    __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('addNewTransactionToStore', newEntry);
  },
  adjustAccountWithTransactionAmount: function adjustAccountWithTransactionAmount(currentTransaction) {
    var add = {
      account: '',
      amount: ''
    };
    var subtract = {
      account: '',
      amount: ''
    };

    if (currentTransaction.transactionType === 'income') {
      add.account = currentTransaction.account;
      add.amount = currentTransaction.transactionAmount;

      __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('addAmountToAccount', add);
    } else if (currentTransaction.transactionType === 'expense') {
      subtract.account = currentTransaction.account;
      subtract.amount = currentTransaction.transactionAmount;

      __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('subtractAmountFromAccount', subtract);
    } else if (currentTransaction.transactionType === 'transfer') {
      subtract.account = currentTransaction.transferFrom;
      subtract.amount = currentTransaction.transactionAmount;

      __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('subtractAmountFromAccount', subtract);

      add.account = currentTransaction.transferTo;
      add.amount = currentTransaction.transactionAmount;

      __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('addAmountToAccount', add);
    }
  },
  updateAccountWithChangedTransactionAmount: function updateAccountWithChangedTransactionAmount(account, transferTo, oldAmount, newAmount, transactionType) {
    var tranObject = {
      account: '',
      amount: ''
    };

    tranObject.account = account;

    if (transactionType === 'expense') {
      if (oldAmount > newAmount) {
        //Add Remainder from account
        tranObject.amount = parseFloat(oldAmount) - parseFloat(newAmount);

        __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('addAmountToAccount', tranObject);
      } else if (newAmount > oldAmount) {
        //Subtract Remainder to account
        tranObject.amount = parseFloat(newAmount) - parseFloat(oldAmount);

        __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('subtractAmountFromAccount', tranObject);
      }
    } else if (transactionType === 'income') {
      if (oldAmount > newAmount) {
        //Subtract Remainder from account
        tranObject.amount = parseFloat(oldAmount) - parseFloat(newAmount);

        __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('subtractAmountFromAccount', tranObject);
      } else if (newAmount > oldAmount) {
        //Add Remainder to account
        tranObject.amount = parseFloat(newAmount) - parseFloat(oldAmount);

        __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('addAmountToAccount', tranObject);
      }
    } else if (transferTo !== '') {
      if (oldAmount > newAmount) {
        //Subtract amount from transferTo Account
        tranObject.amount = parseFloat(oldAmount) - parseFloat(newAmount);

        __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('subtractAmountFromAccount', { account: transferTo, amount: tranObject.amount });

        //Add amount to transferFrom account
        __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('addAmountToAccount', tranObject);
      } else if (newAmount > oldAmount) {
        //Subtract amount from transferFrom Account
        tranObject.amount = parseFloat(newAmount) - parseFloat(oldAmount);

        __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('subtractAmountFromAccount', tranObject);

        //Add amount to transferTo account
        __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('addAmountToAccount', { account: transferTo, amount: tranObject.amount });
      }
    }
  },
  getTransactionByName: function getTransactionByName(name) {
    this.getTransactions();

    for (var i = 0; i < this.transactions.length; i++) {
      if (this.transactions[i].transactionName === name) {
        return this.transactions[i];
      }
    }
  },
  updateTransaction: function updateTransaction(oldTransactionData, newTransactionData) {
    if (this.isRollbackNeeded(newTransactionData)) {
      this.updateAccountWithChangedTransactionAmount(newTransactionData.account, newTransactionData.transferTo, JSON.parse(JSON.stringify(oldTransactionData.transactionAmount)), JSON.parse(JSON.stringify(0)), newTransactionData.transactionType);
    }

    if (this.checkIfTransacationAmountNeedsAdjusting(oldTransactionData, newTransactionData)) {
      this.updateAccountWithChangedTransactionAmount(newTransactionData.account, newTransactionData.transferTo, JSON.parse(JSON.stringify(oldTransactionData.transactionAmount)), JSON.parse(JSON.stringify(newTransactionData.transactionAmount)), newTransactionData.transactionType);
    }

    var transaction = this.transferTransactionData(oldTransactionData, newTransactionData);

    this.updateTransactionInStore(transaction);
  },
  updateEditedTransaction: function updateEditedTransaction(transaction) {
    var oldTransaction = this.getTransactionByName(transaction.transactionName);

    this.updateTransaction(oldTransaction, transaction);
  },
  isRollbackNeeded: function isRollbackNeeded(transaction) {
    if (transaction.objectState === 'Delete') {
      return true;
    }
    return false;
  },
  checkIfTransacationAmountNeedsAdjusting: function checkIfTransacationAmountNeedsAdjusting(oldTransactionData, newTransactionData) {
    if (oldTransactionData.transactionAmount !== newTransactionData.transactionAmount) {
      return true;
    }
    return false;
  },
  updateTransactionInStore: function updateTransactionInStore(transaction) {
    __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('updateTransactioninStore', transaction);
  },
  transferTransactionData: function transferTransactionData(oldTransactionData, newTransactionData) {
    var transaction = this.transactionObject;

    transaction.id = oldTransactionData.id;
    transaction.account = newTransactionData.account;
    transaction.budget = newTransactionData.budget;
    transaction.category = newTransactionData.category;
    transaction.comment = newTransactionData.comment;
    transaction.currency = newTransactionData.currency;
    transaction.cycle = newTransactionData.cycle;
    transaction.goesOffFirst = newTransactionData.goesOffFirst;
    transaction.items = newTransactionData.items;
    transaction.numberOfCycles = newTransactionData.numberOfCycles;

    if (newTransactionData.objectState === 'Delete') {
      transaction.objectState = newTransactionData.objectState;
    } else {
      transaction.objectState = 'Update';
    }

    transaction.paymentType = newTransactionData.paymentType;
    transaction.period = newTransactionData.period;
    transaction.recurringTransaction = newTransactionData.recurringTransaction;
    transaction.repeat = newTransactionData.repeat;
    transaction.show = newTransactionData.show;
    transaction.transactionAmount = newTransactionData.transactionAmount;
    transaction.transactionDate = newTransactionData.transactionDate;
    transaction.transactionName = newTransactionData.transactionName;
    transaction.transactionTime = newTransactionData.transactionTime;
    transaction.transactionType = newTransactionData.transactionType;
    transaction.transferFrom = newTransactionData.transferFrom;
    transaction.transferTo = newTransactionData.transferTo;

    return transaction;
  }
};

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });

var auth = {

  // User object will let us check authentication status
  user: {
    authenticated: false
  },

  // Send a request to the login URL and save the returned JWT
  login: function login(id_token, access_token) {
    localStorage.setItem('id_token', id_token);
    localStorage.setItem('access_token', access_token);

    this.user.authenticated = true;
  },
  signup: function signup(context, creds, redirect) {
    //context.$http.post(SIGNUP_URL, creds, (data) =>
    //{
    //  localStorage.setItem('id_token', data.id_token)
    //  localStorage.setItem('access_token', data.access_token)

    //  this.user.authenticated = true

    //  if (redirect) {
    //    router.go(redirect)
    //  }

    //}).error((err) =>
    //{
    //  context.error = err
    //})

    /////////////////////////////////
    //Call Post method to post Info
    /////////////////////////////////
  },


  // To log out, we just need to remove the token
  logout: function logout() {
    localStorage.removeItem('id_token');
    localStorage.removeItem('access_token');
    localStorage.removeItem('store');
    this.user.authenticated = false;
  },
  checkAuth: function checkAuth() {
    var jwt = localStorage.getItem('access_token');
    if (jwt) {
      this.user.authenticated = true;
      return true;
    } else {
      this.user.authenticated = false;
      return false;
    }
  },


  //The object to be passed as a header for authenticated requests
  getAuthHeader: function getAuthHeader() {
    var header = 'Bearer ' + localStorage.getItem('access_token');
    return {
      header: header
    };
  }
};

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_storeMain__ = __webpack_require__(51);


var accountManager = {
  getAccountByName: function getAccountByName(accountName) {
    var acc = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].state.Accounts));

    for (var i = 0; i < acc.length; i++) {
      if (acc[i].accountName === accountName) {
        return acc[i];
      }
    }
  }
};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_currencyConverter_vue__ = __webpack_require__(150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e4db198_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currencyConverter_vue__ = __webpack_require__(336);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_currencyConverter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e4db198_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currencyConverter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return incomeManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_storeMain__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transactionManager__ = __webpack_require__(52);



var incomeManager = {
  incomes: [],

  incomeObject: {
    id: 0,
    incomeName: '',
    account: '',
    incomeType: '',
    amount: 0,
    incomeAmount: 0,
    currencyConversion: {},
    currency: '',
    incomeDate: '',
    incomeTime: '',
    comment: '',
    category: '',

    //Recurring
    repeat: 1,
    cycle: '',
    period: '',
    numberOfCycles: 1,
    goesOffFirst: '',

    //State of Current Object
    objectState: 'New',
    show: false
  },

  getIncome: function getIncome() {
    this.incomes = __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].state.Incomes;
  },
  addIncome: function addIncome(income) {
    var newEntry = JSON.parse(JSON.stringify(income));

    this.addDialog = false;

    newEntry.id = this.getLargestIdFromItems() + 1;

    this.addIncomeToStore(newEntry);
  },
  getLargestIdFromItems: function getLargestIdFromItems() {
    this.getIncome();

    var largest = 0;
    for (var i = 0; i < this.incomes.length; i++) {
      if (this.incomes[i].id > largest) {
        largest = this.incomes[i].id;
      }
    }
    return largest;
  },
  addIncomeToStore: function addIncomeToStore(newEntry) {
    __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('addNewIncomeToStore', newEntry);
  },
  createTransactionFromIncome: function createTransactionFromIncome(income) {
    var transaction = this.convertIncomeToTransaction(income);

    __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].addTransaction(transaction);
  },
  convertIncomeToTransaction: function convertIncomeToTransaction(income) {
    var transaction = __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].transactionObject;

    //Replace Data from Income
    transaction.account = income.account;
    transaction.transactionName = income.incomeName;
    transaction.transactionType = 'income';
    transaction.transactionAmount = income.incomeAmount;
    transaction.comment = income.comment;
    transaction.currency = income.currency;
    transaction.category = income.category;
    transaction.transactionDate = income.incomeDate;
    transaction.transactionTime = income.incomeTime;

    if (income.incomeType === "Recurring") {
      transaction.recurringTransaction = true;
    } else if (income.incomeType === "OneTime") {
      transaction.recurringTransaction = false;
    }

    transaction.repeat = income.repeat;
    transaction.cycle = income.cycle;
    transaction.period = income.period;
    transaction.numberOfCycles = income.numberOfCycles;
    transaction.goesOffFirst = income.goesOffFirst;
    transaction.objectState = income.objectState;

    return transaction;
  },
  updateTransactionFromIncome: function updateTransactionFromIncome(income) {
    var oldTransaction = __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].getTransactionByName(income.incomeName);

    var newTransaction = this.convertIncomeToTransaction(income);

    __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].updateTransaction(oldTransaction, newTransaction);
  },
  rollbackTransactionFromIncome: function rollbackTransactionFromIncome(income) {
    income.objectState = 'Delete';

    this.updateTransactionFromIncome(income);
  },
  createIncomeFromTrasaction: function createIncomeFromTrasaction(transaction) {
    var newIncome = this.convertTransactionToIncome(transaction);

    this.addIncome(newIncome);
  },
  convertTransactionToIncome: function convertTransactionToIncome(transaction) {
    var income = this.incomeObject;

    income.account = transaction.account;
    income.incomeName = transaction.transactionName;
    //transaction.transactionType = 'income'
    income.incomeAmount = transaction.transactionAmount;
    income.comment = transaction.comment;
    income.category = transaction.category;
    income.currency = transaction.currency;
    income.incomeDate = transaction.transactionDate;
    income.incomeTime = transaction.transactionTime;

    if (transaction.recurringTransaction) {
      income.incomeType === "Recurring";
    } else if (!transaction.recurringTransaction) {
      income.incomeType === "OneTime";
    }

    income.repeat = transaction.repeat;
    income.cycle = transaction.cycle;
    income.period = transaction.period;
    income.numberOfCycles = transaction.numberOfCycles;
    income.goesOffFirst = transaction.goesOffFirst;
    income.objectState = transaction.objectState;

    return income;
  }
};

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sharedJS; });

var sharedJS = {

  ///////////////////////////////////////////
  //Returns Main Menu Items
  ///////////////////////////////////////////
  mainMenuItems: function mainMenuItems() {
    return {
      items: [
      //Home
      { icon: 'dashboard', text: 'Dashboard', link: 'Home' },
      //Accounts
      { icon: 'account_balance', text: 'Accounts', link: 'account' },

      //Incomes
      {
        icon: 'attach_money',
        'icon-alt': 'fa-money-check-alt',
        text: 'Incomes', link: 'income'
        //children: [
        //  { icon: ' ', text: 'One time Incomes' },
        //  { icon: ' ', text: 'Reccurring Incomes' },
        //  { icon: ' ', text: 'Manage Incomes', link: 'income' },
        //]
      },

      //Expenses
      {
        icon: 'assignment',
        'icon-alt': 'assignment',
        text: 'Expenses', link: 'expense'
        //children: [
        //  { icon: ' ', text: 'One time Expenses' },
        //  { icon: ' ', text: 'Reccurring Expenses' },
        //  { icon: ' ', text: 'Manage Expenses', link: 'expense' },
        //]
      },

      //Transactions
      {
        icon: 'fa-hand-holding-usd',
        'icon-alt': 'fa-hand-holding-usd',
        text: 'Transactions', link: 'transaction'
        //children: [
        //  { icon: ' ', text: 'One time Transactions' },
        //  { icon: ' ', text: 'Reccurring Transactions' },
        //  { icon: ' ', text: 'Manage Transactions', link: 'transaction' },
        //]
      },
      //Budgets
      {
        icon: 'fas fa-calculator',
        'icon-alt': 'fas fa-calculator',
        text: 'Budgets', link: 'budget'
        //children: [
        //  { icon: ' ', text: 'Running' },
        //  { icon: ' ', text: 'Completed' },
        //  { icon: ' ', text: 'Manage Budgets', link: 'budget' }
        //]
      }, {
        icon: 'fas fa-exchange-alt',
        'icon-alt': 'fas fa-exchange-alt',
        text: 'Transfers',
        link: 'transfer'
      }]
    };
  },


  ////////////////////////////////////////////
  //Returns The Number for each Badges
  ////////////////////////////////////////////
  navBadges: function navBadges() {}
};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return expenseManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_storeMain__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transactionManager__ = __webpack_require__(52);



var expenseManager = {

  expenses: [],

  expenseObject: {
    id: 0,
    expenseName: '',
    account: '',
    budget: 'None',
    expenseType: '',
    amount: 0,
    expenseAmount: 0,
    currencyConversion: {},
    currency: '',
    expenseDate: '',
    expenseTime: '',
    comment: '',
    category: '',

    //Recurring
    repeat: 1,
    cycle: '',
    period: 'Forever',
    numberOfCycles: 1,
    goesOffFirst: '',

    //State of Current Object
    objectState: 'New',
    show: false
  },

  getExpense: function getExpense() {
    this.expenses = __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].state.Expenses;
  },
  addExpense: function addExpense(expense) {
    var newEntry = JSON.parse(JSON.stringify(expense));

    this.addDialog = false;

    newEntry.id = this.getLargestIdFromItems() + 1;

    this.addExpenseToStore(newEntry);
  },
  getLargestIdFromItems: function getLargestIdFromItems() {
    this.getExpense();

    var largest = 0;
    for (var i = 0; i < this.expenses.length; i++) {
      if (this.expenses[i].id > largest) {
        largest = this.expenses[i].id;
      }
    }
    return largest;
  },
  addExpenseToStore: function addExpenseToStore(newEntry) {
    __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('addNewExpenseToStore', newEntry);
  },
  createTransactionFromExpense: function createTransactionFromExpense(expense) {
    var transaction = this.convertExpenseToTransaction(expense);

    __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].addTransaction(transaction);
  },
  convertExpenseToTransaction: function convertExpenseToTransaction(expense) {
    var transaction = __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].transactionObject;

    //Replace Data from Expense
    transaction.account = expense.account;
    transaction.budget = expense.budget;
    transaction.transactionName = expense.expenseName;
    transaction.transactionType = 'expense';
    transaction.transactionAmount = expense.expenseAmount;
    transaction.comment = expense.comment;
    transaction.category = expense.category;
    transaction.currency = expense.currency;
    transaction.transactionDate = expense.expenseDate;
    transaction.transactionTime = expense.expenseTime;

    if (expense.expenseType === "Recurring") {
      transaction.recurringTransaction = true;
    } else if (expense.expenseType === "OneTime") {
      transaction.recurringTransaction = false;
    }

    transaction.repeat = expense.repeat;
    transaction.cycle = expense.cycle;
    transaction.period = expense.period;
    transaction.numberOfCycles = expense.numberOfCycles;
    transaction.goesOffFirst = expense.goesOffFirst;
    transaction.objectState = expense.objectState;

    return transaction;
  },
  updateTransactionFromExpense: function updateTransactionFromExpense(expense) {
    var oldTransaction = __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].getTransactionByName(expense.expenseName);

    var newTransaction = this.convertExpenseToTransaction(expense);

    __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].updateTransaction(oldTransaction, newTransaction);
  },
  rollbackTransactionFromExpense: function rollbackTransactionFromExpense(expense) {
    expense.objectState = 'Delete';

    __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].updateTransactionFromExpense(expense);
  },
  createExpenseFromTransaction: function createExpenseFromTransaction(transaction) {
    var newExpense = this.convertTransactionToExpense(transaction);

    this.addExpense(newExpense);
  },
  convertTransactionToExpense: function convertTransactionToExpense(transaction) {
    var expense = this.expenseObject;

    expense.account = transaction.account;
    expense.budget = transaction.budget;
    expense.expenseName = transaction.transactionName;
    //transaction.transactionType = 'expense'
    expense.expenseAmount = transaction.transactionAmount;
    expense.comment = transaction.comment;
    expense.category = transaction.category;
    expense.currency = transaction.currency;
    expense.expenseDate = transaction.transactionDate;
    expense.expenseTime = transaction.transactionTime;

    if (transaction.recurringTransaction) {
      expense.expenseType === "Recurring";
    } else if (!transaction.recurringTransaction) {
      expense.expenseType === "OneTime";
    }

    expense.repeat = transaction.repeat;
    expense.cycle = transaction.cycle;
    expense.period = transaction.period;
    expense.numberOfCycles = transaction.numberOfCycles;
    expense.goesOffFirst = transaction.goesOffFirst;
    expense.objectState = transaction.objectState;

    return expense;
  }
};

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return transferManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_storeMain__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transactionManager__ = __webpack_require__(52);



var transferManager = {
  transfers: [],

  getTransfer: function getTransfer() {
    this.transfers = __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].state.Transfers;
  },
  addTransfer: function addTransfer(transfer) {
    var newEntry = JSON.parse(JSON.stringify(transfer));

    this.addDialog = false;

    newEntry.id = this.getLargestIdFromItems() + 1;

    this.addTransferToStore(newEntry);
  },
  getLargestIdFromItems: function getLargestIdFromItems() {
    this.getTransfer();

    var largest = 0;
    for (var i = 0; i < this.transfers.length; i++) {
      if (this.transfers[i].id > largest) {
        largest = this.transfers[i].id;
      }
    }
    return largest;
  },
  addTransferToStore: function addTransferToStore(newEntry) {
    __WEBPACK_IMPORTED_MODULE_0__store_storeMain__["a" /* store */].commit('addNewTransferToStore', newEntry);
  },
  createTransactionFromTransfer: function createTransactionFromTransfer(transfer) {
    var transaction = this.convertTransferToTransaction(transfer);

    __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].addTransaction(transaction);
  },
  convertTransferToTransaction: function convertTransferToTransaction(transfer) {
    var transaction = __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].transactionObject;

    //Replace Data from Income
    transaction.account = transfer.account;
    transaction.transactionName = transfer.transferName;
    transaction.transactionType = 'transfer';
    transaction.transactionAmount = transfer.transferAmount;
    transaction.comment = transfer.comment;
    transaction.category = transfer.category;
    transaction.currency = transfer.currency;
    transaction.transactionDate = transfer.transferDate;
    transaction.transactionTime = transfer.transferTime;

    //if (income.incomeType === "Recurring") {
    //  transaction.recurringTransaction = true
    //}
    //else if (income.incomeType === "OneTime") {
    transaction.recurringTransaction = false;
    //}

    //transaction.repeat = income.repeat
    //transaction.cycle = income.cycle
    //transaction.period = income.period
    //transaction.numberOfCycles = income.numberOfCycles
    //transaction.goesOffFirst = income.goesOffFirst
    transaction.objectState = transfer.objectState;

    return transaction;
  },
  updateTransactionFromTransfer: function updateTransactionFromTransfer(transfer) {
    var oldTransaction = __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].getTransactionByName(transfer.transferName);

    var newTransaction = this.convertTransferToTransaction(transfer);

    __WEBPACK_IMPORTED_MODULE_1__transactionManager__["a" /* transactionManager */].updateTransaction(oldTransaction, newTransaction);
  },
  rollbackTransactionFromTransfer: function rollbackTransactionFromTransfer(transfer) {
    transfer.objectState = 'Delete';

    this.updateTransactionFromTransfer(transfer);
  }
};

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_mainstyles_min_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_mainstyles_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_mainstyles_min_css__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  data: function data() {
    return {

      homeheadline: 'Keep an eye on your wallet.',
      homesubheadline: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec dolor et sapien ultrices suscipit suscipit non orci.',
      cards: [{ title: 'Budgetting', src: '../../static/img/thumbnails/triangle-1280x728.jpg', featureDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec dolor et sapien ultrices suscipit suscipit' }, { title: 'Feature 2', src: '../../static/img/thumbnails/accountant-1280x856.jpg', featureDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec dolor et sapien ultrices suscipit suscipit' }, { title: 'Feature 3', src: '../../static/img/thumbnails/wallet-1280x833.jpg', featureDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec dolor et sapien ultrices suscipit suscipit' }]

    };
  }

});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_httpCommon__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_index__ = __webpack_require__(57);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],

  data: function data() {
    return {
      user: {
        email: '',
        password: ''
      },
      loading: false,
      showErrorMessage: false,
      errorMessage: ''
    };
  },

  computed: {
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.user.email.$dirty) return errors;
      !this.$v.user.email.email && errors.push('Must be valid e-mail');
      !this.$v.user.email.required && errors.push('E-mail is required');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.user.password.$dirty) return errors;
      !this.$v.user.password.required && errors.push('Password is required');
      return errors;
    }
  },
  methods: {
    ValCheck: function ValCheck($v) {

      $v.$touch(); //Triggers Error Messages

      if ($v.email.$invalid || $v.password.$invalid) {
        return;
      }

      this.loading = true;
      this.login();
    },
    login: function login() {
      var _this = this;

      this.showDismissibleAlert = true, __WEBPACK_IMPORTED_MODULE_2__api_httpCommon__["a" /* HTTP */].post('Login', this.user).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3__auth_index__["a" /* auth */].login(response.data.userId, response.data.token);
        if (response.status === 200) {
          _this.$router.push({ path: '/dashboard' });
        } else if (response.status === 401) {
          _this.errorMessage = "Email/Password Incorrect";
          _this.showErrorMessage = true;
        } else if (response.status === 404) {
          _this.errorMessage = "Are you Registered? Please Resgister";
          _this.showErrorMessage = true;
        } else {
          _this.errorMessage = "Something Went Wrong Please try again";
          _this.showErrorMessage = true;
        }
        _this.loading = false;
      }).catch(function (e) {

        if (e.response.status === 401) {
          _this.errorMessage = "Email/Password Incorrect";
          _this.showErrorMessage = true;
        } else if (e.response.status === 404) {
          _this.errorMessage = "Are you Registered? Please Resgister";
          _this.showErrorMessage = true;
        } else {
          _this.errorMessage = "Something Went Wrong Please try again";
          _this.showErrorMessage = true;
        }
        //this.errorMessage = "Something Went Wrong Please try again"
        //this.showErrorMessage = true

        console.log(e);
        _this.loading = false;
      });
    }
  },
  validations: {
    user: {
      email: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }

});

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mww128.343a793.png";

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zxcvbn__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zxcvbn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_zxcvbn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_httpCommon__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import '../../javascript/zxcvbn.js'



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  /// Added vm to create a Component Instance that can be called later
  data: function data(vm) {
    return {
      showErrorMessage: false,
      errorMessage: '',
      passwordShow: false,
      cpasswordShow: false,
      stepper: '',
      user: {
        userName: '',
        email: '',
        password: '',
        cpassword: '',
        subscriptionType: 'Free',
        //PaymentDay: 1,
        gctPercentage: 0,
        //GCTDate: '',
        countryName: '',
        newsletter: false,
        //AddExtraToBudget: false,
        //ExtraPercentage: 0,
        addExcessToSavingsAccount: false
      },
      rules: {
        strength: vm.getPasswordStrength
      },
      countries: ["Anguilla", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Ashmore and Cartier Islands", "Australia", "Austria", "Azerbaijan", "The Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Botswana", "Brazil", "British Virgin Islands", "Canada", "Cayman Islands", "Chile", "China", "Colombia", "Costa Rica", "Cuba", "Czech Republic", "Denmark", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Finland", "France", "French Guiana", "Germany", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guatemala", "Guinea", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Ireland", "Italy", "Jamaica", "Japan", "Martinique", "Mexico", "Montserrat", "Netherlands", "Netherlands Antilles", "New Zealand", "Norway", "Panama", "Poland", "Portugal", "Puerto Rico", "Qatar", "Romania", "Russia", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Saudi Arabia", "Sweden", "Switzerland", "Trinidad and Tobago", "Turkey", "Turks and Caicos Islands", "United Kingdom", "United States", "Venezuela"],
      subscriptionTypes: [{ name: "Free", price: 0 }, { name: "Single", price: 1.00 }, { name: "Couple", price: 1.30 }],
      count: 0
    };
  },

  computed: {
    userNameErrors: function userNameErrors() {
      var errors = [];
      if (!this.$v.user.userName.$dirty) return errors;
      !this.$v.user.userName.required && errors.push('Username is required');
      return errors;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.user.email.$dirty) return errors;
      !this.$v.user.email.email && errors.push('Must be valid e-mail');
      !this.$v.user.email.required && errors.push('E-mail is required');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.user.password.$dirty) return errors;
      !this.$v.user.password.required && errors.push('Password is required');
      return errors;
    },
    cPasswordErrors: function cPasswordErrors() {
      var errors = [];
      if (!this.$v.user.cpassword.$dirty) return errors;
      !this.$v.user.cpassword.sameAsPassword && errors.push(' Passwords must be identical');
      !this.$v.user.cpassword.required && errors.push('Password is required');
      return errors;
    },
    countryNameErrors: function countryNameErrors() {
      var errors = [];
      if (!this.$v.user.countryName.$dirty) return errors;
      !this.$v.user.countryName.required && errors.push('Country is required');
      return errors;
    },
    gctPercentageErrors: function gctPercentageErrors() {
      var errors = [];
      if (!this.$v.user.gctPercentage.$dirty) return errors;
      !this.$v.user.gctPercentage.required && errors.push('GCT is required');
      return errors;
    }
  },
  methods: {
    moveToSecondStep: function moveToSecondStep($v) {
      if (this.validatePersonalDetail($v)) {
        this.stepper = 2;
      }
    },
    moveToFinalStep: function moveToFinalStep() {
      if (this.validateSubscription()) {
        this.stepper = 3;
      }
    },
    validateSubscription: function validateSubscription() {
      if (this.user.subscriptionType === '') {
        this.showErrorMessage = true;
        this.errorMessage = "You Must Select A Subscription Type";
        return false;
      }
      return true;
    },
    validatePersonalDetail: function validatePersonalDetail($v) {
      //Triggers Error Messages
      $v.userName.$touch();
      $v.email.$touch();
      $v.countryName.$touch();
      $v.gctPercentage.$touch();

      if ($v.userName.$invalid || $v.email.$invalid || $v.countryName.$invalid || $v.gctPercentage.$invalid) {
        return false;
      }
      return true;
    },
    validatePassword: function validatePassword($v) {
      //Triggers Error Messages
      $v.password.$touch();
      $v.cpassword.$touch();

      if ($v.password.$invalid || $v.cpassword.$invalid) {
        return false;
      }
      return true;
    },
    register: function register() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__api_httpCommon__["a" /* HTTP */].post('Registration', this.user).then(function (response) {

        if (response.status === 200) {
          _this.$router.push({ path: '/login' });
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    subscriptionSelected: function subscriptionSelected(itemName) {
      this.user.subscriptionType = itemName;
      this.showErrorMessage = false;
    },
    onComplete: function onComplete($v) {
      if (this.validatePersonalDetail($v) && this.validateSubscription() && this.validatePassword($v)) {
        this.register();
      }
    },
    getPasswordStrength: function getPasswordStrength() {
      if (this.user.password !== '' && this.user.password !== null && this.user.password !== undefined) {
        var result = __WEBPACK_IMPORTED_MODULE_2_zxcvbn___default()(this.user.password);

        switch (result.score) {
          case 0:
            return 'Very Weak Password';

          case 1:
            return 'Weak Password';

          case 2:
            return 'Somewhat Weak Password';
        }
      }
      return true;
    }
  },
  validations: {
    user: {
      userName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      cpassword: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        sameAsPassword: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('password')
      },
      countryName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      gctPercentage: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }

});

/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, exports) {

//
//
//
//

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generalSettings_GeneralSettings_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accountSettings_AccountSettings_vue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__securitySettings_SecuritySettings_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notificationSettings_NotificationSettings_vue__ = __webpack_require__(284);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'GeneralSettings': __WEBPACK_IMPORTED_MODULE_0__generalSettings_GeneralSettings_vue__["a" /* default */],
    'AccountSettings': __WEBPACK_IMPORTED_MODULE_1__accountSettings_AccountSettings_vue__["a" /* default */],
    'SecuritySettings': __WEBPACK_IMPORTED_MODULE_2__securitySettings_SecuritySettings_vue__["a" /* default */],
    'NotificationSettings': __WEBPACK_IMPORTED_MODULE_3__notificationSettings_NotificationSettings_vue__["a" /* default */]
  },
  data: function data() {
    return {
      Saved: false,
      settingsmodel: ''
    };
  },

  methods: {
    selectSettings: function selectSettings(item) {
      switch (item) {
        case "general":
          this.settingsmodel = "GeneralSettings";
          break;
        case "account":
          this.settingsmodel = "AccountSettings";
          break;
        case "security":
          this.settingsmodel = "SecuritySettings";
          break;
        case "notification":
          this.settingsmodel = "NotificationSettings";
          break;
      }
    }
  },
  beforeMount: function beforeMount() {
    this.selectSettings(this.$route.params.itemId);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      saveOptions: false,
      editOptions: true,
      model: null,
      gct: '16.5',
      currency: ['USD - U.S Dollar'],
      country: 'Jamaica',
      language: 'English',
      currencies: ['USD - U.S Dollar', 'JMD - Jamaican Dollar'],
      countries: ["Anguilla", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Ashmore and Cartier Islands", "Australia", "Austria", "Azerbaijan", "The Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Botswana", "Brazil", "British Virgin Islands", "Canada", "Cayman Islands", "Chile", "China", "Colombia", "Costa Rica", "Cuba", "Czech Republic", "Denmark", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Finland", "France", "French Guiana", "Germany", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guatemala", "Guinea", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Ireland", "Italy", "Jamaica", "Japan", "Martinique", "Mexico", "Montserrat", "Netherlands", "Netherlands Antilles", "New Zealand", "Norway", "Panama", "Poland", "Portugal", "Puerto Rico", "Qatar", "Romania", "Russia", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Saudi Arabia", "Sweden", "Switzerland", "Trinidad and Tobago", "Turkey", "Turks and Caicos Islands", "United Kingdom", "United States", "Venezuela"],
      languages: ['English', 'Spanish', 'French']
    };
  },

  methods: {
    updateCurrency: function updateCurrency() {}
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      saveThreshod: false,
      editThreshod: true,
      alertThreshods: false,
      lowbalance: '500',
      transactionlimit: '200'
    };
  }
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

//
//
//
//
//
//

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentNotification: {
        id: '',
        title: '',
        body: '',
        date: '',
        status: ''
      },
      items: []
    };
  },

  methods: {
    getNotification: function getNotification(notification) {
      for (i = 0; i < this.items.length; i++) {
        if (this.items[i].id === notification) {
          this.currentNotification = this.items[i];
          break;
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.items = this.$store.state.Notifications;

    this.getNotification(this.$route.params.itemId);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sharedJS_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_index_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BottomNav_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SideNav_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version__ = __webpack_require__(134);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





///Component Imports





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'bottomnav': __WEBPACK_IMPORTED_MODULE_2__BottomNav_vue__["a" /* default */],
    'SideNav': __WEBPACK_IMPORTED_MODULE_3__SideNav_vue__["a" /* default */]
  },
  /// Added vm to create a Component Instance that can be called later
  data: function data(vm) {
    return {

      dropdown: false,
      drawer: false,

      mainMenuBadge: '',
      extensionsBadge: '3',
      budgetDataBadge: '1',
      notificationBadge: '2',

      darkModeSwitch: false,
      //topNav: '',
      //itemCard: '',

      version: '',

      //profile navigation
      account: [{ icon: 'account_box', title: 'Manage Profile', func: vm.profilePage },
      //{ icon: 'payment', title: 'Payments', func: '' },
      { icon: 'settings', title: 'Settings', func: vm.showSettings },
      //{ icon: 'devices', title: 'Devices', func: '' },
      { icon: 'brightness_medium', title: 'Dark mode', func: vm.darkMode, switch: 'switch' }, { icon: 'exit_to_app', title: 'Sign out', func: vm.signOut }],
      mwwmenu: [{ icon: 'help', title: 'help', func: vm.helpPage }, { icon: 'feedback', title: 'Suggestions', func: vm.suggestionsPage }, { icon: 'bug_report', title: 'Report', func: vm.reportPage }],
      // END: profile navigation

      recent_notifications: [{ icon: 'report_problem', iconClass: 'red lighten-1 white--text', title: 'You are over your budget', subtitle: '1 hour ago' }, { icon: 'fa-exclamation-circle', iconClass: 'warning lighten-1 white--text', title: 'Your balance is low', subtitle: '2 hours ago' }],
      quicklaunch: [{ icon: 'fa-money-bill-alt', iconClass: 'red--text', subtitle: 'Expense' }, { icon: 'fa-money-check-alt', iconClass: 'green--text', subtitle: 'Income' }, { icon: 'fa-hand-holding-usd', iconClass: 'blue--text', subtitle: 'Transaction' }, { icon: 'insert_chart', iconClass: 'teal--text', subtitle: 'Budget' }]

    };
  },

  methods: {
    transferPush: function transferPush() {
      this.$router.push({ path: '/dashboard/transaction' });
    },
    helpPage: function helpPage() {
      this.$router.push({ path: '/dashboard/help' });
    },
    suggestionsPage: function suggestionsPage() {
      this.$router.push({ path: '/dashboard/suggestions' });
    },
    reportPage: function reportPage() {
      this.$router.push({ path: '/dashboard/issues' });
    },
    darkMode: function darkMode() {
      this.$vuetify.dark = !this.$vuetify.dark;
      this.adjustDarkMode();

      this.$store.commit('UpdateNightModeSelection', this.darkModeSwitch);
    },
    adjustDarkMode: function adjustDarkMode() {
      this.darkModeSwitch = this.$vuetify.dark;

      this.$store.state.NightMode.topNav = this.$vuetify.dark ? 'dark-mode' : 'light-mode';
      this.$store.state.NightMode.sideNav = this.$vuetify.dark ? 'dark-mode' : 'light-mode';
      this.$store.state.NightMode.itemCard = this.$vuetify.dark ? 'itemCarddark' : 'itemCardlight';
    },
    profilePage: function profilePage() {
      this.$router.push({ path: '/dashboard/Profile' });
    },
    showSettings: function showSettings() {
      this.$router.push({ path: '/dashboard/settings/general' });
    },
    signOut: function signOut() {

      __WEBPACK_IMPORTED_MODULE_1__auth_index_js__["a" /* auth */].logout();

      this.$router.push({ path: '/' });
    }

  },
  beforeMount: function beforeMount() {

    //Get Side Nav Items From SharedJS
    this.items = __WEBPACK_IMPORTED_MODULE_0__sharedJS_js__["a" /* sharedJS */].mainMenuItems().items;

    this.version = __WEBPACK_IMPORTED_MODULE_4__version__["a" /* version */];

    if (this.$store.state.NightMode.switch !== '') {
      this.$vuetify.dark = this.$store.state.NightMode.switch;
      this.adjustDarkMode();
    }
  },
  beforeCreate: function beforeCreate() {
    this.$store.commit('initialiseStore');

    ///////////////////////////////////////////////////////////////////
    //TODO: Check if online then run function below
    ///////////////////////////////////////////////////////////////////

    //this.$store.dispatch('syncStoreWithDatabaseAfterComingOnline')
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mainMenuBadge: '',
      extensionsBadge: '3',
      budgetDataBadge: '1',
      notificationBadge: '2',

      navSelection: ''
    };
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sharedJS_js__ = __webpack_require__(81);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['drawer'],
  data: function data() {
    return {

      mainMenuBadge: '2',
      extensionsBadge: '3',
      budgetDataBadge: '1',
      notificationBadge: '2',

      navSelection: 'home',

      //side nav items
      items: []

    };
  },
  beforeMount: function beforeMount() {

    //Get Side Nav Items From SharedJS
    this.items = __WEBPACK_IMPORTED_MODULE_0__sharedJS_js__["a" /* sharedJS */].mainMenuItems().items;
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return version; });
var version = '0.2.0.0';

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_index__ = __webpack_require__(57);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 137 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 138 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sharedJS_js__ = __webpack_require__(81);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: []

    };
  },
  beforeMount: function beforeMount() {

    //Gets Menu Items From SharedJS File
    this.items = __WEBPACK_IMPORTED_MODULE_0__sharedJS_js__["a" /* sharedJS */].mainMenuItems().items;
  }
});

/***/ }),
/* 140 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reuseable_viewListItem_listItem_vue__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'ListItem': __WEBPACK_IMPORTED_MODULE_0__reuseable_viewListItem_listItem_vue__["a" /* default */]
  },
  props: ['drawer'],
  data: function data() {
    return {
      direction: 'left',
      speedDial: false,
      transition: 'slide-y-reverse-transition',
      moreOptions: false,
      search: '',
      viewSearch: false,
      viewFilter: false,
      filterBy: {
        transactionType: 'None',
        budget: 'None',
        category: 'None',
        currency: 'None',
        paymentType: 'None',
        show: false
      },
      deleteDialog: false,
      deleteAccount: {
        id: '',
        accountName: '',
        accountType: '',
        accountDescription: '',
        accountCurrency: '',
        accountAmount: 0,
        objectState: ''
      },
      items: [],
      itemsMinusDeleted: []
    };
  },

  methods: {
    DeleteAccountAccept: function DeleteAccountAccept() {
      this.deleteDialog = false;

      this.deleteAccount.objectState = "Delete";

      ///Remove item from items array
      this.removeDeletedAccountsFromItems();

      this.$store.commit('markAccountAsDeleted', this.deleteAccount);
    },
    DeleteAccount: function DeleteAccount(item) {

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === item) {
          this.deleteAccount = this.items[i];
          break;
        }
      }

      this.deleteDialog = true;
    },
    redirectToEditPage: function redirectToEditPage(item) {
      this.$router.push({ path: '/dashboard/editaccount/' + item });
    },
    removeDeletedAccountsFromItems: function removeDeletedAccountsFromItems() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].objectState === 'Delete') {
          this.items.splice(i, 1);
        }
      }

      this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items));
    },
    getSearchItems: function getSearchItems() {
      //Check if Search is empty
      if (this.search === '') {
        return;
      }

      //Get All Items from item
      this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items));

      //Remove Transactions that does not meet search criteria 
      for (var i = 0; i < this.itemsMinusDeleted.length; i++) {
        if (this.itemsMinusDeleted[i].accountName.indexOf(this.search) === -1) {
          this.itemsMinusDeleted.splice(i, 1);
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.items = JSON.parse(JSON.stringify(this.$store.state.Accounts));

    ///Remove deleted items from items array
    this.removeDeletedAccountsFromItems();
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account_AccountData_vue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__budget_BudgetData_vue__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transfer_TransferData_vue__ = __webpack_require__(315);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'AccountData': __WEBPACK_IMPORTED_MODULE_0__account_AccountData_vue__["a" /* default */],
    'BudgetData': __WEBPACK_IMPORTED_MODULE_1__budget_BudgetData_vue__["a" /* default */],
    'TransferData': __WEBPACK_IMPORTED_MODULE_2__transfer_TransferData_vue__["a" /* default */]
  },
  props: ['liItem'],
  data: function data() {
    return {
      lItem: {
        id: 0,
        name: '',
        account: '',
        type: '',
        amount: 0,
        amountSpent: 0,
        refillAmount: 0,
        date: '',
        currency: '',

        show: false
      }
    };
  },

  methods: {
    redirectToEditPage: function redirectToEditPage(itemId) {
      this.$emit('Edit', itemId);
    },
    DeleteItem: function DeleteItem(lItem) {
      this.$emit('Delete', lItem);
    },
    conversionManager: function conversionManager(type, data) {
      switch (type) {
        case "account":
          this.convertAccountTolItem(data);
          break;
        case "income":
          this.convertIncomeTolItem(data);
          break;
        case "expense":
          this.convertExpenseTolItem(data);
          break;
        case "budget":
          this.convertBudgetTolItem(data);
          break;
        case "transfer":
          this.convertTransferTolItem(data);
          break;
        case "transaction":
          this.convertTransactionTolItem(data);
          break;
      }
    },
    convertAccountTolItem: function convertAccountTolItem(data) {
      this.lItem.id = data.id;
      this.lItem.name = data.accountName;
      this.lItem.type = data.accountType;
      this.lItem.amount = data.accountAmount;
      this.lItem.currency = data.accountCurrency;
    },
    convertIncomeTolItem: function convertIncomeTolItem(data) {
      this.lItem.id = data.id;
      this.lItem.name = data.incomeName;
      this.lItem.type = data.incomeType;
      this.lItem.amount = data.incomeAmount;
      this.lItem.currency = data.currency;
      this.lItem.account = data.account;
      this.lItem.date = data.incomeDate;
    },
    convertExpenseTolItem: function convertExpenseTolItem(data) {
      this.lItem.id = data.id;
      this.lItem.name = data.expenseName;
      this.lItem.type = data.expenseType;
      this.lItem.amount = data.expenseAmount;
      this.lItem.currency = data.currency;
      this.lItem.account = data.account;
      this.lItem.date = data.expenseDate;
    },
    convertBudgetTolItem: function convertBudgetTolItem(data) {
      this.lItem.id = data.id;
      this.lItem.name = data.budgetName;
      this.lItem.type = data.budgetType;
      this.lItem.amount = data.budgetAmount;
      this.lItem.account = data.account;
    },
    convertTransferTolItem: function convertTransferTolItem(data) {
      this.lItem.id = data.id;
      this.lItem.name = data.transferName;
      this.lItem.amount = data.transferAmount;
      this.lItem.currency = data.currency;
      this.lItem.account = data.account;
      this.lItem.date = data.transferDate;
    },
    convertTransactionTolItem: function convertTransactionTolItem(data) {
      this.lItem.id = data.id;
      this.lItem.name = data.transactionName;
      this.lItem.type = data.transactionType;
      this.lItem.amount = data.transactionAmount;
      this.lItem.currency = data.currency;
      this.lItem.account = data.account;
      this.lItem.date = data.transactionDate;
    }
  },
  beforeMount: function beforeMount() {
    this.conversionManager(this.liItem.type, this.liItem.data);
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['accountId'],
  data: function data() {
    return {
      account: []
    };
  },
  beforeMount: function beforeMount() {
    var acc = this.$store.state.Accounts;
    for (var i = 0; i < acc.length; i++) {
      if (acc[i].id === this.accountId) {
        this.account = acc[i];
        break;
      }
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['budgetId'],
  data: function data() {
    return {
      budget: []
    };
  },

  computed: {
    percentage: function percentage() {
      return function (spent, total) {
        return spent / total * 100;
      };
    },
    colorSelector: function colorSelector() {
      return function (val) {
        if (val < 60) {
          return 'green';
        } else if (val >= 60 && val < 90) {
          return 'orange';
        } else if (val >= 90) {
          return 'red';
        }
      };
    }
  },
  beforeMount: function beforeMount() {
    var bud = this.$store.state.Budgets;
    for (var i = 0; i < bud.length; i++) {
      if (bud[i].id === this.budgetId) {
        this.budget = bud[i];
        break;
      }
    }
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['transferId'],
  data: function data() {
    return {
      transfer: []
    };
  },
  beforeMount: function beforeMount() {
    var tran = this.$store.state.Transfers;
    for (var i = 0; i < tran.length; i++) {
      if (tran[i].id === this.transferId) {
        this.transfer = tran[i];
        break;
      }
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  props: ['drawer'],
  data: function data() {
    return {
      sameAccount: false,
      types: ["Bank", "Saving", "Checking", "Cash", "Other"],
      curriences: ["USD", "JMD"],
      currentAccount: {
        id: 0,
        accountName: '',
        accountType: '',
        accountDescription: '',
        accountCurrency: '',
        accountAmount: 0,
        objectState: 'New'
        //show: false
      },
      items: []
    };
  },

  computed: {
    accountNameErrors: function accountNameErrors() {
      var errors = [];
      if (!this.$v.currentAccount.accountName.$dirty) return errors;
      this.sameAccount && errors.push('An Account already has this Name. Enter a new Name or update Account');
      !this.$v.currentAccount.accountName.required && errors.push('Account Name is required');
      return errors;
    },
    accountTypeErrors: function accountTypeErrors() {
      var errors = [];
      if (!this.$v.currentAccount.accountType.$dirty) return errors;
      !this.$v.currentAccount.accountType.required && errors.push('Account Type is required');
      return errors;
    },

    //accountDescriptionErrors() {
    //  const errors = []
    //  if (!this.$v.currentAccount.accountDescription.$dirty) return errors
    //  !this.$v.currentAccount.accountDescription.required && errors.push('Account Description is required')
    //  return errors
    //},
    accountCurrencyErrors: function accountCurrencyErrors() {
      var errors = [];
      if (!this.$v.currentAccount.accountCurrency.$dirty) return errors;
      !this.$v.currentAccount.accountCurrency.required && errors.push('Account Currency is required');
      return errors;
    }
  },
  methods: {
    AddAccountCheck: function AddAccountCheck($v) {

      $v.$touch(); //Triggers Error Messages

      if (this.currentAccount.accountAmount < 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.currentAccount.accountAmount) || this.currentAccount.accountAmount === "") {
        this.currentAccount.accountAmount = 0;
      }

      if ($v.accountName.$invalid || $v.accountCurrency.$invalid) {
        return;
      }

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].accountName.toLowerCase() === this.currentAccount.accountName.toLowerCase()) {
          this.sameAccount = true;
          return;
        }
        if (i === this.items.length - 1) {
          this.sameAccount = false;
        }
      }

      this.AddAccount($v);
    },
    AddAccount: function AddAccount($v) {
      var newEntry = JSON.parse(JSON.stringify(this.currentAccount));

      this.addDialog = false;

      newEntry.id = this.getLargestIdFromItems() + 1;

      this.$store.commit('addNewAccountToStore', newEntry);

      this.$router.push({ path: '/dashboard/account' });
    },
    getLargestIdFromItems: function getLargestIdFromItems() {
      var largest = 0;
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id > largest) {
          largest = this.items[i].id;
        }
      }
      return largest;
    },
    removeDeletedAccountsFromItems: function removeDeletedAccountsFromItems() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].objectState === 'Delete') {
          this.items.splice(i, 1);
        }
      }
    }
  },
  beforeMount: function beforeMount() {

    this.items = this.$store.state.Accounts;

    ///Remove deleted items from items array
    this.removeDeletedAccountsFromItems();

    //this.curriences = this.$store.state.Currencies
  },

  validations: {
    currentAccount: {
      accountName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      accountType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      //accountDescription: {
      //  required
      //},
      accountCurrency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }

  }

});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  props: ['drawer'],
  data: function data() {
    return {
      sameAccount: false,
      types: ["Bank", "Saving", "Checking", "Cash", "Other"],
      curriences: [],
      editAccount: {
        id: '',
        accountName: '',
        accountType: '',
        accountDescription: '',
        accountCurrency: '',
        accountAmount: 0,
        objectState: ''
      },
      items: []
    };
  },

  computed: {
    accountNameErrors: function accountNameErrors() {
      var errors = [];
      if (!this.$v.editAccount.accountName.$dirty) return errors;
      this.sameAccount && errors.push('An Account already has this Name. Enter a new Name of update Account');
      !this.$v.editAccount.accountName.required && errors.push('Account Name is required');
      return errors;
    },
    accountTypeErrors: function accountTypeErrors() {
      var errors = [];
      if (!this.$v.editAccount.accountType.$dirty) return errors;
      !this.$v.editAccount.accountType.required && errors.push('Account Type is required');
      return errors;
    },

    //accountDescriptionErrors() {
    //  const errors = []
    //  if (!this.$v.editAccount.accountDescription.$dirty) return errors
    //  !this.$v.editAccount.accountDescription.required && errors.push('Account Description is required')
    //  return errors
    //},
    accountCurrencyErrors: function accountCurrencyErrors() {
      var errors = [];
      if (!this.$v.editAccount.accountCurrency.$dirty) return errors;
      !this.$v.editAccount.accountCurrency.required && errors.push('Account Currency is required');
      return errors;
    }
  },
  methods: {
    UpdateEditedAccount: function UpdateEditedAccount($v) {
      $v.$touch(); //Triggers Error Messages

      if ($v.accountName.$invalid || $v.accountCurrency.$invalid) {
        return;
      }

      this.editAccount.objectState = "Update";

      this.$store.commit('updateAccountinStore', this.editAccount);

      this.$router.push({ path: '/dashboard/account' });
    },
    EditAccount: function EditAccount(item) {

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === parseInt(item)) {
          var editEntry = JSON.parse(JSON.stringify(this.items[i]));
          this.editAccount = editEntry;
          break;
        }
      }
    },
    removeDeletedAccountsFromItems: function removeDeletedAccountsFromItems() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].objectState === 'Delete') {
          this.items.splice(i, 1);
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.items = this.$store.state.Accounts;

    ///Remove deleted items from items array
    this.removeDeletedAccountsFromItems();

    this.curriences = this.$store.state.Currencies;

    this.EditAccount(this.$route.params.itemId);
  },

  validations: {
    editAccount: {
      accountName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      accountType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      //accountDescription: {
      //  required
      //},
      accountCurrency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }

});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__javascript_incomeManager__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reuseable_viewListItem_listItem_vue__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    'ListItem': __WEBPACK_IMPORTED_MODULE_2__reuseable_viewListItem_listItem_vue__["a" /* default */]
  },
  props: ['drawer'],
  data: function data() {
    return {
      direction: 'left',
      speedDial: false,
      transition: 'slide-y-reverse-transition',
      moreOptions: false,
      search: '',
      viewSearch: false,
      viewFilter: false,
      account: [],
      category: [],
      OneTime: false,
      Recurring: false,
      type: 'OneTime',
      addModelIncomeDate: false,
      addModelGoesOff: false,
      sameIncome: false,
      addDialog: false,
      deleteDialog: false,
      deleteIncome: {
        id: 0,
        incomeName: '',
        account: '',
        incomeType: '',
        foreignCurrencyAmount: 0,
        incomeAmount: 0,
        currencyConversion: '',
        currency: '',
        incomeDate: '',
        incomeTime: '',
        comment: '',
        category: '',

        //Recurring
        repeat: 1,
        cycle: '',
        period: '',
        numberOfCycles: 1,
        goesOffFirst: '',

        //State of Current Object
        objectState: ''
      },
      items: [],
      itemsMinusDeleted: []
    };
  },

  methods: {
    DeleteIncomeAccept: function DeleteIncomeAccept() {
      this.deleteDialog = false;

      this.deleteIncome.objectState = "Delete";

      ///Remove item from items array
      this.removeDeletedIncomesFromItems();

      __WEBPACK_IMPORTED_MODULE_1__javascript_incomeManager__["a" /* incomeManager */].rollbackTransactionFromIncome(this.deleteIncome);

      this.$store.commit('markIncomeAsDeleted', this.deleteIncome);
    },
    DeleteIncome: function DeleteIncome(item) {

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === item) {
          this.deleteIncome = this.items[i];
          break;
        }
      }

      this.deleteDialog = true;
    },
    removeDeletedIncomesFromItems: function removeDeletedIncomesFromItems() {
      this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items));

      for (var i = 0; i < this.itemsMinusDeleted.length; i++) {
        if (this.itemsMinusDeleted[i].objectState === 'Delete') {
          this.itemsMinusDeleted.splice(i, 1);
        }
      }
    },
    redirectToEditPage: function redirectToEditPage(item) {
      this.$router.push({ path: '/dashboard/editincome/' + item });
    },
    getSearchItems: function getSearchItems() {
      //Check if Search is empty
      if (this.search === '') {
        this.getitemsFromStoreAndRemoveDeletedItems();
        return;
      }

      //Clear Items
      this.items = [];

      //Add Expenses that contain search criteria
      for (var i = 0; i < this.itemsMinusDeleted.length; i++) {
        if (this.itemsMinusDeleted[i].expenseName.indexOf(this.search) !== -1) {
          this.items.push(this.itemsMinusDeleted[i]);
        }
      }
    },
    getitemsFromStoreAndRemoveDeletedItems: function getitemsFromStoreAndRemoveDeletedItems() {
      this.items = JSON.parse(JSON.stringify(this.$store.state.Incomes));

      ///Remove deleted items from items array
      this.removeDeletedIncomesFromItems();
    }
  },
  beforeMount: function beforeMount() {
    this.getitemsFromStoreAndRemoveDeletedItems();

    var cat = this.$store.state.Categories;
    for (var i = 0; i < cat.length; i++) {
      this.category.push(cat[i].categoryName);
    }

    var acc = this.$store.state.Accounts;
    for (var _i = 0; _i < acc.length; _i++) {
      this.account.push(acc[_i].accountName);
    }
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__javascript_incomeManager__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_reuseable_currencyConverter_currencyConverter_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_reuseable_moneyCalculator_MoneyCalculator_vue__ = __webpack_require__(337);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    'CurrencyConverter': __WEBPACK_IMPORTED_MODULE_5__components_reuseable_currencyConverter_currencyConverter_vue__["a" /* default */],
    'MoneyCalculator': __WEBPACK_IMPORTED_MODULE_6__components_reuseable_moneyCalculator_MoneyCalculator_vue__["a" /* default */]
  },
  props: ['drawer'],
  data: function data() {
    return {
      account: [],
      category: ["cat"],
      curriencies: ["USD", "JMD"],
      OneTime: false,
      Recurring: false,
      calculator: true,
      type: 'OneTime',
      conversion: false,
      recurringIncome: false,
      addModelIncomeDate: false,
      addModelGoesOff: false,
      timemenuvisibilty: false,
      sameIncome: false,
      currentIncome: {
        id: 0,
        incomeName: '',
        account: '',
        incomeType: '',
        foreignCurrencyAmount: 0,
        incomeAmount: 0,
        currencyConversion: {},
        currency: '',
        incomeDate: '',
        incomeTime: '',
        comment: '',
        category: '',

        //Recurring
        repeat: 1,
        cycle: '',
        period: '',
        numberOfCycles: 1,
        goesOffFirst: '',

        //State of Current Object
        objectState: 'New',
        show: false
      },
      items: []
    };
  },

  computed: {
    incomeNameErrors: function incomeNameErrors() {
      var errors = [];
      if (!this.$v.currentIncome.incomeName.$dirty) return errors;
      this.sameIncome && errors.push('A Income already has this Name. Enter a new Name of update Income');
      !this.$v.currentIncome.incomeName.required && errors.push('Income Name is required');
      return errors;
    },
    accountErrors: function accountErrors() {
      var errors = [];
      if (!this.$v.currentIncome.account.$dirty) return errors;
      !this.$v.currentIncome.account.required && errors.push('Account is required');
      return errors;
    },
    currencyErrors: function currencyErrors() {
      var errors = [];
      if (!this.$v.currentIncome.currency.$dirty) return errors;
      !this.$v.currentIncome.currency.required && errors.push('Currency is required');
      return errors;
    },
    currencyConversionErrors: function currencyConversionErrors() {
      var errors = [];
      if (!this.$v.currentIncome.currencyConversion.$dirty) return errors;
      !this.$v.currentIncome.currencyConversion.required && errors.push('Currency Conversion is required');
      return errors;
    },
    categoryErrors: function categoryErrors() {
      var errors = [];
      if (!this.$v.currentIncome.category.$dirty) return errors;
      !this.$v.currentIncome.category.required && errors.push('Category is required');
      return errors;
    },
    foreignCurrencyAmountErrors: function foreignCurrencyAmountErrors() {
      var errors = [];
      if (!this.$v.currentIncome.foreignCurrencyAmount.$dirty && !this.$v.currentIncome.foreignCurrencyAmount.$dirty) return errors;
      !this.$v.currentIncome.foreignCurrencyAmount.minValue && !this.$v.currentIncome.foreignCurrencyAmount.minValue && errors.push('Amount must be at least 1');
      return errors;
    },
    incomeAmountErrors: function incomeAmountErrors() {
      var errors = [];
      if (!this.$v.currentIncome.incomeAmount.$dirty && !this.$v.currentIncome.incomeAmount.$dirty) return errors;
      !this.$v.currentIncome.incomeAmount.minValue && !this.$v.currentIncome.incomeAmount.minValue && errors.push('Income Amount must be at least 1');
      return errors;
    },
    incomeDateErrors: function incomeDateErrors() {
      var errors = [];
      if (!this.$v.currentIncome.incomeDate.$dirty) return errors;
      !this.$v.currentIncome.incomeDate && errors.push('Income Date is required');
      return errors;
    }
  },
  methods: {
    adjustCurrency: function adjustCurrency() {
      if (this.currentIncome.account !== '') {
        var acc = __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__["a" /* accountManager */].getAccountByName(this.currentIncome.account);

        if (this.currentIncome.currency === '') {
          this.currentIncome.currency = acc.accountCurrency;
        } else if (this.currentIncome.currency !== acc.accountCurrency) {
          this.conversion = true;
        } else if (this.currentIncome.currency === acc.accountCurrency) {
          this.conversion = false;
        }
      }
    },
    getCurrencyConvertionRate: function getCurrencyConvertionRate() {
      this.$refs.converter.showConverter();

      var acc = __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__["a" /* accountManager */].getAccountByName(this.currentIncome.account);

      this.$refs.converter.getcurrencyData(this.currentIncome.currency, acc.accountCurrency);
    },
    setCurrencyConversionRate: function setCurrencyConversionRate(data) {
      this.currentIncome.currencyConversion = data;
    },
    updateDateAndTime: function updateDateAndTime() {
      this.currentIncome.incomeDate = __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getCurrentDateForPicker();
      this.currentIncome.incomeTime = __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getCurrentTimeForPicker();
    },
    incomeCheck: function incomeCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.currentIncome.incomeAmount <= 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.currentIncome.incomeAmount) || this.currentIncome.incomeAmount === "") {
        this.currentIncome.incomeAmount = 0;
      }

      if ($v.incomeName.$invalid || $v.category.$invalid || $v.account.$invalid) {
        return false;
      }

      if (this.recurringIncome) {
        this.currentIncome.incomeType = "Recurring";
      } else if (!this.recurringIncome) {
        this.currentIncome.incomeType = "OneTime";
      }

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].incomeName.toLowerCase() === this.currentIncome.incomeName.toLowerCase()) {
          this.sameIncome = true;
          return false;
        }
        if (i === this.items.length - 1) {
          this.sameIncome = false;
        }
      }

      return true;
    },
    addIncomeCheck: function addIncomeCheck($v) {
      if (this.incomeCheck($v)) {
        this.addIncome();
      }
    },
    addIncome: function addIncome() {
      __WEBPACK_IMPORTED_MODULE_4__javascript_incomeManager__["a" /* incomeManager */].addIncome(this.currentIncome);

      this.createTransactionIfNeeded();

      this.$router.push({ path: '/dashboard/income' });
    },
    createTransactionIfNeeded: function createTransactionIfNeeded() {
      if (this.checkIfTransactionIsNeeded) {
        __WEBPACK_IMPORTED_MODULE_4__javascript_incomeManager__["a" /* incomeManager */].createTransactionFromIncome(this.currentIncome);
      }
    },
    checkIfTransactionIsNeeded: function checkIfTransactionIsNeeded() {
      var today = new Date();
      var incomeTime = new Date(this.currentIncome.incomeDate);

      if (today.getTime() === incomeTime.getTime()) {
        return true;
      }

      return false;
    },
    calculateConvertedAmount: function calculateConvertedAmount() {
      if (this.currentIncome.foreignCurrencyAmount !== 0 && this.currentIncome.foreignCurrencyAmount !== '' && this.currentIncome.currencyConversion.conversionRate !== '') {
        this.currentIncome.incomeAmount = parseFloat(this.currentIncome.foreignCurrencyAmount) * parseFloat(this.currentIncome.currencyConversion.conversionRate);
      } else {
        this.currentIncome.incomeAmount = 0;
      }
    }
  },
  watch: {
    "currentIncome.currencyConversion": function currentIncomeCurrencyConversion() {
      this.calculateConvertedAmount();
    }
  },
  beforeMount: function beforeMount() {
    this.items = this.$store.state.Incomes;

    var cat = this.$store.state.Categories;
    for (var i = 0; i < cat.length; i++) {
      this.category.push(cat[i].categoryName);
    }

    var acc = this.$store.state.Accounts;
    for (var _i = 0; _i < acc.length; _i++) {
      this.account.push(acc[_i].accountName);
    }

    this.updateDateAndTime();
  },

  validations: {
    currentIncome: {
      incomeName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currencyConversion: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      foreignCurrencyAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      incomeAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      incomeDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      dialog: false,
      menu1: '',
      newConversion: false,
      listConversion: true,
      currencies: ["JMD", "USD"],
      currentConversion: {
        convertFrom: '',
        convertTo: '',
        conversionRate: '',
        date: ''
      },
      conversions: [],
      items: []
    };
  },

  computed: {
    covertFromErrors: function covertFromErrors() {
      var errors = [];
      if (!this.$v.currentConversion.convertFrom.$dirty) return errors;
      !this.$v.currentConversion.convertFrom.required && errors.push('Convert From is required');
      return errors;
    },
    convertToErrors: function convertToErrors() {
      var errors = [];
      if (!this.$v.currentConversion.convertTo.$dirty) return errors;
      !this.$v.currentConversion.convertTo.required && errors.push('Convert To is required');
      return errors;
    },
    conversionRateErrors: function conversionRateErrors() {
      var errors = [];
      if (!this.$v.currentConversion.conversionRate.$dirty) return errors;
      !this.$v.currentConversion.conversionRate.required && errors.push('Convert To is required');
      return errors;
    }
  },
  methods: {
    showConverter: function showConverter() {
      this.dialog = true;
    },
    createNewConversion: function createNewConversion() {
      this.newConversion = true;
      this.listConversion = false;
    },
    conversionCheck: function conversionCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if ($v.convertFrom.$invalid || $v.convertTo.$invalid || $v.conversionRate.$invalid) {
        return false;
      }

      return true;
    },
    checkNewConversion: function checkNewConversion($v) {
      if (this.conversionCheck($v)) {
        this.addConversion($v);
      }
    },
    addConversion: function addConversion($v) {
      var newEntry = JSON.parse(JSON.stringify(this.currentConversion));

      newEntry.id = this.getLargestIdFromConversions() + 1;

      this.$store.commit('addNewCurrencyConversionToStore', newEntry);

      this.clearNewConversionAndReset($v);
      this.returnSelectedConversion(newEntry);
    },
    clearNewConversionAndReset: function clearNewConversionAndReset($v) {
      this.currentConversion.convertFrom = '';
      this.currentConversion.convertTo = '';
      this.currentConversion.conversionRate = '';
      this.currentConversion.date = '';

      $v.$reset();

      this.closeNewConversionWindow();
    },
    closeNewConversionWindow: function closeNewConversionWindow() {
      this.newConversion = false;
      this.listConversion = true;
    },
    getLargestIdFromConversions: function getLargestIdFromConversions() {
      var largest = 0;
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id > largest) {
          largest = this.items[i].id;
        }
      }
      return largest;
    },
    getcurrencyData: function getcurrencyData(from, to) {
      this.currentConversion.convertFrom = from;
      this.currentConversion.convertTo = to;

      this.showDataForCurrencies(from, to);
    },
    showDataForCurrencies: function showDataForCurrencies(from, to) {
      this.getCurrencyConversions();

      this.conversions = [];

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].convertFrom === from && this.items[i].convertTo === to) {
          this.conversions.push(this.items[i]);
        }
      }
    },
    getCurrencyConversions: function getCurrencyConversions() {
      this.items = this.$store.state.CurrencyConversions;
    },
    returnSelectedConversion: function returnSelectedConversion(item) {
      this.$emit('conversionRate', item);
      this.dialog = false;
    }
  },
  validations: {
    currentConversion: {
      convertFrom: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      convertTo: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      conversionRate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }

});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      topDisplay: '',
      bottomDisplay: 0,
      topDisplayReset: false,
      bottomDisplayReset: false
    };
  },

  methods: {
    updateBottomDisplay: function updateBottomDisplay(num) {
      if (this.bottomDisplay === 0 || this.bottomDisplayReset) {
        this.bottomDisplay = '';
      }
      this.bottomDisplayReset = false;

      this.bottomDisplay += num;
    },
    updateTopDisplay: function updateTopDisplay(num) {
      if (this.topDisplay === 0 || this.topDisplayReset) {
        this.topDisplay = '';
      }
      this.topDisplayReset = false;

      this.adjustTopDisplay();

      this.topDisplay += num;
      this.topDisplay += ' ';
      this.bottomDisplayReset = true;
    },
    adjustTopDisplay: function adjustTopDisplay() {
      this.topDisplay += this.bottomDisplay;
      this.topDisplay += ' ';
    },
    evaluateCalculation: function evaluateCalculation() {
      if (!this.topDisplayReset) {
        this.adjustTopDisplay();

        this.bottomDisplay = eval(this.topDisplay);

        this.topDisplayReset = true;
        this.bottomDisplayReset = true;
      }
    }
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__javascript_incomeManager__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_reuseable_currencyConverter_currencyConverter_vue__ = __webpack_require__(59);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    'CurrencyConverter': __WEBPACK_IMPORTED_MODULE_5__components_reuseable_currencyConverter_currencyConverter_vue__["a" /* default */]
  },
  props: ['drawer'],
  data: function data() {
    return {
      account: [],
      category: ["cat"],
      curriencies: ["USD", "JMD"],
      editModelIncomeDate: false,
      editModelGoesOff: false,
      sameIncome: false,
      conversion: false,
      recurringIncome: false,
      timemenuvisibilty: false,
      editIncome: {
        id: 0,
        incomeName: '',
        account: '',
        incomeType: '',
        foreignCurrencyAmount: 0,
        incomeAmount: 0,
        currencyConversion: {},
        currency: '',
        incomeDate: '',
        incomeTime: '',
        comment: '',
        category: '',

        //Recurring
        repeat: 1,
        cycle: '',
        period: '',
        numberOfCycles: 1,
        goesOffFirst: '',

        //State of Current Object
        objectState: 'New'
      },
      items: []
    };
  },

  computed: {
    incomeNameErrors: function incomeNameErrors() {
      var errors = [];
      if (!this.$v.editIncome.incomeName.$dirty && !this.$v.editIncome.incomeName.$dirty) return errors;
      this.sameIncome && errors.push('A Income already has this Name. Enter a new Name of update Income');
      !this.$v.editIncome.incomeName.required && !this.$v.editIncome.incomeName.required && errors.push('Income Name is required');
      return errors;
    },
    accountErrors: function accountErrors() {
      var errors = [];
      if (!this.$v.editIncome.account.$dirty && !this.$v.editIncome.account.$dirty) return errors;
      !this.$v.editIncome.account.required && !this.$v.editIncome.account.required && errors.push('Account is required');
      return errors;
    },
    currencyErrors: function currencyErrors() {
      var errors = [];
      if (!this.$v.editIncome.currency.$dirty) return errors;
      !this.$v.editIncome.currency.required && errors.push('Currency is required');
      return errors;
    },
    currencyConversionErrors: function currencyConversionErrors() {
      var errors = [];
      if (!this.$v.editIncome.currencyConversion.$dirty) return errors;
      !this.$v.editIncome.currencyConversion.required && errors.push('Currency Conversion is required');
      return errors;
    },
    categoryErrors: function categoryErrors() {
      var errors = [];
      if (!this.$v.editIncome.category.$dirty && !this.$v.editIncome.category.$dirty) return errors;
      !this.$v.editIncome.category.required && !this.$v.editIncome.category.required && errors.push('Category is required');
      return errors;
    },
    foreignCurrencyAmountErrors: function foreignCurrencyAmountErrors() {
      var errors = [];
      if (!this.$v.editIncome.foreignCurrencyAmount.$dirty && !this.$v.editIncome.foreignCurrencyAmount.$dirty) return errors;
      !this.$v.editIncome.foreignCurrencyAmount.minValue && !this.$v.editIncome.foreignCurrencyAmount.minValue && errors.push('Amount must be at least 1');
      return errors;
    },
    incomeAmountErrors: function incomeAmountErrors() {
      var errors = [];
      if (!this.$v.editIncome.incomeAmount.$dirty && !this.$v.editIncome.incomeAmount.$dirty) return errors;
      !this.$v.editIncome.incomeAmount.minValue && !this.$v.editIncome.incomeAmount.minValue && errors.push('Income Amount must be at least 1');
      return errors;
    },
    incomeDateErrors: function incomeDateErrors() {
      var errors = [];
      if (!this.$v.editIncome.incomeDate.$dirty) return errors;
      !this.$v.editIncome.incomeDate && errors.push('Income Date is required');
      return errors;
    }
  },
  methods: {
    adjustCurrency: function adjustCurrency() {
      if (this.editIncome.account !== '') {
        var acc = __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__["a" /* accountManager */].getAccountByName(this.editIncome.account);

        if (this.editIncome.currency === '') {
          this.editIncome.currency = acc.accountCurrency;
        } else if (this.editIncome.currency !== acc.accountCurrency) {
          this.conversion = true;
        } else if (this.editIncome.currency === acc.accountCurrency) {
          this.conversion = false;
        }
      }
    },
    getCurrencyConvertionRate: function getCurrencyConvertionRate() {
      this.$refs.converter.showConverter();

      var acc = __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__["a" /* accountManager */].getAccountByName(this.editIncome.account);

      this.$refs.converter.getcurrencyData(this.editIncome.currency, acc.accountCurrency);
    },
    setCurrencyConversionRate: function setCurrencyConversionRate(data) {
      this.editIncome.currencyConversion = data;
    },
    incomeCheck: function incomeCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.editIncome.incomeAmount <= 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.editIncome.incomeAmount) || this.editIncome.incomeAmount === "") {
        this.editIncome.incomeAmount = 0;
      }

      if ($v.incomeName.$invalid || $v.category.$invalid || $v.account.$invalid) {
        return false;
      }

      if (this.recurringIncome) {
        this.editIncome.incomeType = "Recurring";
      } else if (!this.recurringIncome) {
        this.editIncome.incomeType = "OneTime";
      }

      //for (let i = 0; i < this.items.length; i++) {
      //  if (this.items[i].incomeName.toLowerCase() === this.editIncome.incomeName.toLowerCase()) {
      //    this.sameIncome = true
      //    return false
      //  }
      //  if (i === this.items.length - 1) {
      //    this.sameIncome = false
      //  }
      //}

      return true;
    },
    updateEditedIncome: function updateEditedIncome($v) {
      if (this.incomeCheck($v)) {

        this.editIncome.objectState = "Update";

        this.$store.commit('updateIncomeinStore', this.editIncome);

        __WEBPACK_IMPORTED_MODULE_4__javascript_incomeManager__["a" /* incomeManager */].updateTransactionFromIncome(this.editIncome);

        this.$router.push({ path: '/dashboard/income' });
      }
    },
    editIncomeSetter: function editIncomeSetter(item) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === parseInt(item)) {
          var editEntry = JSON.parse(JSON.stringify(this.items[i]));
          this.editIncome = editEntry;
          break;
        }
      }
    },
    setRecurrringSwitch: function setRecurrringSwitch() {
      if (this.editIncome.incomeType === 'Recurring') {
        this.recurringIncome = true;
      } else {
        this.recurringIncome = false;
      }
    },
    calculateConvertedAmount: function calculateConvertedAmount() {
      if (this.editIncome.foreignCurrencyAmount !== 0 && this.editIncome.foreignCurrencyAmount !== '' && this.editIncome.currencyConversion.conversionRate.conversionRate !== '') {
        this.editIncome.incomeAmount = parseFloat(this.editIncome.foreignCurrencyAmount) * parseFloat(this.editIncome.currencyConversion.conversionRate.conversionRate);
      } else {
        this.editIncome.incomeAmount = 0;
      }
    }
  },
  watch: {
    "editIncome.currencyConversion": function editIncomeCurrencyConversion() {
      this.calculateConvertedAmount();
    }
  },
  beforeMount: function beforeMount() {
    this.items = this.$store.state.Incomes;

    var cat = this.$store.state.Categories;
    for (var i = 0; i < cat.length; i++) {
      this.category.push(cat[i].categoryName);
    }

    var acc = this.$store.state.Accounts;
    for (var _i = 0; _i < acc.length; _i++) {
      this.account.push(acc[_i].accountName);
    }

    this.editIncomeSetter(this.$route.params.itemId);
    this.setRecurrringSwitch();
    this.adjustCurrency();
  },

  validations: {
    editIncome: {
      incomeName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currencyConversion: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      foreignCurrencyAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      incomeAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      incomeDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }

});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__javascript_transactionManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reuseable_viewListItem_listItem_vue__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    'ListItem': __WEBPACK_IMPORTED_MODULE_2__reuseable_viewListItem_listItem_vue__["a" /* default */]
  },
  props: ['drawer'],
  data: function data() {
    return {
      direction: 'left',
      speedDial: false,
      transition: 'slide-y-reverse-transition',
      moreOptions: false,
      search: '',
      viewSearch: false,
      viewFilter: false,
      deleteDialog: false,
      deleteExpense: {
        id: 0,
        expenseName: '',
        account: '',
        budget: 'None',
        expenseType: '',
        foreignCurrencyAmount: 0,
        expenseAmount: 0,
        currencyConversion: '',
        currency: '',
        expenseDate: '',
        expenseTime: '',
        comment: '',
        category: '',

        items: [],

        //Recurring
        repeat: 1,
        cycle: '',
        period: '',
        numberOfCycles: 1,
        goesOffFirst: '',

        //State of Current Object
        objectState: '',
        show: false
      },
      items: [],
      itemsMinusDeleted: []
    };
  },

  methods: {
    DeleteExpenseAccept: function DeleteExpenseAccept() {
      this.deleteDialog = false;

      this.deleteExpense.objectState = "Delete";

      ///Remove item from items array
      this.removeDeletedExpensesFromItems();

      __WEBPACK_IMPORTED_MODULE_1__javascript_transactionManager__["a" /* transactionManager */].rollbackTransactionFromExpense(this.deleteExpense);

      this.$store.commit('markExpenseAsDeleted', this.deleteExpense);
    },
    DeleteExpense: function DeleteExpense(item) {

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === item) {
          this.deleteExpense = this.items[i];
          break;
        }
      }

      this.deleteDialog = true;
    },
    removeDeletedExpensesFromItems: function removeDeletedExpensesFromItems() {
      this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items));

      for (var i = 0; i < this.itemsMinusDeleted.length; i++) {
        if (this.itemsMinusDeleted[i].objectState === 'Delete') {
          this.itemsMinusDeleted.splice(i, 1);
        }
      }
    },
    redirectToEditPage: function redirectToEditPage(item) {
      this.$router.push({ path: '/dashboard/editexpense/' + item });
    },
    getSearchItems: function getSearchItems() {
      //Check if Search is empty
      if (this.search === '') {
        this.getitemsFromStoreAndRemoveDeletedItems();
        return;
      }

      //Clear Items
      this.items = [];

      //Add Expenses that contain search criteria
      for (var i = 0; i < this.itemsMinusDeleted.length; i++) {
        if (this.itemsMinusDeleted[i].expenseName.indexOf(this.search) !== -1) {
          this.items.push(this.itemsMinusDeleted[i]);
        }
      }
    },
    getitemsFromStoreAndRemoveDeletedItems: function getitemsFromStoreAndRemoveDeletedItems() {
      this.items = JSON.parse(JSON.stringify(this.$store.state.Expenses));

      ///Remove deleted items from items array
      this.removeDeletedExpensesFromItems();
    }
  },
  beforeMount: function beforeMount() {

    this.getitemsFromStoreAndRemoveDeletedItems();

    //let cat = this.$store.state.Categories
    //for (let i = 0; i < cat.length; i++) {
    //  this.category.push(cat[i].categoryName)
    //}

    //let acc = this.$store.state.Accounts
    //for (let i = 0; i < acc.length; i++) {
    //  this.account.push(acc[i].accountName)
    //}
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__javascript_expenseManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_reuseable_items_Items_vue__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_reuseable_currencyConverter_currencyConverter_vue__ = __webpack_require__(59);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    'CurrencyConverter': __WEBPACK_IMPORTED_MODULE_6__components_reuseable_currencyConverter_currencyConverter_vue__["a" /* default */],
    'Items': __WEBPACK_IMPORTED_MODULE_5__components_reuseable_items_Items_vue__["a" /* default */]
  },
  props: ['drawer'],
  data: function data() {
    return {
      error: false,
      errorMessage: '',
      account: [],
      budget: ["None"],
      category: ["cat"],
      curriencies: ["USD", "JMD"],
      OneTime: false,
      Recurring: false,
      type: 'OneTime',
      //addItem: false,
      //expenseItemheaders: [
      //  { text: 'Item', align: 'left', value: 'itemName' },
      //  { text: 'Price', align: 'left', value: 'itemPrice' }
      //],
      //expenseItems: [],
      //expenseItemsNames: ['Cat', 'Dog'],
      //expenseItemsSearch: '',
      conversion: false,
      recurringExpense: false,
      sameExpense: false,
      addModelExpenseDate: false,
      addModelGoesOff: false,
      timemenuvisibilty: false,
      conversions: [],
      //expenseItemTemp: {
      //  itemName: [],
      //  itemPrice: '',
      //  itemCurrency: '',
      //  isTaxed: false,
      //  taxedPrice: '',

      //  dateChanged: ''
      //},
      currentExpense: {
        id: 0,
        expenseName: '',
        account: '',
        budget: 'None',
        expenseType: '',
        foreignCurrencyAmount: 0,
        expenseAmount: 0,
        currencyConversion: {},
        currency: '',
        expenseDate: '',
        expenseTime: '',
        comment: '',
        category: '',

        items: [],

        //Recurring
        repeat: 1,
        cycle: '',
        period: 'Forever',
        numberOfCycles: 1,
        goesOffFirst: '',

        //State of Current Object
        objectState: 'New',
        show: false
      },
      items: []
    };
  },

  computed: {
    expenseNameErrors: function expenseNameErrors() {
      var errors = [];
      if (!this.$v.currentExpense.expenseName.$dirty) return errors;
      this.sameExpense && errors.push('A Expense already has this Name. Enter a new Name of update Expense');
      !this.$v.currentExpense.expenseName.required && errors.push('Expense Name is required');
      return errors;
    },
    accountErrors: function accountErrors() {
      var errors = [];
      if (!this.$v.currentExpense.account.$dirty) return errors;
      !this.$v.currentExpense.account.required && errors.push('Account is required');
      return errors;
    },
    currencyErrors: function currencyErrors() {
      var errors = [];
      if (!this.$v.currentExpense.currency.$dirty) return errors;
      !this.$v.currentExpense.currency.required && errors.push('Currency is required');
      return errors;
    },
    currencyConversionErrors: function currencyConversionErrors() {
      var errors = [];
      if (!this.$v.currentExpense.currencyConversion.$dirty) return errors;
      !this.$v.currentExpense.currencyConversion.required && errors.push('Currency Conversion is required');
      return errors;
    },
    budgetErrors: function budgetErrors() {
      var errors = [];
      if (!this.$v.currentExpense.budget.$dirty) return errors;
      !this.$v.currentExpense.budget.required && errors.push('Budget is required');
      return errors;
    },
    categoryErrors: function categoryErrors() {
      var errors = [];
      if (!this.$v.currentExpense.category.$dirty) return errors;
      !this.$v.currentExpense.category.required && errors.push('Category is required');
      return errors;
    },
    foreignCurrencyAmountErrors: function foreignCurrencyAmountErrors() {
      var errors = [];
      if (!this.$v.currentExpense.foreignCurrencyAmount.$dirty && !this.$v.currentExpense.foreignCurrencyAmount.$dirty) return errors;
      !this.$v.currentExpense.foreignCurrencyAmount.minValue && !this.$v.currentExpense.foreignCurrencyAmount.minValue && errors.push('Amount must be at least 1');
      return errors;
    },
    expenseAmountErrors: function expenseAmountErrors() {
      var errors = [];
      if (!this.$v.currentExpense.expenseAmount.$dirty) return errors;
      !this.$v.currentExpense.expenseAmount.minValue && errors.push('Expense Amount must be at least 1');
      return errors;
    },
    expenseDateErrors: function expenseDateErrors() {
      var errors = [];
      if (!this.$v.currentExpense.expenseDate.$dirty) return errors;
      !this.$v.currentExpense.expenseDate && errors.push('Expense Date is required');
      return errors;
    }
  },
  methods: {
    adjustCurrency: function adjustCurrency() {
      if (this.currentExpense.account !== '') {
        var acc = __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__["a" /* accountManager */].getAccountByName(this.currentExpense.account);

        if (this.currentExpense.currency === '') {
          this.currentExpense.currency = acc.accountCurrency;
        } else if (this.currentExpense.currency !== acc.accountCurrency) {
          this.conversion = true;
        }
      }
    },
    getCurrencyConvertionRate: function getCurrencyConvertionRate() {
      this.$refs.converter.showConverter();

      var acc = __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__["a" /* accountManager */].getAccountByName(this.currentExpense.account);

      this.$refs.converter.getcurrencyData(this.currentExpense.currency, acc.accountCurrency);
    },
    setCurrencyConversionRate: function setCurrencyConversionRate(data) {
      this.currentExpense.currencyConversion = data;
    },
    updateDateAndTime: function updateDateAndTime() {
      this.currentExpense.expenseDate = __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getCurrentDateForPicker();
      this.currentExpense.expenseTime = __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getCurrentTimeForPicker();
    },
    expenseCheck: function expenseCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.currentExpense.expenseAmount <= 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.currentExpense.expenseAmount) || this.currentExpense.expenseAmount === "") {
        this.currentExpense.expenseAmount = 0;
      }

      if ($v.expenseName.$invalid || $v.category.$invalid || $v.account.$invalid) {
        return false;
      }

      if (!this.checkAmountIfGreaterThanAccountOrBudget()) {
        return false;
      }

      if (this.recurringExpense) {
        this.currentExpense.expenseType = "Recurring";
      } else if (!this.recurringExpense) {
        this.currentExpense.expenseType = "OneTime";
      }

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].expenseName.toLowerCase() === this.currentExpense.expenseName.toLowerCase() && this.items[i].objectState !== 'Delete') {
          this.sameExpense = true;
          return false;
        }
        if (i === this.items.length - 1) {
          this.sameExpense = false;
        }
      }

      return true;
    },
    addExpenseCheck: function addExpenseCheck($v) {
      if (this.expenseCheck($v)) {
        this.addExpense();
      }
    },
    addExpense: function addExpense() {
      __WEBPACK_IMPORTED_MODULE_4__javascript_expenseManager__["a" /* expenseManager */].addExpense(this.currentExpense);

      this.createTransactionIfNeeded();

      this.$router.push({ path: '/dashboard/expense' });
    },
    //getLargestIdFromItems: function () {
    //  let largest = 0
    //  for (let i = 0; i < this.items.length; i++) {
    //    if (this.items[i].id > largest) {
    //      largest = this.items[i].id
    //    }
    //  }
    //  return largest
    //},
    adjustAccountToMatchBudgetOnBudgetChange: function adjustAccountToMatchBudgetOnBudgetChange() {
      if (this.currentExpense.budget !== 'None') {
        var bud = this.$store.state.Budgets;
        for (var i = 0; i < bud.length; i++) {
          if (bud[i].budgetName === this.currentExpense.budget) {
            this.currentExpense.account = bud[i].account;
          }
        }
      }
    },
    clearBudgetOnAccountChange: function clearBudgetOnAccountChange() {
      this.currentExpense.budget = 'None';
    },
    checkAmountIfGreaterThanAccountOrBudget: function checkAmountIfGreaterThanAccountOrBudget() {
      var amount = this.getAmountForBudgetOrAccount();

      if (parseInt(this.currentExpense.expenseAmount) > parseInt(amount)) {

        //Show Error Message
        this.error = true;
        this.errorMessage = "Cannot Add An Expense Greater Than Account/ Budget Amount";

        return false;
      }
      return true;
    },
    getAmountForBudgetOrAccount: function getAmountForBudgetOrAccount() {
      if (this.currentExpense.budget === 'None') {
        return __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getAccountCurrentAmount(this.currentExpense.account, this.$store.state.Accounts);
      } else if (this.currentExpense.budget !== 'None') {
        return __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getBudgetCurrentAmount(this.currentExpense.budget, this.$store.state.Budgets);
      }
    },
    createTransactionIfNeeded: function createTransactionIfNeeded() {
      if (this.checkIfTransactionIsNeeded) {
        __WEBPACK_IMPORTED_MODULE_4__javascript_expenseManager__["a" /* expenseManager */].createTransactionFromExpense(this.currentExpense);
      }
    },
    checkIfTransactionIsNeeded: function checkIfTransactionIsNeeded() {
      var today = new Date();
      var expenseTime = new Date(this.currentExpense.expenseDate);

      if (today.getTime() === expenseTime.getTime()) {
        return true;
      }

      return false;
    },
    calculateConvertedAmount: function calculateConvertedAmount() {
      if (this.currentExpense.foreignCurrencyAmount !== 0 && this.currentExpense.foreignCurrencyAmount !== '' && this.currentExpense.currencyConversion.conversionRate !== '') {
        this.currentExpense.expenseAmount = parseFloat(this.currentExpense.foreignCurrencyAmount) * parseFloat(this.currentExpense.currencyConversion.conversionRate);
      } else {
        this.currentExpense.expenseAmount = 0;
      }
    },
    addItemToExpense: function addItemToExpense(item) {
      if (this.currentExpense.items.length === 0) {
        this.currentExpense.items.push(item);

        this.addItemPriceToExpenseAmount();
      } else {
        for (var i = 0; i < this.currentExpense.items.length; i++) {
          if (this.currentExpense.items[i].id === item.id) {

            this.updateExpenseAmount(this.currentExpense.items[i], item);
            this.currentExpense.items[i] = JSON.parse(JSON.stringify(item));
            break;
          }

          if (i === this.currentExpense.items.length - 1) {
            this.currentExpense.items.push(item);
            this.addItemPriceToExpenseAmount();
            break;
          }
        }
      }
    },

    updateExpenseAmount: function updateExpenseAmount(olditem, newitem) {
      this.currentExpense.expenseAmount = parseFloat(this.currentExpense.expenseAmount) - parseFloat(this.currencyConverter(olditem));

      this.currentExpense.expenseAmount = parseFloat(this.currentExpense.expenseAmount) + parseFloat(this.currencyConverter(newitem));
    },
    addItemPriceToExpenseAmount: function addItemPriceToExpenseAmount() {

      var total = 0;
      for (var i = 0; i < this.currentExpense.items.length; i++) {
        total = parseFloat(total) + parseFloat(this.currencyConverter(this.currentExpense.items[i]));
      }

      this.currentExpense.expenseAmount = total;
    },
    currencyConverter: function currencyConverter(item) {
      ////////////////////////////////////////////////////////////////////
      //Returns Price If Currencies Are The Same,
      //Returns Adjusted Price If Currency Is Different
      ////////////////////////////////////////////////////////////////////

      if (item.itemCurrency === this.currentExpense.currency || this.currentExpense.currency === "") {
        return item.itemPrice;
      } else {
        for (var i = 0; i < this.conversions.length; i++) {
          if (this.conversions.convertFrom === item.itemCurrency) {
            return parseFloat(this.conversions.conversionRate) * item.itemPrice;
          }
        }
      }
    }
  },
  watch: {
    "currentExpense.currencyConversion": function currentExpenseCurrencyConversion() {
      this.calculateConvertedAmount();
    }
  },
  beforeMount: function beforeMount() {

    this.items = this.$store.state.Expenses;

    var cat = this.$store.state.Categories;
    for (var i = 0; i < cat.length; i++) {
      this.category.push(cat[i].categoryName);
    }

    var acc = this.$store.state.Accounts;
    for (var _i = 0; _i < acc.length; _i++) {
      this.account.push(acc[_i].accountName);
    }

    var curCon = this.$store.state.CurrencyConversions;
    for (var _i2 = 0; _i2 < curCon.length; _i2++) {
      this.currencyConversions.push(curCon[_i2]);
    }

    var bud = this.$store.state.Budgets;
    for (var _i3 = 0; _i3 < bud.length; _i3++) {
      this.budget.push(bud[_i3].budgetName);
    }

    this.updateDateAndTime();
  },

  validations: {
    currentExpense: {
      expenseName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currencyConversion: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      budget: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      foreignCurrencyAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      expenseAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      expenseDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
    //expenseItemTemp: {
    //  itemName: {
    //    required
    //  },
    //  itemPrice: {
    //    required,
    //    minValue: minValue(1)
    //  },
    //  itemCurrency: {
    //    required
    //  }

    //}
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
var _methods;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  props: ["itype"],
  data: function data() {
    return {
      curriencies: ["USD", "JMD"],
      addItem: false,
      editItems: false,
      deleteDialog: false,
      Itemheaders: [{ text: 'Item', align: 'left', value: 'itemName' }, { text: 'Price', align: 'left', value: 'itemPrice' }],
      ItemsNames: ['Cat', 'Dog'],
      ItemsSearch: '',
      ItemTemp: {
        id: 0,
        itemName: '',
        itemPrice: '',
        itemCurrency: '',
        isTaxed: false,
        taxedPrice: '',

        dateChanged: '',

        objectState: 'New',
        show: false
      },
      editItemTemp: {
        id: 0,
        itemName: '',
        itemPrice: '',
        itemCurrency: '',
        isTaxed: false,
        taxedPrice: '',

        dateChanged: '',

        objectState: '',
        show: false
      },
      deleteItemTemp: {
        id: 0,
        itemName: '',
        itemPrice: '',
        itemCurrency: '',
        isTaxed: false,
        taxedPrice: '',

        dateChanged: '',

        objectState: '',
        show: false
      },
      items: [],
      storedItems: []
    };
  },

  computed: {
    ItemNameErrors: function ItemNameErrors() {
      var errors = [];
      if (!this.$v.ItemTemp.itemName.$dirty || !this.$v.editItemTemp.itemName.$dirty) return errors;
      !this.$v.ItemTemp.itemName.required && !this.$v.editItemTemp.itemName.required && errors.push('Item Name is required');
      return errors;
    },
    ItemPriceErrors: function ItemPriceErrors() {
      var errors = [];
      if (!this.$v.ItemTemp.itemPrice.$dirty || !this.$v.editItemTemp.itemPrice.$dirty) return errors;
      !this.$v.ItemTemp.itemPrice.minValue && !this.$v.editItemTemp.itemPrice.minValue && errors.push('Item Price must be at least 1');
      return errors;
    },
    ItemCurrencyErrors: function ItemCurrencyErrors() {
      var errors = [];
      if (!this.$v.ItemTemp.itemCurrency.$dirty || !this.$v.editItemTemp.itemCurrency.$dirty) return errors;
      !this.$v.ItemTemp.itemCurrency.required && !this.$v.editItemTemp.itemCurrency.required && errors.push('Currency is required');
      return errors;
    }
  },
  methods: (_methods = {
    itemCheck: function itemCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.ItemTemp.itemPrice < 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.ItemTemp.itemPrice) || this.ItemTemp.itemPrice === "") {
        this.ItemTemp.itemPrice = 0;
      }

      if ($v.itemName.$invalid || $v.itemPrice.$invalid || $v.itemCurrency.$invalid) {
        return false;
      }
      return true;
    },
    addItemCheck: function addItemCheck($v) {
      if (this.itemCheck($v)) {
        this.addItemToItems();

        $v.$reset();
      }
    },
    addItemToItems: function addItemToItems() {
      //Add Item to Transaction Items

      var newItem = JSON.parse(JSON.stringify(this.ItemTemp));

      newItem.id = this.getLargestIdFromItems() + 1;

      this.returnItem(newItem);
      this.items.push(newItem);

      this.addItem = false;

      this.doesItemExist();

      this.resetItemForm();
    },
    getLargestIdFromItems: function getLargestIdFromItems() {
      var largest = 0;
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id > largest) {
          largest = this.items[i].id;
        }
      }
      return largest;
    },

    resetItemForm: function resetItemForm() {
      this.ItemTemp.itemName = '';
      this.ItemTemp.itemPrice = 0;
      this.ItemTemp.itemCurrency = '';
      this.ItemTemp.isTaxed = false;
      this.ItemTemp.taxedPrice = 0;
    },
    doesItemExist: function doesItemExist() {
      if (this.items.length !== 0) {
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].itemName === this.ItemTemp.itemName) {

            /////////////////////////////////////////////////////////////
            //Check All other values to see if they are the same
            /////////////////////////////////////////////////////////////

            if (this.items[i].itemPrice !== this.ItemTemp.itemPrice) {

              ///////////////////////////////////////////////////////////////////
              //Create New Item To Represent Update,
              //Keep Old Data As To Not Cause Problems To Past Transactions
              ///////////////////////////////////////////////////////////////////

              this.addNewItem();
              return;
            }
          }
        }
      } else {
        this.addNewItem();
      }
    },
    addNewItem: function addNewItem() {
      this.ItemTemp.dateChanged = __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getCurrentDate();

      var newEntry = JSON.parse(JSON.stringify(this.ItemTemp));

      newEntry.id = this.getLargestIdFromItems() + 1;

      this.$store.commit('addNewItemToStore', newEntry);
    }
  }, _defineProperty(_methods, 'getLargestIdFromItems', function getLargestIdFromItems() {
    var largest = 0;
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].id > largest) {
        largest = this.items[i].id;
      }
    }
    return largest;
  }), _defineProperty(_methods, 'returnItem', function returnItem(item) {
    this.$emit('ItemToAdd', item);
  }), _defineProperty(_methods, 'editItem', function editItem(item) {
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].id === parseInt(item)) {
        var editEntry = JSON.parse(JSON.stringify(this.items[i]));
        this.editItemTemp = editEntry;
        break;
      }
    }

    this.editItems = true;
  }), _defineProperty(_methods, 'editItemCheck', function editItemCheck($v) {
    if (this.itemCheck($v)) {
      this.editItemTemp.objectState = "Update";

      this.$store.commit('updateIteminStore', this.editItemTemp);

      this.updateItemList();

      this.editItems = false;

      this.returnItem(this.editItemTemp);
    }
  }), _defineProperty(_methods, 'updateItemList', function updateItemList() {
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].id === this.editItemTemp.id) {
        this.items[i] = JSON.parse(JSON.stringify(this.editItemTemp));
      }
    }
  }), _defineProperty(_methods, 'deleteItem', function deleteItem(item) {
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i] === item) {
        this.deleteItemTemp = this.items[i];
        break;
      }
    }

    this.deleteDialog = true;
  }), _defineProperty(_methods, 'deleteItemAccept', function deleteItemAccept() {}), _methods),
  beforeMount: function beforeMount() {},

  validations: {
    ItemTemp: {
      itemName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      itemPrice: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      itemCurrency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }

    },
    editItemTemp: {
      itemName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      itemPrice: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      itemCurrency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }

    }
  }

});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__javascript_expenseManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_reuseable_currencyConverter_currencyConverter_vue__ = __webpack_require__(59);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    'CurrencyConverter': __WEBPACK_IMPORTED_MODULE_5__components_reuseable_currencyConverter_currencyConverter_vue__["a" /* default */]
  },
  props: ['drawer'],
  data: function data() {
    return {
      account: [],
      budget: ["None"],
      category: ["cat"],
      curriencies: ["USD", "JMD"],
      OneTime: false,
      Recurring: false,
      recurringExpense: false,
      timemenuvisibilty: false,
      editModelExpenseDate: false,
      editModelGoesOff: false,
      sameExpense: false,
      editExpense: {
        id: 0,
        expenseName: '',
        account: '',
        budget: 'None',
        expenseType: '',
        foreignCurrencyAmount: 0,
        expenseAmount: 0,
        currencyConversion: '',
        currency: '',
        expenseDate: '',
        expenseTime: '',
        comment: '',
        category: '',

        //Recurring
        repeat: 1,
        cycle: '',
        period: 'Forever',
        numberOfCycles: 1,
        goesOffFirst: '',

        //State of Current Object
        objectState: 'New'
      },
      items: []
    };
  },

  computed: {
    expenseNameErrors: function expenseNameErrors() {
      var errors = [];
      if (!this.$v.editExpense.expenseName.$dirty) return errors;
      this.sameExpense && errors.push('A Expense already has this Name. Enter a new Name of update Expense');
      !this.$v.editExpense.expenseName.required && errors.push('Expense Name is required');
      return errors;
    },
    accountErrors: function accountErrors() {
      var errors = [];
      if (!this.$v.editExpense.account.$dirty) return errors;
      !this.$v.editExpense.account.required && errors.push('Account is required');
      return errors;
    },
    currencyErrors: function currencyErrors() {
      var errors = [];
      if (!this.$v.editExpense.currency.$dirty) return errors;
      !this.$v.editExpense.currency.required && errors.push('Currency is required');
      return errors;
    },
    currencyConversionErrors: function currencyConversionErrors() {
      var errors = [];
      if (!this.$v.editExpense.currencyConversion.$dirty) return errors;
      !this.$v.editExpense.currencyConversion.required && errors.push('Currency Conversion is required');
      return errors;
    },
    budgetErrors: function budgetErrors() {
      var errors = [];
      if (!this.$v.editExpense.budget.$dirty) return errors;
      !this.$v.editExpense.budget.required && errors.push('Budget is required');
      return errors;
    },
    categoryErrors: function categoryErrors() {
      var errors = [];
      if (!this.$v.editExpense.category.$dirty) return errors;
      !this.$v.editExpense.category.required && errors.push('Category is required');
      return errors;
    },
    foreignCurrencyAmountErrors: function foreignCurrencyAmountErrors() {
      var errors = [];
      if (!this.$v.editExpense.foreignCurrencyAmount.$dirty && !this.$v.editExpense.foreignCurrencyAmount.$dirty) return errors;
      !this.$v.editExpense.foreignCurrencyAmount.minValue && !this.$v.editExpense.foreignCurrencyAmount.minValue && errors.push('Amount must be at least 1');
      return errors;
    },
    expenseAmountErrors: function expenseAmountErrors() {
      var errors = [];
      if (!this.$v.editExpense.expenseAmount.$dirty) return errors;
      !this.$v.editExpense.expenseAmount.minValue && errors.push('Expense Amount must be at least 1');
      return errors;
    },
    expenseDateErrors: function expenseDateErrors() {
      var errors = [];
      if (!this.$v.editExpense.expenseDate.$dirty) return errors;
      !this.$v.editExpense.expenseDate && errors.push('Expense Date is required');
      return errors;
    }
  },
  methods: {
    adjustCurrency: function adjustCurrency() {
      if (this.editExpense.account !== '') {
        var acc = __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__["a" /* accountManager */].getAccountByName(this.editExpense.account);

        if (this.editExpense.currency === '') {
          this.editExpense.currency = acc.accountCurrency;
        } else if (this.editExpense.currency !== acc.accountCurrency) {
          this.conversion = true;
        }
      }
    },
    getCurrencyConvertionRate: function getCurrencyConvertionRate() {
      this.$refs.converter.showConverter();

      var acc = __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__["a" /* accountManager */].getAccountByName(this.editExpense.account);

      this.$refs.converter.getcurrencyData(this.editExpense.currency, acc.accountCurrency);
    },
    setCurrencyConversionRate: function setCurrencyConversionRate(data) {
      this.editExpense.currencyConversion = data.conversionRate;
    },
    expenseCheck: function expenseCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.editExpense.expenseAmount <= 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.editExpense.expenseAmount) || this.editExpense.expenseAmount === "") {
        this.editExpense.expenseAmount = 0;
      }

      if ($v.expenseName.$invalid || $v.category.$invalid || $v.account.$invalid) {
        return false;
      }

      if (this.recurringExpense) {
        this.editExpense.expenseType = "Recurring";
      } else if (!this.recurringExpense) {
        this.editExpense.expenseType = "OneTime";
      }

      //for (let i = 0; i < this.items.length; i++) {
      //  if (this.items[i].expenseName.toLowerCase() === this.editExpense.expenseName.toLowerCase() && this.items[i].objectState !== 'Delete') {
      //    this.sameExpense = true
      //    return false
      //  }
      //  if (i === this.items.length - 1) {
      //    this.sameExpense = false
      //  }
      //}

      return true;
    },
    UpdateEditedExpense: function UpdateEditedExpense($v) {
      if (this.expenseCheck($v)) {

        this.editExpense.objectState = "Update";

        this.$store.commit('updateExpenseinStore', this.editExpense);

        __WEBPACK_IMPORTED_MODULE_4__javascript_expenseManager__["a" /* expenseManager */].updateTransactionFromExpense(this.editExpense);

        this.$router.push({ path: '/dashboard/expense' });
      }
    },
    EditExpense: function EditExpense(item) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === parseInt(item)) {
          var editEntry = JSON.parse(JSON.stringify(this.items[i]));
          this.editExpense = editEntry;
          break;
        }
      }
    },
    setRecurrringSwitch: function setRecurrringSwitch() {
      if (this.EditExpense.expenseType === 'Recurring') {
        this.recurringExpense = true;
      } else {
        this.recurringExpense = false;
      }
    },
    calculateConvertedAmount: function calculateConvertedAmount() {
      if (this.editExpense.foreignCurrencyAmount !== 0 && this.editExpense.foreignCurrencyAmount !== '' && this.editExpense.currencyConversion !== '') {
        this.editExpense.expenseAmount = parseFloat(this.editExpense.foreignCurrencyAmount) * parseFloat(this.editExpense.currencyConversion);
      } else {
        this.editExpense.expenseAmount = 0;
      }
    }
  },
  watch: {
    "editExpense.currencyConversion": function editExpenseCurrencyConversion() {
      this.calculateConvertedAmount();
    }
  },
  beforeMount: function beforeMount() {

    this.items = this.$store.state.Expenses;

    var cat = this.$store.state.Categories;
    for (var i = 0; i < cat.length; i++) {
      this.category.push(cat[i].categoryName);
    }

    var acc = this.$store.state.Accounts;
    for (var _i = 0; _i < acc.length; _i++) {
      this.account.push(acc[_i].accountName);
    }

    var bud = this.$store.state.Budgets;
    for (var _i2 = 0; _i2 < bud.length; _i2++) {
      this.budget.push(bud[_i2].budgetName);
    }

    this.EditExpense(this.$route.params.itemId);
    this.setRecurrringSwitch();
    this.adjustCurrency();
  },

  validations: {
    editExpense: {
      expenseName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currencyConversion: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      budget: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      foreignCurrencyAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      expenseAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      expenseDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }

});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reuseable_viewListItem_listItem_vue__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    'ListItem': __WEBPACK_IMPORTED_MODULE_2__reuseable_viewListItem_listItem_vue__["a" /* default */]
  },
  props: ['drawer'],
  data: function data() {
    return {
      direction: 'left',
      speedDial: false,
      transition: 'slide-y-reverse-transition',
      moreOptions: false,
      search: '',
      viewSearch: false,
      viewFilter: false,
      //rowsPerPageItems: [4, 8, 12],
      //pagination: {
      //  //rowsPerPage: 4
      //},
      account: [],
      category: ["cat1", "cat2", "cat3", "cat4"],
      type: ["None", "Weekly", "Monthly", "Yearly"],
      sameBudget: false,
      copyToRefill: true,
      //addDialog: false,
      //editDialog: false,
      deleteDialog: false,
      //addModelRefillDate: false,
      //editModelRefillDate: false,
      //currentBudget: {
      //  id: 0,
      //  budgetName: '',
      //  account: '',
      //  budgetType: '',
      //  budgetAmount: 0,
      //  amountSpent: 0,
      //  refillAmount: 0,
      //  //refillDate: '',
      //  comment: '',
      //  category: [],

      //  //Notification
      //  budgetOverspent: true,
      //  OverspendingRisk: true,

      //  //State of Current Object
      //  objectState: 'New'
      //},
      //editBudget: {
      //  id: 0,
      //  budgetName: '',
      //  account: '',
      //  budgetType: '',
      //  budgetAmount: 0,
      //  amountSpent: 0,
      //  refillAmount: 0,
      //  //refillDate: '',
      //  comment: '',
      //  category: '',

      //  //Notification
      //  budgetOverspent: true,
      //  OverspendingRisk: true,

      //  //State of Current Object
      //  objectState: ''
      //},
      deleteBudget: {
        id: 0,
        budgetName: '',
        account: '',
        budgetType: '',
        budgetAmount: 0,
        amountSpent: 0,
        refillAmount: 0,
        //refillDate: '',
        currency: '',
        comment: '',
        category: '',

        //Notification
        budgetOverspent: true,
        OverspendingRisk: true,

        //State of Current Object
        objectState: ''
      },
      items: [],
      itemsMinusDeleted: []
    };
  },

  computed: {
    //percentage: function () {
    //  return (spent, total) => {
    //    return (spent/total) * 100
    //  }
    //},
    //colorSelector: function () {
    //  return (val) => {
    //    if (val < 60) {
    //      return 'green'
    //    }
    //    else if (val >= 60 && val < 90) {
    //      return 'orange'
    //    }
    //    else if (val >= 90) {
    //      return 'red'
    //    }
    //  }
    //},
    pages: function pages() {
      if (this.pagination.rowsPerPage === null || this.pagination.totalItems === null) return 0;

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    }
  },
  methods: {
    //budgetCheck: function ($v) {
    //  $v.$touch(); //Triggers Error Messages

    //  if (this.currentBudget.budgetAmount <= 0 || !globalFunctions.isIntOrFloat(this.currentBudget.budgetAmount) || this.currentBudget.budgetAmount === "") { this.currentBudget.budgetAmount = 0 }

    //  if ($v.budgetName.$invalid || $v.account.$invalid) {
    //    return false
    //  }

    //  for (let i = 0; i < this.items.length; i++) {
    //    if (this.items[i].budgetName.toLowerCase() === this.currentBudget.budgetName.toLowerCase()) {
    //      this.sameBudget = true
    //      return false
    //    }
    //    if (i === this.items.length - 1) {
    //      this.sameBudget = false
    //    }
    //  }

    //  return true
    //},
    //AddBudgetCheck: function ($v) {
    //  if (this.budgetCheck($v)) {
    //    this.AddBudget($v);
    //  }
    //},
    //AddBudget: function ($v) {
    //  let newEntry = JSON.parse(JSON.stringify(this.currentBudget))

    //  this.addDialog = false

    //  newEntry.id = this.getLargestIdFromItems() + 1

    //  this.$store.commit('addNewBudgetToStore', newEntry)
    //  this.resetCurrentBudgetObject()

    //  $v.$reset() //Resets Validations
    //},
    //getLargestIdFromItems: function () {
    //  let largest = 0
    //  for (let i = 0; i < this.items.length; i++) {
    //    if (this.items[i].id > largest) {
    //      largest = this.items[i].id
    //    }
    //  }
    //  return largest
    //},
    UpdateEditedBudget: function UpdateEditedBudget($v) {
      if (this.budgetCheck($v)) {
        this.editDialog = false;

        this.editBudget.objectState = "Update";

        this.$store.commit('updateBudgetinStore', this.editBudget);
      }
    },
    EditBudget: function EditBudget(item) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === item) {
          var editEntry = JSON.parse(JSON.stringify(this.items[i]));
          this.editBudget = editEntry;
          break;
        }
      }

      this.editDialog = true;
      this.copyToRefill = false;
    },
    redirectToEditPage: function redirectToEditPage(item) {
      this.$router.push({ path: '/dashboard/editbudget/' + item });
    },
    DeleteBudgetAccept: function DeleteBudgetAccept() {
      this.deleteDialog = false;

      this.deleteBudget.objectState = "Delete";

      this.$store.commit('markBudgetAsDeleted', this.deleteBudget);
    },
    DeleteBudget: function DeleteBudget(item) {

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === item) {
          this.deleteBudget = this.items[i];
          break;
        }
      }

      this.deleteDialog = true;
    },
    resetCurrentBudgetObject: function resetCurrentBudgetObject() {
      this.currentBudget.budgetName = '';
      this.currentBudget.account = '';
      this.currentBudget.budgetType = '';
      this.currentBudget.budgetAmount = 0;
      this.currentBudget.amountSpent = 0;
      this.currentBudget.refillAmount = 0;
      this.currentBudget.category = [];
      this.currentBudget.comment = '';
      this.currentBudget.category = '';
      this.currentBudget.budgetOverspent = true;
      this.currentBudget.OverspendingRisk = true;
    },
    getitemsFromStoreAndRemoveDeletedItems: function getitemsFromStoreAndRemoveDeletedItems() {
      this.items = JSON.parse(JSON.stringify(this.$store.state.Budgets));

      ///Remove deleted items from items array
      this.removeDeletedBudgetsFromItems();
    },
    removeDeletedBudgetsFromItems: function removeDeletedBudgetsFromItems() {
      this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items));

      for (var i = 0; i < this.itemsMinusDeleted.length; i++) {
        if (this.itemsMinusDeleted[i].objectState === 'Delete') {
          this.itemsMinusDeleted.splice(i, 1);
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getitemsFromStoreAndRemoveDeletedItems();

    var cat = this.$store.state.Categories;
    for (var i = 0; i < cat.length; i++) {
      this.category.push(cat[i].categoryName);
    }

    var acc = this.$store.state.Accounts;
    for (var _i = 0; _i < acc.length; _i++) {
      this.account.push(acc[_i].accountName);
    }
  },

  validations: {
    currentBudget: {
      budgetName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      budgetType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      budgetAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      refillAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      refillDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    },
    editBudget: {
      budgetName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      budgetType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      budgetAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      refillAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      refillDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }

});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_accountManager__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reuseable_currencyConverter_currencyConverter_vue__ = __webpack_require__(59);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    'CurrencyConverter': __WEBPACK_IMPORTED_MODULE_4__components_reuseable_currencyConverter_currencyConverter_vue__["a" /* default */]
    //'MoneyCalculator': MoneyCalculator
  },
  props: ['drawer'],
  data: function data() {
    return {
      account: [],
      category: ["cat1", "cat2", "cat3", "cat4"],
      type: ["None", "Weekly", "Monthly", "Yearly"],
      curriencies: ["USD", "JMD"],
      sameBudget: false,
      copyToRefill: true,
      currentBudget: {
        id: 0,
        budgetName: '',
        account: '',
        budgetType: '',
        budgetAmount: 0,
        amountSpent: 0,
        refillAmount: 0,
        //refillDate: '',
        currency: '',
        comment: '',
        category: [],

        //Notification
        budgetOverspent: true,
        OverspendingRisk: true,

        //State of Current Object
        objectState: 'New',
        show: false
      },
      items: []
    };
  },

  computed: {
    percentage: function percentage() {
      return function (spent, total) {
        return spent / total * 100;
      };
    },
    colorSelector: function colorSelector() {
      return function (val) {
        if (val < 60) {
          return 'green';
        } else if (val >= 60 && val < 90) {
          return 'orange';
        } else if (val >= 90) {
          return 'red';
        }
      };
    },
    pages: function pages() {
      if (this.pagination.rowsPerPage === null || this.pagination.totalItems === null) return 0;

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },
    budgetNameErrors: function budgetNameErrors() {
      var errors = [];
      if (!this.$v.currentBudget.budgetName.$dirty) return errors;
      this.sameBudget && errors.push('A Budget already has this Name. Enter a new Name of update Budget');
      !this.$v.currentBudget.budgetName.required && errors.push('Budget Name is required');
      return errors;
    },
    accountErrors: function accountErrors() {
      var errors = [];
      if (!this.$v.currentBudget.account.$dirty) return errors;
      !this.$v.currentBudget.account.required && errors.push('Account is required');
      return errors;
    },
    budgetTypeErrors: function budgetTypeErrors() {
      var errors = [];
      if (!this.$v.currentBudget.budgetType.$dirty) return errors;
      !this.$v.currentBudget.budgetType.required && errors.push('Budget Type is required');
      return errors;
    },
    categoryErrors: function categoryErrors() {
      var errors = [];
      if (!this.$v.currentBudget.category.$dirty) return errors;
      !this.$v.currentBudget.category.required && errors.push('Category is required');
      return errors;
    },
    currencyErrors: function currencyErrors() {
      var errors = [];
      if (!this.$v.currentBudget.currency.$dirty) return errors;
      !this.$v.currentBudget.currency.required && errors.push('Currency is required');
      return errors;
    },
    budgetAmountErrors: function budgetAmountErrors() {
      var errors = [];
      if (!this.$v.currentBudget.budgetAmount.$dirty) return errors;
      !this.$v.currentBudget.budgetAmount.minValue && errors.push('Budget Amount must be at least 1');
      return errors;
    },
    refillAmountErrors: function refillAmountErrors() {
      var errors = [];
      if (!this.$v.currentBudget.budgetAmount.$dirty) return errors;
      !this.$v.currentBudget.budgetAmount.minValue && errors.push('Refill Amount must be at least 1');
      return errors;
    },
    copyBudgetAmountToRefillAmount: function copyBudgetAmountToRefillAmount() {
      if (this.currentBudget.refillAmount === 0 || this.currentBudget.refillAmount === '') {
        this.copyToRefill = true;
      }

      if (this.copyToRefill === true) {
        this.currentBudget.refillAmount = this.currentBudget.budgetAmount;
      }
    },
    stopCopyBudgetAmountToRefillAmount: function stopCopyBudgetAmountToRefillAmount() {
      this.copyToRefill = false;
    }
  },
  methods: {
    //adjustCurrency: function () {
    //  if (this.currentBudget.account !== '') {
    //    let acc = accountManager.getAccountByName(this.currentBudget.account)

    //    if (this.currentBudget.currency === '') {
    //      this.currentBudget.currency = acc.accountCurrency
    //    }
    //    else if (this.currentBudget.currency !== acc.accountCurrency) {
    //      this.conversion = true
    //    }
    //    else if (this.currentBudget.currency === acc.accountCurrency) {
    //      this.conversion = false
    //    }
    //  }
    //},
    budgetCheck: function budgetCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.currentBudget.budgetAmount <= 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.currentBudget.budgetAmount) || this.currentBudget.budgetAmount === "") {
        this.currentBudget.budgetAmount = 0;
      }

      if ($v.budgetName.$invalid || $v.account.$invalid) {
        return false;
      }

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].budgetName.toLowerCase() === this.currentBudget.budgetName.toLowerCase()) {
          this.sameBudget = true;
          return false;
        }
        if (i === this.items.length - 1) {
          this.sameBudget = false;
        }
      }

      return true;
    },
    AddBudgetCheck: function AddBudgetCheck($v) {
      if (this.budgetCheck($v)) {
        this.AddBudget($v);
      }
    },
    AddBudget: function AddBudget($v) {
      var newEntry = JSON.parse(JSON.stringify(this.currentBudget));

      this.addDialog = false;

      newEntry.id = this.getLargestIdFromItems() + 1;

      this.$store.commit('addNewBudgetToStore', newEntry);

      this.$router.push({ path: '/dashboard/budget' });
    },
    getLargestIdFromItems: function getLargestIdFromItems() {
      var largest = 0;
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id > largest) {
          largest = this.items[i].id;
        }
      }
      return largest;
    }
  },
  beforeMount: function beforeMount() {
    this.items = this.$store.state.Budgets;

    var cat = this.$store.state.Categories;
    for (var i = 0; i < cat.length; i++) {
      this.category.push(cat[i].categoryName);
    }

    var acc = this.$store.state.Accounts;
    for (var _i = 0; _i < acc.length; _i++) {
      this.account.push(acc[_i].accountName);
    }
  },

  validations: {
    currentBudget: {
      budgetName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      budgetType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      budgetAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      refillAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      refillDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  props: ['drawer'],
  data: function data() {
    return {
      account: [],
      category: ["cat1", "cat2", "cat3", "cat4"],
      type: ["None", "Weekly", "Monthly", "Yearly"],
      curriencies: ["USD", "JMD"],
      copyToRefill: true,
      editBudget: {
        id: 0,
        budgetName: '',
        account: '',
        budgetType: '',
        budgetAmount: 0,
        amountSpent: 0,
        refillAmount: 0,
        //refillDate: '',
        currency: '',
        comment: '',
        category: '',

        //Notification
        budgetOverspent: true,
        OverspendingRisk: true,

        //State of Current Object
        objectState: ''
      },
      items: []
    };
  },

  computed: {
    budgetNameErrors: function budgetNameErrors() {
      var errors = [];
      if (!this.$v.editBudget.budgetName.$dirty) return errors;
      !this.$v.editBudget.budgetName.required && errors.push('Budget Name is required');
      return errors;
    },
    accountErrors: function accountErrors() {
      var errors = [];
      if (!this.$v.editBudget.account.$dirty) return errors;
      !this.$v.editBudget.account.required && errors.push('Account is required');
      return errors;
    },
    budgetTypeErrors: function budgetTypeErrors() {
      var errors = [];
      if (!this.$v.editBudget.budgetType.$dirty) return errors;
      !this.$v.editBudget.budgetType.required && errors.push('Budget Type is required');
      return errors;
    },
    categoryErrors: function categoryErrors() {
      var errors = [];
      if (!this.$v.editBudget.category.$dirty) return errors;
      !this.$v.editBudget.category.required && errors.push('Category is required');
      return errors;
    },
    currencyErrors: function currencyErrors() {
      var errors = [];
      if (!this.$v.editBudget.currency.$dirty) return errors;
      !this.$v.editBudget.currency.required && errors.push('Currency is required');
      return errors;
    },
    budgetAmountErrors: function budgetAmountErrors() {
      var errors = [];
      if (!this.$v.editBudget.budgetAmount.$dirty) return errors;
      !this.$v.editBudget.budgetAmount.minValue && errors.push('Budget Amount must be at least 1');
      return errors;
    },
    refillAmountErrors: function refillAmountErrors() {
      var errors = [];
      if (!this.$v.editBudget.budgetAmount.$dirty) return errors;
      !this.$v.editBudget.budgetAmount.minValue && errors.push('Refill Amount must be at least 1');
      return errors;
    },
    copyBudgetAmountToRefillAmount: function copyBudgetAmountToRefillAmount() {
      if (this.editBudget.refillAmount === 0 || this.editBudget.refillAmount === '') {
        this.copyToRefill = true;
      }

      if (this.copyToRefill === true) {
        this.editBudget.refillAmount = this.editBudget.budgetAmount;
      }
    },
    stopCopyBudgetAmountToRefillAmount: function stopCopyBudgetAmountToRefillAmount() {
      this.copyToRefill = false;
    }
  },
  methods: {
    budgetCheck: function budgetCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.editBudget.budgetAmount <= 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.editBudget.budgetAmount) || this.editBudget.budgetAmount === "") {
        this.editBudget.budgetAmount = 0;
      }

      if ($v.budgetName.$invalid || $v.account.$invalid) {
        return false;
      }

      //for (let i = 0; i < this.items.length; i++) {
      //  if (this.items[i].budgetName.toLowerCase() === this.currentBudget.budgetName.toLowerCase()) {
      //    this.sameBudget = true
      //    return false
      //  }
      //  if (i === this.items.length - 1) {
      //    this.sameBudget = false
      //  }
      //}

      return true;
    },
    UpdateEditedBudget: function UpdateEditedBudget($v) {
      if (this.budgetCheck($v)) {
        this.editDialog = false;

        this.editBudget.objectState = "Update";

        this.$store.commit('updateBudgetinStore', this.editBudget);

        this.$router.push({ path: '/dashboard/budget' });
      }
    },
    EditBudget: function EditBudget(item) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === parseInt(item)) {
          var editEntry = JSON.parse(JSON.stringify(this.items[i]));
          this.editBudget = editEntry;
          break;
        }
      }

      this.editDialog = true;
      this.copyToRefill = false;
    }
  },
  beforeMount: function beforeMount() {
    this.items = JSON.parse(JSON.stringify(this.$store.state.Budgets));

    var cat = this.$store.state.Categories;
    for (var i = 0; i < cat.length; i++) {
      this.category.push(cat[i].categoryName);
    }

    var acc = this.$store.state.Accounts;
    for (var _i = 0; _i < acc.length; _i++) {
      this.account.push(acc[_i].accountName);
    }

    this.EditBudget(this.$route.params.itemId);
  },

  validations: {
    editBudget: {
      budgetName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      budgetType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      budgetAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      refillAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      refillDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }

});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reuseable_viewListItem_listItem_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reuseable_filter_Filter_vue__ = __webpack_require__(359);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    'ListItem': __WEBPACK_IMPORTED_MODULE_2__reuseable_viewListItem_listItem_vue__["a" /* default */],
    'MyFilter': __WEBPACK_IMPORTED_MODULE_3__reuseable_filter_Filter_vue__["a" /* default */]
  },
  props: ['drawer'],
  data: function data() {
    return {
      direction: 'left',
      speedDial: false,
      transition: 'slide-y-reverse-transition',
      moreOptions: false,
      search: '',
      viewSearch: false,
      viewFilter: false,
      filterBy: {
        transactionType: 'None',
        budget: 'None',
        category: 'None',
        currency: 'None',
        paymentType: 'None',
        show: false
      },
      addItem: false,
      datemenu: false,
      timemenuvisibilty: false,
      transactionItemsSearch: '',
      currency: ["JMD", "USD"],
      account: ["All Accounts"],
      transferAccount: [],
      selectedAccount: 'All Accounts',
      category: ["cat1", "cat2", "cat3", "cat4"],
      budget: [],
      period: ["All", "Day", "Week", "Month", "Year", "Custom"],
      paymentType: ["Cash", "Credit Card", "Debit Card", "Bank Transfer", "Voucher"],
      selectedPeriod: 'All',
      addDialog: false,
      editDialog: false,
      deleteDialog: false,
      //transactionItemTemp: {
      //  itemName: '',

      //},
      currentTransaction: {
        id: 0,
        account: '',
        transactionName: '',
        transactionType: 'expense',
        transactionAmount: 0,
        paymentType: '',
        comment: '',
        category: '',
        currency: '',
        items: [{
          item: "item1",
          price: 12
        }, {
          item: "item2",
          price: 12
        }],

        transactionDate: '',
        transactionTime: null,

        transferFrom: '',
        transferTo: '',

        recurringTransaction: false,

        //Recurring Transactions
        repeat: 1,
        cycle: '',
        period: 'Forever',
        numberOfCycles: 1,
        goesOffFirst: '',

        //State of Current Object
        objectState: 'New',
        show: false
      },
      deleteTransaction: {
        id: 0,
        transactionName: '',
        account: '',
        transactionType: '',
        transactionAmount: 0,
        paymentType: '',
        comment: '',
        category: '',
        currency: '',
        items: [],

        transactionDate: '',
        transactionTime: null,

        transferFrom: '',
        transferTo: '',

        recurringTransaction: false,

        //Recurring Transactions
        repeat: 1,
        cycle: '',
        period: 'Forever',
        numberOfCycles: 1,
        goesOffFirst: '',

        //State of Current Object
        objectState: '',
        show: false
      },
      transactionType: 1,
      items: [],
      itemsMinusDeleted: []
    };
  },

  computed: {
    accountErrors: function accountErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.account.$dirty && !this.$v.editTransaction.account.$dirty) return errors;
      !this.$v.currentTransaction.account.required && !this.$v.editTransaction.account.required && errors.push('Account is required');
      return errors;
    },
    transferFromErrors: function transferFromErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.transferFrom.$dirty && !this.$v.editTransaction.transferFrom.$dirty) return errors;
      !this.$v.currentTransaction.transferFrom.required && !this.$v.editTransaction.transferFrom.required && errors.push('Tranfer from is required');
      return errors;
    },
    transferToErrors: function transferToErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.transferTo.$dirty && !this.$v.editTransaction.transferTo.$dirty) return errors;
      !this.$v.currentTransaction.transferTo.required && !this.$v.editTransaction.transferTo.required && errors.push('Tranfer to is required');
      if (this.currentTransaction.transferTo === this.currentTransaction.transferFrom) errors.push('Cannot tranfer to the same Account');
      return errors;
    },
    paymentTypeErrors: function paymentTypeErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.paymentType.$dirty && !this.$v.editTransaction.paymentType.$dirty) return errors;
      !this.$v.currentTransaction.paymentType.required && !this.$v.editTransaction.paymentType.required && errors.push('Payment Type is required');
      return errors;
    },
    categoryErrors: function categoryErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.category.$dirty && !this.$v.editTransaction.category.$dirty) return errors;
      !this.$v.currentTransaction.category.required && !this.$v.editTransaction.category.required && errors.push('Category is required');
      return errors;
    },
    transactionAmountErrors: function transactionAmountErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.transactionAmount.$dirty && !this.$v.editTransaction.transactionAmount.$dirty) return errors;
      !this.$v.currentTransaction.transactionAmount.minValue && !this.$v.editTransaction.transactionAmount.minValue && errors.push('Transaction Amount must be at least 1');
      return errors;
    },
    currencyErrors: function currencyErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.currency.$dirty && !this.$v.editTransaction.currency.$dirty) return errors;
      !this.$v.currentTransaction.currency.required && !this.$v.editTransaction.currency.required && errors.push('Category is required');
      return errors;
    }
  },
  methods: {
    launchAddTransactionAndPopulateDateTime: function launchAddTransactionAndPopulateDateTime() {
      this.addDialog = true;
      var date = new Date();

      var month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }

      var day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }

      this.currentTransaction.transactionDate = date.getFullYear() + "-" + month + "-" + day;

      this.currentTransaction.transactionTime = date.getHours() + ":" + date.getMinutes();
    },
    TransactionCheck: function TransactionCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if ($v.account.$invalid || $v.category.$invalid || $v.transactionAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
        return false;
      }
      return true;
    },
    AddTransactionCheck: function AddTransactionCheck($v) {
      if (this.TransactionCheck($v)) {
        this.AddTransaction();
      }
    },
    AddTransaction: function AddTransaction() {
      if (this.currentTransaction.transactionAmount < 0 || !/^[0-9]+$/.test(this.currentTransaction.transactionAmount) || this.currentTransaction.transactionAmount === "") {
        this.currentTransaction.transactionAmount = 0;
      }

      var newEntry = JSON.parse(JSON.stringify(this.currentTransaction));

      this.addDialog = false;

      newEntry.id = this.getLargestIdFromItems() + 1;

      this.$store.commit('addNewTransactionToStore', newEntry);
      this.resetCurrentTransactionObject();
    },
    getLargestIdFromItems: function getLargestIdFromItems() {
      var largest = 0;
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id > largest) {
          largest = this.items[i].id;
        }
      }
      return largest;
    },
    UpdateEditedTransaction: function UpdateEditedTransaction($v) {
      if (this.TransactionCheck($v)) {
        this.editDialog = false;

        this.editTransaction.objectState = "Update";

        this.$store.commit('updateTransactioninStore', this.editTransaction);
      }
    },
    EditTransaction: function EditTransaction(item) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i] === item) {
          var editEntry = JSON.parse(JSON.stringify(this.items[i]));
          this.editTransaction = editEntry;
          break;
        }
      }

      this.editDialog = true;
    },
    DeleteTransactionAccept: function DeleteTransactionAccept() {
      this.deleteDialog = false;

      this.deleteTransaction.objectState = "Delete";

      this.$store.commit('markTransactionAsDeleted', this.deleteTransaction);
    },
    DeleteTransaction: function DeleteTransaction(item) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === item) {
          this.deleteTransaction = this.items[i];
          break;
        }
      }

      this.deleteDialog = true;
    },
    resetCurrentTransactionObject: function resetCurrentTransactionObject() {
      this.currentTransaction.transactionType = "expense";
      this.currentTransaction.transactionAmount = 0;
      this.currentTransaction.paymentType = "";
      this.currentTransaction.comment = "";
      this.currentTransaction.category = "";
      this.currentTransaction.currency = "";
      this.currentTransaction.transactionDate = "";
      this.currentTransaction.transactionTime = null;
    },
    removeDeletedTransactionsFromItems: function removeDeletedTransactionsFromItems() {
      this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items));

      for (var i = 0; i < this.itemsMinusDeleted.length; i++) {
        if (this.itemsMinusDeleted[i].objectState === 'Delete') {
          this.itemsMinusDeleted.splice(i, 1);
        }
      }
    },
    redirectToEditPage: function redirectToEditPage(item) {
      this.$router.push({ path: '/dashboard/edittransaction/' + item });
    },
    getSearchItems: function getSearchItems() {
      //Check if Search is empty
      if (this.search === '') {
        return;
      }

      //Get All Items from item
      this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items));

      //Remove Transactions that does not meet search criteria 
      for (var i = 0; i < this.itemsMinusDeleted.length; i++) {
        if (this.itemsMinusDeleted[i].transactionName.indexOf(this.search) === -1) {
          this.itemsMinusDeleted.splice(i, 1);
        }
      }
    },
    getitemsFromStoreAndRemoveDeletedItems: function getitemsFromStoreAndRemoveDeletedItems() {
      this.items = JSON.parse(JSON.stringify(this.$store.state.Transactions));

      ///Remove deleted items from items array
      this.removeDeletedTransactionsFromItems();
    },
    getfilteredData: function getfilteredData(filter) {
      this.filterBy.transactionType = filter.transactionType;
      this.filterBy.budget = filter.budget;
      this.filterBy.category = filter.category;
      this.filterBy.currency = filter.currency;
      this.filterBy.paymentType = filter.paymentType;
      this.viewFilter = filter.show;

      this.filterdata();
    },
    filterdata: function filterdata() {
      this.getitemsFromStoreAndRemoveDeletedItems();

      //Filter By TransactionType
      if (this.filterBy.transactionType !== 'None') {
        for (var i = 0; i < this.itemsMinusDeleted.length; i++) {
          if (this.itemsMinusDeleted[i].transactionType.toLowerCase() !== this.filterBy.transactionType.toLowerCase()) {
            this.itemsMinusDeleted.splice(i, 1);
          }
        }
      }

      //Filter By Budget
      if (this.filterBy.budget !== 'None') {
        for (var _i = 0; _i < this.itemsMinusDeleted.length; _i++) {
          if (this.itemsMinusDeleted[_i].budget.toLowerCase() !== this.filterBy.budget.toLowerCase()) {
            this.itemsMinusDeleted.splice(_i, 1);
          }
        }
      }

      //Filter By Category
      if (this.filterBy.category !== 'None') {
        for (var _i2 = 0; _i2 < this.itemsMinusDeleted.length; _i2++) {
          if (this.itemsMinusDeleted[_i2].category.toLowerCase() !== this.filterBy.category.toLowerCase()) {
            this.itemsMinusDeleted.splice(_i2, 1);
          }
        }
      }

      //Filter By Currency
      if (this.filterBy.currency !== 'None') {
        for (var _i3 = 0; _i3 < this.itemsMinusDeleted.length; _i3++) {
          if (this.itemsMinusDeleted[_i3].currency.toLowerCase() !== this.filterBy.currency.toLowerCase()) {
            this.itemsMinusDeleted.splice(_i3, 1);
          }
        }
      }

      //Filter By PaymentType
      if (this.filterBy.paymentType !== 'None') {
        for (var _i4 = 0; _i4 < this.itemsMinusDeleted.length; _i4++) {
          if (this.itemsMinusDeleted[_i4].paymentType.toLowerCase() !== this.filterBy.paymentType.toLowerCase()) {
            this.itemsMinusDeleted.splice(_i4, 1);
          }
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getitemsFromStoreAndRemoveDeletedItems();

    var cat = this.$store.state.Categories;
    for (var i = 0; i < cat.length; i++) {
      this.category.push(cat[i].categoryName);
    }

    var cur = this.$store.state.Currencies;
    for (var _i5 = 0; _i5 < cur.length; _i5++) {
      this.currency.push(cur[_i5].currencyName);
    }

    var acc = this.$store.state.Accounts;
    for (var _i6 = 0; _i6 < acc.length; _i6++) {
      this.account.push(acc[_i6].accountName);
      this.transferAccount.push(acc[_i6].accountName);
    }
  },

  validations: {
    currentTransaction: {
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transactionAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      transactionDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transactionTime: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      paymentType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferFrom: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferTo: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    },
    editTransaction: {
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transactionAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      transactionDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transactionTime: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      paymentType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferFrom: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferTo: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
    //transactionItemTemp: {
    //  itemName: {
    //    required
    //  }

    //}
  }

});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['filterBy'],
  data: function data() {
    return {
      viewFilter: true,
      currency: ["None", "JMD", "USD"],
      category: ["None", "cat1", "cat2", "cat3", "cat4"],
      budget: ["None"],
      paymentType: ["None", "Cash", "Credit Card", "Debit Card", "Bank Transfer", "Voucher"]
    };
  },

  methods: {
    setfilteredData: function setfilteredData() {
      this.$emit('filterData', this.filterBy);
    }
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_transactionManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__javascript_incomeManager__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__javascript_expenseManager__ = __webpack_require__(82);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  props: ['drawer'],
  data: function data() {
    return {
      showSnackbar: false,
      snackbarText: '',
      snackbarColor: '',
      addItem: false,
      datemenu: false,
      timemenuvisibilty: false,
      addModelGoesOff: false,
      transactionItemheaders: [{ text: 'Item', align: 'left', value: 'itemName' }, { text: 'Price', align: 'left', value: 'itemPrice' }],
      transactionItems: [],
      transactionItemsNames: ['Cat', 'Dog'],
      transactionItemsSearch: '',
      currency: ["JMD", "USD"],
      account: [],
      budget: ["None"],
      transferAccount: [],
      selectedAccount: '',
      category: ["cat1", "cat2", "cat3", "cat4"],
      paymentType: ["Cash", "Credit Card", "Debit Card", "Bank Transfer", "Voucher"],
      currentTransaction: {
        id: 0,
        account: '',
        transactionName: '',
        transactionType: 'expense',
        transactionAmount: 0,
        paymentType: '',
        budget: 'None',
        comment: '',
        category: '',
        currency: '',
        items: [],

        transactionDate: '',
        transactionTime: null,

        transferFrom: '',
        transferTo: '',

        recurringTransaction: false,

        //Recurring Transactions
        repeat: 1,
        cycle: '',
        period: 'Forever',
        numberOfCycles: 1,
        goesOffFirst: '',

        //State of Current Object
        objectState: 'New',
        show: false
      },
      transactionItemTemp: {
        itemName: [],
        itemPrice: '',
        itemCurrency: '',
        isTaxed: false,
        taxedPrice: '',

        dateChanged: ''
      },
      transactionType: 1,
      conversions: [],
      currencyConversions: [],
      convert: false,
      transactions: []
    };
  },

  computed: {
    transactionNameErrors: function transactionNameErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.transactionName.$dirty) return errors;
      !this.$v.currentTransaction.transactionName.required && errors.push('Transaction Name is required');
      return errors;
    },
    accountErrors: function accountErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.account.$dirty) return errors;
      !this.$v.currentTransaction.account.required && errors.push('Account is required');
      return errors;
    },
    transferFromErrors: function transferFromErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.transferFrom.$dirty) return errors;
      !this.$v.currentTransaction.transferFrom.required && errors.push('Tranfer from is required');
      return errors;
    },
    transferToErrors: function transferToErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.transferTo.$dirty) return errors;
      !this.$v.currentTransaction.transferTo.required && errors.push('Tranfer to is required');
      if (this.currentTransaction.transferTo === this.currentTransaction.transferFrom) errors.push('Cannot tranfer to the same Account');
      return errors;
    },
    paymentTypeErrors: function paymentTypeErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.paymentType.$dirty) return errors;
      !this.$v.currentTransaction.paymentType.required && errors.push('Payment Type is required');
      return errors;
    },
    categoryErrors: function categoryErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.category.$dirty) return errors;
      !this.$v.currentTransaction.category.required && errors.push('Category is required');
      return errors;
    },
    transactionAmountErrors: function transactionAmountErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.transactionAmount.$dirty) return errors;
      !this.$v.currentTransaction.transactionAmount.minValue && errors.push('Transaction Amount must be at least 1');
      return errors;
    },
    currencyErrors: function currencyErrors() {
      var errors = [];
      if (!this.$v.currentTransaction.currency.$dirty) return errors;
      !this.$v.currentTransaction.currency.required && errors.push('Currency is required');
      return errors;
    },
    transactionItemNameErrors: function transactionItemNameErrors() {
      var errors = [];
      if (!this.$v.transactionItemTemp.itemName.$dirty) return errors;
      !this.$v.transactionItemTemp.itemName.required && errors.push('Item Name is required');
      return errors;
    },
    transactionItemPriceErrors: function transactionItemPriceErrors() {
      var errors = [];
      if (!this.$v.transactionItemTemp.itemPrice.$dirty) return errors;
      !this.$v.transactionItemTemp.itemPrice.minValue && errors.push('Item Price must be at least 1');
      return errors;
    },
    transactionItemCurrencyErrors: function transactionItemCurrencyErrors() {
      var errors = [];
      if (!this.$v.transactionItemTemp.itemCurrency.$dirty) return errors;
      !this.$v.transactionItemTemp.itemCurrency.required && errors.push('Currency is required');
      return errors;
    },
    selectAndHideAccount: function selectAndHideAccount() {
      //Find Correct Budget Object
      var bud = this.$store.state.Budgets;
      for (var i = 0; i < bud.length; i++) {
        if (bud[i].budgetName === this.currentTransaction.budget) {
          this.currentTransaction.account = bud[i].account;
          //this.accountReadonly = true
        }
        //else if (this.currentTransaction.budget === "None") {
        //this.accountReadonly = false
        //}
      }
    },
    adjustAccountToMatchBudget: function adjustAccountToMatchBudget() {

      ////////////////////////////////////////////////////////
      //TODO: Check if Budget is not "None".
      //TODO: Show error and choice to user if not none
      //and account changed
      ////////////////////////////////////////////////////////

    }
  },
  methods: {
    updateDateAndTime: function updateDateAndTime() {
      this.currentTransaction.transactionDate = __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getCurrentDateForPicker();
      this.currentTransaction.transactionTime = __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getCurrentTimeForPicker();
    },
    buildAccountSelect: function buildAccountSelect() {
      var tempAccount = this.$store.state.Accounts;

      this.account.push({ header: 'Accounts' });

      for (var i = 0; i < tempAccount.length; i++) {
        this.account.push(tempAccount[i]);
      }

      this.transferAccount = this.account;

      //let group = this.$store.state.Groups

      //if (group.length > 0) {
      //  this.account.push({ header: 'Groups' })

      //  for (let i = 0; i < group.length; i++) {
      //    this.account.push(group[i])
      //  }
      //}
    },
    TransactionCheck: function TransactionCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.currentTransaction.transactionAmount < 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.currentTransaction.transactionAmount) || this.currentTransaction.transactionAmount === "") {
        this.currentTransaction.transactionAmount = 0;
      }

      if (this.currentTransaction.transactionType !== 'transfer') {
        if ($v.account.$invalid || $v.category.$invalid || $v.transactionAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
          return false;
        }
      } else if (this.currentTransaction.transactionType === 'transfer') {
        if ($v.transferFrom.$invalid || $v.transferTo.$invalid || $v.category.$invalid || $v.transactionAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
          return false;
        }
      }
      return true;
    },
    AddTransactionCheck: function AddTransactionCheck($v) {
      if (this.TransactionCheck($v)) {

        __WEBPACK_IMPORTED_MODULE_3__javascript_transactionManager__["a" /* transactionManager */].addTransaction(this.currentTransaction);

        if (this.currentTransaction.transactionType === 'income') {
          __WEBPACK_IMPORTED_MODULE_4__javascript_incomeManager__["a" /* incomeManager */].createIncomeFromTrasaction(this.currentTransaction);
        } else if (this.currentTransaction.transactionType === 'expense') {
          __WEBPACK_IMPORTED_MODULE_5__javascript_expenseManager__["a" /* expenseManager */].createExpenseFromTransaction(this.currentTransaction);
        }

        this.$router.push({ path: '/dashboard/transaction' });
      }
    },
    itemCheck: function itemCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.transactionItemTemp.itemPrice < 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.transactionItemTemp.itemPrice) || this.transactionItemTemp.itemPrice === "") {
        this.transactionItemTemp.itemPrice = 0;
      }

      if ($v.itemName.$invalid || $v.itemPrice.$invalid || $v.itemCurrency.$invalid) {
        return false;
      }
      return true;
    },
    addItemCheck: function addItemCheck($v) {
      if (this.itemCheck($v)) {
        this.addItemToTransaction();
      }
    },
    addItemToTransaction: function addItemToTransaction() {
      //Add Item to Transaction Items

      var newItem = JSON.parse(JSON.stringify(this.transactionItemTemp));

      this.currentTransaction.items.push(newItem);

      this.addItem = false;

      this.doesItemExist();

      this.addItemPriceToTransactionAmount();

      this.resetItemForm();
    },
    addItemPriceToTransactionAmount: function addItemPriceToTransactionAmount() {

      var total = 0;
      for (var i = 0; i < this.currentTransaction.items.length; i++) {
        total = parseFloat(total) + parseFloat(this.currencyConverter(this.currentTransaction.items[i]));
      }

      this.currentTransaction.transactionAmount = total;
    },
    resetItemForm: function resetItemForm() {
      this.transactionItemTemp.itemName = '';
      this.transactionItemTemp.itemPrice = 0;
      this.transactionItemTemp.itemCurrency = '';
      this.transactionItemTemp.isTaxed = false;
      this.transactionItemTemp.taxedPrice = 0;
    },
    doesItemExist: function doesItemExist() {
      if (this.transactionItems.length !== 0) {
        for (var i = 0; i < this.transactionItems.length; i++) {
          if (this.transactionItems[i].itemName === this.transactionItemTemp.itemName) {

            /////////////////////////////////////////////////////////////
            //Check All other values to see if they are the same
            /////////////////////////////////////////////////////////////

            if (this.transactionItems[i].itemPrice !== this.transactionItemTemp.itemPrice) {

              ///////////////////////////////////////////////////////////////////
              //Create New Item To Represent Update,
              //Keep Old Data As To Not Cause Problems To Past Transactions
              ///////////////////////////////////////////////////////////////////

              this.addNewItem();
              return;
            }
          }
        }
      } else {
        this.addNewItem();
      }
    },
    addNewItem: function addNewItem() {
      this.transactionItemTemp.dateChanged = __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getCurrentDate();

      var newEntry = JSON.parse(JSON.stringify(this.transactionItemTemp));

      newEntry.id = this.getLargestIdFromTransactionItems() + 1;

      this.$store.commit('addNewItemToStore', newEntry);
    },
    getLargestIdFromTransactionItems: function getLargestIdFromTransactionItems() {
      var largest = 0;
      for (var i = 0; i < this.transactionItems.length; i++) {
        if (this.transactionItems[i].id > largest) {
          largest = this.transactionItems[i].id;
        }
      }
      return largest;
    },
    selectedCurrencyChanged: function selectedCurrencyChanged() {
      ///////////////////////////////////////////////////////
      //Go Through Each Transaction Item 
      ///////////////////////////////////////////////////////

      for (var i = 0; i < this.transactionItems.length; i++) {
        ////////////////////////////////////////////////////////////////
        //Loop conversions and test if currency already found
        ///////////////////////////////////////////////////////////////

        for (var x = 0; x < this.conversions.length; x++) {
          if (this.transactionItems[i].itemCurrency === this.conversions[x]) {
            break;
          } else if (x === this.conversions.length - 1) {
            this.getConversion(this.transactionItems[i].itemCurrency);
          }
        }
      }
    },
    getConversion: function getConversion(from) {
      for (var i = 0; i < this.currencyConversions.length; i++) {
        if (this.currencyConversions[i].convertFrom === from && this.currencyConversions[i].convertTo === this.currentTransaction.currency) {
          this.conversions.push(this.currencyConversions[i]);
        }
      }

      this.convert = true;
    },
    currencyConverter: function currencyConverter(item) {
      ////////////////////////////////////////////////////////////////////
      //Returns Price If Currencies Are The Same,
      //Returns Adjusted Price If Currency Is Different
      ////////////////////////////////////////////////////////////////////

      if (item.itemCurrency === this.currentTransaction.currency || this.currentTransaction.currency === "") {
        return item.itemPrice;
      } else {
        for (var i = 0; i < this.conversions.length; i++) {
          if (this.conversions.convertFrom === item.itemCurrency) {
            return parseFloat(this.conversions.conversionRate) * item.itemPrice;
          }
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.transactions = this.$store.state.Transactions;

    var tranItems = this.$store.state.Items;
    this.transactionItems = tranItems;
    for (var i = 0; i < tranItems.length; i++) {
      this.transactionItemsNames.push(tranItems[i].itemName);
    }

    var cat = this.$store.state.Categories;
    for (var _i = 0; _i < cat.length; _i++) {
      this.category.push(cat[_i].categoryName);
    }

    var cur = this.$store.state.Currencies;
    for (var _i2 = 0; _i2 < cur.length; _i2++) {
      this.currency.push(cur[_i2].currencyName);
    }

    var curCon = this.$store.state.CurrencyConversions;
    for (var _i3 = 0; _i3 < curCon.length; _i3++) {
      this.currencyConversions.push(curCon[_i3]);
    }

    var bud = this.$store.state.Budgets;
    for (var _i4 = 0; _i4 < bud.length; _i4++) {
      this.budget.push(bud[_i4].budgetName);
    }

    this.updateDateAndTime();
    this.buildAccountSelect();
  },

  validations: {
    currentTransaction: {
      transactionName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transactionAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      transactionDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transactionTime: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      paymentType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferFrom: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferTo: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    },
    transactionItemTemp: {
      itemName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      itemPrice: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      itemCurrency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }

    }
  }

});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_transactionManager__ = __webpack_require__(52);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  props: ['drawer'],
  data: function data() {
    return {
      showSnackbar: false,
      snackbarText: '',
      snackbarColor: '',
      addItem: false,
      datemenu: false,
      timemenuvisibilty: false,
      editModelGoesOff: false,
      transactionItemheaders: [{ text: 'Item', align: 'left', value: 'itemName' }, { text: 'Price', align: 'left', value: 'itemPrice' }],
      transactionItems: [],
      transactionItemsNames: ['Cat', 'Dog'],
      transactionItemsSearch: '',
      currency: ["JMD", "USD"],
      account: [],
      budget: ["None"],
      transferAccount: [],
      selectedAccount: '',
      category: ["cat1", "cat2", "cat3", "cat4"],
      paymentType: ["Cash", "Credit Card", "Debit Card", "Bank Transfer", "Voucher"],
      editTransaction: {
        id: 0,
        account: '',
        transactionName: '',
        transactionType: 'expense',
        transactionAmount: 0,
        paymentType: '',
        budget: 'None',
        comment: '',
        category: '',
        currency: '',
        items: [],

        transactionDate: '',
        transactionTime: null,

        transferFrom: '',
        transferTo: '',

        recurringTransaction: false,

        //Recurring Transactions
        repeat: 1,
        cycle: '',
        period: 'Forever',
        numberOfCycles: 1,
        goesOffFirst: '',

        //State of Current Object
        objectState: 'New',
        show: false
      },
      transactionItemTemp: {
        itemName: [],
        itemPrice: '',
        itemCurrency: '',
        isTaxed: false,
        taxedPrice: '',

        dateChanged: ''
      },
      transactionType: 1,
      conversions: [],
      currencyConversions: [],
      convert: false,
      transactions: []
    };
  },

  computed: {
    transactionNameErrors: function transactionNameErrors() {
      var errors = [];
      if (!this.$v.editTransaction.transactionName.$dirty) return errors;
      !this.$v.editTransaction.transactionName.required && errors.push('Transaction Name is required');
      return errors;
    },
    accountErrors: function accountErrors() {
      var errors = [];
      if (!this.$v.editTransaction.account.$dirty) return errors;
      !this.$v.editTransaction.account.required && errors.push('Account is required');
      return errors;
    },
    transferFromErrors: function transferFromErrors() {
      var errors = [];
      if (!this.$v.editTransaction.transferFrom.$dirty) return errors;
      !this.$v.editTransaction.transferFrom.required && errors.push('Tranfer from is required');
      return errors;
    },
    transferToErrors: function transferToErrors() {
      var errors = [];
      if (!this.$v.editTransaction.transferTo.$dirty) return errors;
      !this.$v.editTransaction.transferTo.required && errors.push('Tranfer to is required');
      if (this.editTransaction.transferTo === this.editTransaction.transferFrom) errors.push('Cannot tranfer to the same Account');
      return errors;
    },
    paymentTypeErrors: function paymentTypeErrors() {
      var errors = [];
      if (!this.$v.editTransaction.paymentType.$dirty) return errors;
      !this.$v.editTransaction.paymentType.required && errors.push('Payment Type is required');
      return errors;
    },
    categoryErrors: function categoryErrors() {
      var errors = [];
      if (!this.$v.editTransaction.category.$dirty) return errors;
      !this.$v.editTransaction.category.required && errors.push('Category is required');
      return errors;
    },
    transactionAmountErrors: function transactionAmountErrors() {
      var errors = [];
      if (!this.$v.editTransaction.transactionAmount.$dirty) return errors;
      !this.$v.editTransaction.transactionAmount.minValue && errors.push('Transaction Amount must be at least 1');
      return errors;
    },
    currencyErrors: function currencyErrors() {
      var errors = [];
      if (!this.$v.editTransaction.currency.$dirty) return errors;
      !this.$v.editTransaction.currency.required && errors.push('Currency is required');
      return errors;
    },
    transactionItemNameErrors: function transactionItemNameErrors() {
      var errors = [];
      if (!this.$v.transactionItemTemp.itemName.$dirty) return errors;
      !this.$v.transactionItemTemp.itemName.required && errors.push('Item Name is required');
      return errors;
    },
    transactionItemPriceErrors: function transactionItemPriceErrors() {
      var errors = [];
      if (!this.$v.transactionItemTemp.itemPrice.$dirty) return errors;
      !this.$v.transactionItemTemp.itemPrice.minValue && errors.push('Item Price must be at least 1');
      return errors;
    },
    transactionItemCurrencyErrors: function transactionItemCurrencyErrors() {
      var errors = [];
      if (!this.$v.transactionItemTemp.itemCurrency.$dirty) return errors;
      !this.$v.transactionItemTemp.itemCurrency.required && errors.push('Currency is required');
      return errors;
    },
    selectAndHideAccount: function selectAndHideAccount() {
      //Find Correct Budget Object
      var bud = this.$store.state.Budgets;
      for (var i = 0; i < bud.length; i++) {
        if (bud[i].budgetName === this.editTransaction.budget) {
          this.editTransaction.account = bud[i].account;
          //this.accountReadonly = true
        }
        //else if (this.editTransaction.budget === "None") {
        //this.accountReadonly = false
        //}
      }
    },
    adjustAccountToMatchBudget: function adjustAccountToMatchBudget() {

      ////////////////////////////////////////////////////////
      //TODO: Check if Budget is not "None".
      //TODO: Show error and choice to user if not none
      //and account changed
      ////////////////////////////////////////////////////////

    }
  },
  methods: {
    //updateDateAndTime: function () {
    //  this.editTransaction.transactionDate = globalFunctions.getCurrentDateForPicker()
    //  this.editTransaction.transactionTime = globalFunctions.getCurrentTimeForPicker()
    //},
    buildAccountSelect: function buildAccountSelect() {
      var tempAccount = this.$store.state.Accounts;

      this.account.push({ header: 'Accounts' });

      for (var i = 0; i < tempAccount.length; i++) {
        this.account.push(tempAccount[i]);
      }

      this.transferAccount = this.account;

      //let group = this.$store.state.Groups

      //if (group.length > 0) {
      //  this.account.push({ header: 'Groups' })

      //  for (let i = 0; i < group.length; i++) {
      //    this.account.push(group[i])
      //  }
      //}
    },
    TransactionCheck: function TransactionCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.editTransaction.transactionAmount < 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.editTransaction.transactionAmount) || this.editTransaction.transactionAmount === "") {
        this.editTransaction.transactionAmount = 0;
      }

      if (this.editTransaction.transactionType !== 'transfer') {
        if ($v.account.$invalid || $v.category.$invalid || $v.transactionAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
          return false;
        }
      } else if (this.editTransaction.transactionType === 'transfer') {
        if ($v.transferFrom.$invalid || $v.transferTo.$invalid || $v.category.$invalid || $v.transactionAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
          return false;
        }
      }
      return true;
    },
    editTransactionCheck: function editTransactionCheck($v) {
      if (this.TransactionCheck($v)) {
        __WEBPACK_IMPORTED_MODULE_3__javascript_transactionManager__["a" /* transactionManager */].updateEditedTransaction(this.editTransaction);

        //////////////////////////////////////
        //Transaction Successful
        //////////////////////////////////////

        //this.snackbarText = "Transaction Successful"
        //this.snackbarColor = "success"
        //this.showSnackbar = true

        this.$router.push({ path: '/dashboard/transaction' });
      }
    },
    editTransactionSetter: function editTransactionSetter(item) {
      for (var i = 0; i < this.transactions.length; i++) {
        if (this.transactions[i].id === parseInt(item)) {
          var editEntry = JSON.parse(JSON.stringify(this.transactions[i]));
          this.editTransaction = editEntry;
          break;
        }
      }
    },
    itemCheck: function itemCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.transactionItemTemp.itemPrice < 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.transactionItemTemp.itemPrice) || this.transactionItemTemp.itemPrice === "") {
        this.transactionItemTemp.itemPrice = 0;
      }

      if ($v.itemName.$invalid || $v.itemPrice.$invalid || $v.itemCurrency.$invalid) {
        return false;
      }
      return true;
    },
    addItemCheck: function addItemCheck($v) {
      if (this.itemCheck($v)) {
        this.addItemToTransaction();
      }
    },
    addItemToTransaction: function addItemToTransaction() {
      //Add Item to Transaction Items

      var newItem = JSON.parse(JSON.stringify(this.transactionItemTemp));

      this.editTransaction.items.push(newItem);

      this.addItem = false;

      this.doesItemExist();

      this.addItemPriceToTransactionAmount();

      this.resetItemForm();
    },
    addItemPriceToTransactionAmount: function addItemPriceToTransactionAmount() {

      var total = 0;
      for (var i = 0; i < this.editTransaction.items.length; i++) {
        total = parseFloat(total) + parseFloat(this.currencyConverter(this.editTransaction.items[i]));
      }

      this.editTransaction.transactionAmount = total;
    },
    resetItemForm: function resetItemForm() {
      this.transactionItemTemp.itemName = '';
      this.transactionItemTemp.itemPrice = 0;
      this.transactionItemTemp.itemCurrency = '';
      this.transactionItemTemp.isTaxed = false;
      this.transactionItemTemp.taxedPrice = 0;
    },
    doesItemExist: function doesItemExist() {
      if (this.transactionItems.length !== 0) {
        for (var i = 0; i < this.transactionItems.length; i++) {
          if (this.transactionItems[i].itemName === this.transactionItemTemp.itemName) {

            /////////////////////////////////////////////////////////////
            //Check All other values to see if they are the same
            /////////////////////////////////////////////////////////////

            if (this.transactionItems[i].itemPrice !== this.transactionItemTemp.itemPrice) {

              ///////////////////////////////////////////////////////////////////
              //Create New Item To Represent Update,
              //Keep Old Data As To Not Cause Problems To Pass Transactions
              ///////////////////////////////////////////////////////////////////

              this.addNewItem();
              return;
            }
          }
        }
      } else {
        this.addNewItem();
      }
    },
    addNewItem: function addNewItem() {
      this.transactionItemTemp.dateChanged = __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getCurrentDate();

      var newEntry = JSON.parse(JSON.stringify(this.transactionItemTemp));

      newEntry.id = this.getLargestIdFromTransactionItems() + 1;

      this.$store.commit('addNewItemToStore', newEntry);
    },
    getLargestIdFromTransactionItems: function getLargestIdFromTransactionItems() {
      var largest = 0;
      for (var i = 0; i < this.transactionItems.length; i++) {
        if (this.transactionItems[i].id > largest) {
          largest = this.transactionItems[i].id;
        }
      }
      return largest;
    },
    selectedCurrencyChanged: function selectedCurrencyChanged() {
      ///////////////////////////////////////////////////////
      //Go Through Each Transaction Item 
      ///////////////////////////////////////////////////////

      for (var i = 0; i < this.transactionItems.length; i++) {
        ////////////////////////////////////////////////////////////////
        //Loop conversions and test if currency already found
        ///////////////////////////////////////////////////////////////

        for (var x = 0; x < this.conversions.length; x++) {
          if (this.transactionItems[i].itemCurrency === this.conversions[x]) {
            break;
          } else if (x === this.conversions.length - 1) {
            this.getConversion(this.transactionItems[i].itemCurrency);
          }
        }
      }
    },
    getConversion: function getConversion(from) {
      for (var i = 0; i < this.currencyConversions.length; i++) {
        if (this.currencyConversions[i].convertFrom === from && this.currencyConversions[i].convertTo === this.editTransaction.currency) {
          this.conversions.push(this.currencyConversions[i]);
        }
      }

      this.convert = true;
    },
    currencyConverter: function currencyConverter(item) {
      ////////////////////////////////////////////////////////////////////
      //Returns Price If Currencies Are The Same,
      //Returns Adjusted Price If Currency Is Different
      ////////////////////////////////////////////////////////////////////

      if (item.itemCurrency === this.editTransaction.currency || this.editTransaction.currency === "") {
        return item.itemPrice;
      } else {
        for (var i = 0; i < this.conversions.length; i++) {
          if (this.conversions.convertFrom === item.itemCurrency) {
            return parseFloat(this.conversions.conversionRate) * item.itemPrice;
          }
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.transactions = this.$store.state.Transactions;

    var tranItems = this.$store.state.Items;
    this.transactionItems = tranItems;
    for (var i = 0; i < tranItems.length; i++) {
      this.transactionItemsNames.push(tranItems[i].itemName);
    }

    var cat = this.$store.state.Categories;
    for (var _i = 0; _i < cat.length; _i++) {
      this.category.push(cat[_i].categoryName);
    }

    var cur = this.$store.state.Currencies;
    for (var _i2 = 0; _i2 < cur.length; _i2++) {
      this.currency.push(cur[_i2].currencyName);
    }

    var curCon = this.$store.state.CurrencyConversions;
    for (var _i3 = 0; _i3 < curCon.length; _i3++) {
      this.currencyConversions.push(curCon[_i3]);
    }

    var bud = this.$store.state.Budgets;
    for (var _i4 = 0; _i4 < bud.length; _i4++) {
      this.budget.push(bud[_i4].budgetName);
    }

    //this.updateDateAndTime()
    this.buildAccountSelect();

    this.editTransactionSetter(this.$route.params.itemId);
  },

  validations: {
    editTransaction: {
      transactionName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      account: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transactionAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      transactionDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transactionTime: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      paymentType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferFrom: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferTo: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    },
    transactionItemTemp: {
      itemName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      itemPrice: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      itemCurrency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }

    }
  }

});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reuseable_viewListItem_listItem_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__javascript_transferManager__ = __webpack_require__(83);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'ListItem': __WEBPACK_IMPORTED_MODULE_0__reuseable_viewListItem_listItem_vue__["a" /* default */]
  },
  props: ['drawer'],
  data: function data() {
    return {
      direction: 'left',
      speedDial: false,
      transition: 'slide-y-reverse-transition',
      moreOptions: false,
      search: '',
      viewSearch: false,
      viewFilter: false,
      deleteDialog: false,
      deleteTransfer: {
        id: 0,
        currency: '',
        transferName: '',
        category: '',
        transferAmount: 0,
        comment: '',
        paymentType: '',

        transferFrom: '',
        transferTo: '',

        transferDate: '',
        transferTime: null,

        //State of Current Object
        objectState: ''
      },
      items: [],
      itemsMinusDeleted: []
    };
  },

  methods: {
    redirectToEditPage: function redirectToEditPage(item) {
      this.$router.push({ path: '/dashboard/edittransfer/' + item });
    },
    DeleteTransferAccept: function DeleteTransferAccept() {
      this.deleteDialog = false;

      this.deleteTransfer.objectState = "Delete";

      ///Remove item from items array
      this.removeDeletedTransfersFromItems();

      __WEBPACK_IMPORTED_MODULE_1__javascript_transferManager__["a" /* transferManager */].rollbackTransactionFromTransfer(this.deleteTransfer);

      this.$store.commit('markTransferAsDeleted', this.deleteTransfer);
    },
    DeleteTransfer: function DeleteTransfer(item) {
      for (var i = 0; i < this.itemsMinusDeleted.length; i++) {
        if (this.itemsMinusDeleted[i].id === item) {
          this.deleteTransfer = this.itemsMinusDeleted[i];
          break;
        }
      }

      this.deleteDialog = true;
    },

    removeDeletedTransfersFromItems: function removeDeletedTransfersFromItems() {
      //Add Items if not Deleted

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].objectState !== 'Delete') {
          this.itemsMinusDeleted.push(this.items[i]);
        }
      }
    },
    getitemsFromStoreAndRemoveDeletedItems: function getitemsFromStoreAndRemoveDeletedItems() {
      this.items = JSON.parse(JSON.stringify(this.$store.state.Transfers));

      ///Remove deleted items from items array
      this.removeDeletedTransfersFromItems();
    }
  },
  beforeMount: function beforeMount() {
    this.getitemsFromStoreAndRemoveDeletedItems();

    //let cat = this.$store.state.Categories
    //for (let i = 0; i < cat.length; i++) {
    //  this.category.push(cat[i].categoryName)
    //}

    //let acc = this.$store.state.Accounts
    //for (let i = 0; i < acc.length; i++) {
    //  this.account.push(acc[i].accountName)
    //}
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_transferManager__ = __webpack_require__(83);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  props: ['drawer'],
  data: function data() {
    return {
      paymentType: ["Cash", "Credit Card", "Debit Card", "Bank Transfer", "Voucher"],
      category: ["cat1", "cat2", "cat3", "cat4"],
      currency: ["JMD", "USD"],
      account: [],
      datemenu: false,
      timemenuvisibilty: false,
      currentTransfer: {
        id: 0,
        currency: '',
        transferName: '',
        category: '',
        transferAmount: 0,
        comment: '',
        paymentType: '',

        transferFrom: '',
        transferTo: '',

        transferDate: '',
        transferTime: null,

        //State of Current Object
        objectState: 'New'
      },
      transferItems: []
    };
  },

  computed: {
    transferFromErrors: function transferFromErrors() {
      var errors = [];
      if (!this.$v.currentTransfer.transferFrom.$dirty) return errors;
      !this.$v.currentTransfer.transferFrom.required && errors.push('Tranfer from is required');
      return errors;
    },
    transferToErrors: function transferToErrors() {
      var errors = [];
      if (!this.$v.currentTransfer.transferTo.$dirty) return errors;
      !this.$v.currentTransfer.transferTo.required && errors.push('Tranfer to is required');
      if (this.currentTransfer.transferTo === this.currentTransfer.transferFrom) errors.push('Cannot tranfer to the same Account');
      return errors;
    },
    categoryErrors: function categoryErrors() {
      var errors = [];
      if (!this.$v.currentTransfer.category.$dirty) return errors;
      !this.$v.currentTransfer.category.required && errors.push('Category is required');
      return errors;
    },
    transferAmountErrors: function transferAmountErrors() {
      var errors = [];
      if (!this.$v.currentTransfer.transferAmount.$dirty) return errors;
      !this.$v.currentTransfer.transferAmount.minValue && errors.push('Transfer Amount must be at least 1');
      return errors;
    },
    currencyErrors: function currencyErrors() {
      var errors = [];
      if (!this.$v.currentTransfer.currency.$dirty) return errors;
      !this.$v.currentTransfer.currency.required && errors.push('Currency is required');
      return errors;
    },
    transferNameErrors: function transferNameErrors() {
      var errors = [];
      if (!this.$v.currentTransfer.transferName.$dirty) return errors;
      !this.$v.currentTransfer.transferName.required && errors.push('Transfer Name is required');
      return errors;
    },
    paymentTypeErrors: function paymentTypeErrors() {
      var errors = [];
      if (!this.$v.currentTransfer.paymentType.$dirty) return errors;
      !this.$v.currentTransfer.paymentType.required && errors.push('Payment Type is required');
      return errors;
    }
  },
  methods: {
    updateDateAndTime: function updateDateAndTime() {
      this.currentTransfer.transferDate = __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getCurrentDateForPicker();
      this.currentTransfer.transferTime = __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].getCurrentTimeForPicker();
    },
    buildAccountSelect: function buildAccountSelect() {
      var tempAccount = this.$store.state.Accounts;

      this.account.push({ header: 'Accounts' });

      for (var i = 0; i < tempAccount.length; i++) {
        this.account.push(tempAccount[i]);
      }

      //let group = this.$store.state.Groups

      //if (group.length > 0) {
      //  this.account.push({ header: 'Groups' })

      //  for (let i = 0; i < group.length; i++) {
      //    this.account.push(group[i])
      //  }
      //}
    },
    transferCheck: function transferCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.currentTransfer.transferAmount < 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.currentTransfer.transferAmount) || this.currentTransfer.transferAmount === "") {
        this.currentTransfer.transferAmount = 0;
      }

      if ($v.transferFrom.$invalid || $v.transferTo.$invalid || $v.category.$invalid || $v.transferAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
        return false;
      }

      return true;
    },
    addTransferCheck: function addTransferCheck($v) {
      if (this.transferCheck($v)) {
        this.addTransfer();
      }
    },
    addTransfer: function addTransfer() {
      __WEBPACK_IMPORTED_MODULE_3__javascript_transferManager__["a" /* transferManager */].addTransfer(this.currentTransfer);

      this.createTransactionIfNeeded();

      this.$router.push({ path: '/dashboard/transfer' });
    },

    createTransactionIfNeeded: function createTransactionIfNeeded() {
      if (this.checkIfTransactionIsNeeded) {
        __WEBPACK_IMPORTED_MODULE_3__javascript_transferManager__["a" /* transferManager */].createTransactionFromTransfer(this.currentTransfer);
      }
    },
    checkIfTransactionIsNeeded: function checkIfTransactionIsNeeded() {
      var today = new Date();
      var transferTime = new Date(this.currentTransfer.transferDate);

      if (today.getTime() === transferTime.getTime()) {
        return true;
      }

      return false;
    },
    selectedCurrencyChanged: function selectedCurrencyChanged() {
      ///////////////////////////////////////////////////////
      //Go Through Each Transaction Item 
      ///////////////////////////////////////////////////////

      //for (let i = 0; i < this.transferItems.length; i++) {
      //  ////////////////////////////////////////////////////////////////
      //  //Loop conversions and test if currency already found
      //  ///////////////////////////////////////////////////////////////

      //  for (let x = 0; x < this.conversions.length; x++) {
      //    if (this.transactionItems[i].itemCurrency === this.conversions[x]) {
      //      break
      //    } else if (x === this.conversions.length - 1) {
      //      this.getConversion(this.transactionItems[i].itemCurrency)
      //    }
      //  }
      //}
    }
  },
  beforeMount: function beforeMount() {

    this.transferItems = this.$store.state.Transfers;

    var cat = this.$store.state.Categories;
    for (var i = 0; i < cat.length; i++) {
      this.category.push(cat[i].categoryName);
    }

    var cur = this.$store.state.Currencies;
    for (var _i = 0; _i < cur.length; _i++) {
      this.currency.push(cur[_i].currencyName);
    }

    this.updateDateAndTime();
    this.buildAccountSelect();
  },

  validations: {
    currentTransfer: {
      transferName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      transferDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferTime: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      paymentType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferFrom: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferTo: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_transferManager__ = __webpack_require__(83);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  props: ['drawer'],
  data: function data() {
    return {
      paymentType: ["Cash", "Credit Card", "Debit Card", "Bank Transfer", "Voucher"],
      category: ["cat1", "cat2", "cat3", "cat4"],
      currency: ["JMD", "USD"],
      account: [],
      datemenu: false,
      timemenuvisibilty: false,
      editTransfer: {
        id: 0,
        currency: '',
        transferName: '',
        category: '',
        transferAmount: 0,
        comment: '',
        paymentType: '',

        transferFrom: '',
        transferTo: '',

        transferDate: '',
        transferTime: null,

        //State of Current Object
        objectState: 'New'
      },
      transferItems: []
    };
  },

  computed: {
    transferFromErrors: function transferFromErrors() {
      var errors = [];
      if (!this.$v.editTransfer.transferFrom.$dirty) return errors;
      !this.$v.editTransfer.transferFrom.required && errors.push('Tranfer from is required');
      return errors;
    },
    transferToErrors: function transferToErrors() {
      var errors = [];
      if (!this.$v.editTransfer.transferTo.$dirty) return errors;
      !this.$v.editTransfer.transferTo.required && errors.push('Tranfer to is required');
      if (this.editTransfer.transferTo === this.editTransfer.transferFrom) errors.push('Cannot tranfer to the same Account');
      return errors;
    },
    categoryErrors: function categoryErrors() {
      var errors = [];
      if (!this.$v.editTransfer.category.$dirty) return errors;
      !this.$v.editTransfer.category.required && errors.push('Category is required');
      return errors;
    },
    transferAmountErrors: function transferAmountErrors() {
      var errors = [];
      if (!this.$v.editTransfer.transferAmount.$dirty) return errors;
      !this.$v.editTransfer.transferAmount.minValue && errors.push('Transfer Amount must be at least 1');
      return errors;
    },
    currencyErrors: function currencyErrors() {
      var errors = [];
      if (!this.$v.editTransfer.currency.$dirty) return errors;
      !this.$v.editTransfer.currency.required && errors.push('Currency is required');
      return errors;
    },
    transferNameErrors: function transferNameErrors() {
      var errors = [];
      if (!this.$v.editTransfer.transferName.$dirty) return errors;
      !this.$v.editTransfer.transferName.required && errors.push('Transfer Name is required');
      return errors;
    },
    paymentTypeErrors: function paymentTypeErrors() {
      var errors = [];
      if (!this.$v.editTransfer.paymentType.$dirty) return errors;
      !this.$v.editTransfer.paymentType.required && errors.push('Payment Type is required');
      return errors;
    }
  },
  methods: {
    transferCheck: function transferCheck($v) {
      $v.$touch(); //Triggers Error Messages

      if (this.editTransfer.transferAmount < 0 || !__WEBPACK_IMPORTED_MODULE_2__javascript_globalFunctions__["a" /* globalFunctions */].isIntOrFloat(this.editTransfer.transferAmount) || this.editTransfer.transferAmount === "") {
        this.editTransfer.transferAmount = 0;
      }

      if ($v.transferFrom.$invalid || $v.transferTo.$invalid || $v.category.$invalid || $v.transferAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
        return false;
      }

      return true;
    },
    UpdateEditedTransfer: function UpdateEditedTransfer($v) {
      if (this.transferCheck($v)) {
        this.editTransfer.objectState = "Update";

        this.$store.commit('updateTransferinStore', this.editTransfer);

        __WEBPACK_IMPORTED_MODULE_3__javascript_transferManager__["a" /* transferManager */].updateTransactionFromTransfer(this.EditTransfer);

        this.$router.push({ path: '/dashboard/transfer' });
      }
    },
    EditTransfer: function EditTransfer(item) {
      for (var i = 0; i < this.transferItems.length; i++) {
        if (this.transferItems[i].id === parseInt(item)) {
          var editEntry = JSON.parse(JSON.stringify(this.transferItems[i]));
          this.editTransfer = editEntry;
          break;
        }
      }
    },
    selectedCurrencyChanged: function selectedCurrencyChanged() {
      ///////////////////////////////////////////////////////
      //Go Through Each Transaction Item
      ///////////////////////////////////////////////////////

      //for (let i = 0; i < this.transferItems.length; i++) {
      //  ////////////////////////////////////////////////////////////////
      //  //Loop conversions and test if currency already found
      //  ///////////////////////////////////////////////////////////////

      //  for (let x = 0; x < this.conversions.length; x++) {
      //    if (this.transactionItems[i].itemCurrency === this.conversions[x]) {
      //      break
      //    } else if (x === this.conversions.length - 1) {
      //      this.getConversion(this.transactionItems[i].itemCurrency)
      //    }
      //  }
      //}
    }
  },
  beforeMount: function beforeMount() {
    this.transferItems = this.$store.state.Transfers;

    var cat = this.$store.state.Categories;
    for (var i = 0; i < cat.length; i++) {
      this.category.push(cat[i].categoryName);
    }

    var cur = this.$store.state.Currencies;
    for (var _i = 0; _i < cur.length; _i++) {
      this.currency.push(cur[_i].currencyName);
    }

    this.account = this.$store.state.Accounts;

    this.EditTransfer(this.$route.params.itemId);
  },

  validations: {
    editTransfer: {
      transferName: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      category: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferAmount: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minValue: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minValue"])(1)
      },
      transferDate: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferTime: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      paymentType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      currency: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferFrom: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      transferTo: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  }

});

/***/ }),
/* 167 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 168 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 169 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_storeMain__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_polyfill__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a, {
  theme: {
    primary: "#2196F3",
    secondary: "#26A69A",
    accent: "#80CBC4",
    error: "#f44336",
    warning: "#ffeb3b",
    info: "#2196f3",
    success: "#4caf50"
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuelidate___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  },
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store_storeMain__["a" /* store */]
});

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71a10cb6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(212);
function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71a10cb6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */,
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BackgroundStyle-2",staticStyle:{"height":"100vh !important"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_index__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HomePage_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_userAccount_Login_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_userAccount_Registration_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_userAccount_ChangePassword_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_userAccount_Profile_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_settings_Settings_vue__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Notification_Notifications_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Notification_NotificationSingle_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_dashboard_Dashboard_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_dashboard_DashboardHome_vue__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_dashboard_navigationPages_BudgetData_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_dashboard_navigationPages_Extensions_vue__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_dashboard_navigationPages_MainNav_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_dashboard_navigationPages_Reminders_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_account_ViewAccounts_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_account_AddAccounts_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_account_EditAccounts_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_income_ViewIncomes_vue__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_income_AddIncomes_vue__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_income_EditIncomes_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_expense_ViewExpenses_vue__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_expense_AddExpenses_vue__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_expense_EditExpenses_vue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_budget_ViewBudgets_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_budget_AddBudgets_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_budget_EditBudgets_vue__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_transaction_ViewTransactions_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_transaction_AddTransaction_vue__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_transaction_EditTransaction_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_transfer_ViewTransfers_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_transfer_AddTransfers_vue__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_transfer_EditTransfers_vue__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_help_help_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Feedback_Suggestions_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Feedback_Issues_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Error_vue__ = __webpack_require__(378);






//import PasswordRecovery from '@/components/userAccount/PasswordRecovery.vue'




//Notification Floder Imports



//Dashboard Folder Imports



//Navigation Pages Folder Imports





//Account Folder Imports




//Income Folder Imports




//Expense Folder Imports




//Budget Folder Imports




//Transaction Folder Imports




//Transfer FolderImports




//Help Folder Imports


//Feedback Folder Imports



//Error Page


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/index.html', component: __WEBPACK_IMPORTED_MODULE_3__components_HomePage_vue__["a" /* default */] }, { path: '/', component: __WEBPACK_IMPORTED_MODULE_3__components_HomePage_vue__["a" /* default */] },

  //User Account Links
  { path: '/login', component: __WEBPACK_IMPORTED_MODULE_4__components_userAccount_Login_vue__["a" /* default */] }, { path: '/registration', component: __WEBPACK_IMPORTED_MODULE_5__components_userAccount_Registration_vue__["a" /* default */] },
  //{ path: '/PasswordRecovery', component: PasswordRecovery },
  { path: '/ChangePassword', component: __WEBPACK_IMPORTED_MODULE_6__components_userAccount_ChangePassword_vue__["a" /* default */] },

  //Dashboard Links
  {
    path: '/dashboard/', component: __WEBPACK_IMPORTED_MODULE_11__components_dashboard_Dashboard_vue__["a" /* default */],
    children: [
    // DashboardHome will be rendered inside Dashboard's <router-view>
    // when /Dashboard is matched
    { path: '', redirect: 'home' }, { path: 'home', component: __WEBPACK_IMPORTED_MODULE_12__components_dashboard_DashboardHome_vue__["a" /* default */] /*, meta: { requiresAuth: true }*/ },

    //Profile Page
    { path: 'profile', component: __WEBPACK_IMPORTED_MODULE_7__components_userAccount_Profile_vue__["default"] },

    //navigation Pages
    { path: 'budgetData', component: __WEBPACK_IMPORTED_MODULE_13__components_dashboard_navigationPages_BudgetData_vue__["default"] }, { path: 'extensions', component: __WEBPACK_IMPORTED_MODULE_14__components_dashboard_navigationPages_Extensions_vue__["default"] }, { path: 'mainNav', component: __WEBPACK_IMPORTED_MODULE_15__components_dashboard_navigationPages_MainNav_vue__["a" /* default */] }, { path: 'reminders', component: __WEBPACK_IMPORTED_MODULE_16__components_dashboard_navigationPages_Reminders_vue__["default"] },

    //Account Link
    { path: 'account', component: __WEBPACK_IMPORTED_MODULE_17__components_account_ViewAccounts_vue__["a" /* default */] }, { path: 'addAccount', component: __WEBPACK_IMPORTED_MODULE_18__components_account_AddAccounts_vue__["a" /* default */] }, { path: 'editAccount/:itemId', component: __WEBPACK_IMPORTED_MODULE_19__components_account_EditAccounts_vue__["a" /* default */] },

    //Income Link
    { path: 'income', component: __WEBPACK_IMPORTED_MODULE_20__components_income_ViewIncomes_vue__["a" /* default */] }, { path: 'AddIncome', component: __WEBPACK_IMPORTED_MODULE_21__components_income_AddIncomes_vue__["a" /* default */] }, { path: 'EditIncome/:itemId', component: __WEBPACK_IMPORTED_MODULE_22__components_income_EditIncomes_vue__["a" /* default */] },

    //Expense Link
    { path: 'expense', component: __WEBPACK_IMPORTED_MODULE_23__components_expense_ViewExpenses_vue__["a" /* default */] }, { path: 'addExpense', component: __WEBPACK_IMPORTED_MODULE_24__components_expense_AddExpenses_vue__["a" /* default */] }, { path: 'editExpense/:itemId', component: __WEBPACK_IMPORTED_MODULE_25__components_expense_EditExpenses_vue__["a" /* default */] },

    //Budget Link
    { path: 'budget', component: __WEBPACK_IMPORTED_MODULE_26__components_budget_ViewBudgets_vue__["a" /* default */] }, { path: 'addBudget', component: __WEBPACK_IMPORTED_MODULE_27__components_budget_AddBudgets_vue__["a" /* default */] }, { path: 'editBudget/:itemId', component: __WEBPACK_IMPORTED_MODULE_28__components_budget_EditBudgets_vue__["a" /* default */] },

    //Transaction Link
    { path: 'transaction', component: __WEBPACK_IMPORTED_MODULE_29__components_transaction_ViewTransactions_vue__["a" /* default */] }, { path: 'addTransaction', component: __WEBPACK_IMPORTED_MODULE_30__components_transaction_AddTransaction_vue__["a" /* default */] }, { path: 'editTransaction/:itemId', component: __WEBPACK_IMPORTED_MODULE_31__components_transaction_EditTransaction_vue__["a" /* default */] },

    //Transfer Link
    { path: 'transfer', component: __WEBPACK_IMPORTED_MODULE_32__components_transfer_ViewTransfers_vue__["a" /* default */] }, { path: 'addTransfer', component: __WEBPACK_IMPORTED_MODULE_33__components_transfer_AddTransfers_vue__["a" /* default */] }, { path: 'editTransfer/:itemId', component: __WEBPACK_IMPORTED_MODULE_34__components_transfer_EditTransfers_vue__["a" /* default */] },

    //Help Link
    { path: 'help', component: __WEBPACK_IMPORTED_MODULE_35__components_help_help_vue__["default"] },

    //Feedback Link
    { path: 'suggestions', component: __WEBPACK_IMPORTED_MODULE_36__components_Feedback_Suggestions_vue__["default"] }, { path: 'issues', component: __WEBPACK_IMPORTED_MODULE_37__components_Feedback_Issues_vue__["default"] },

    //Settings Page
    { path: 'settings/:itemId', component: __WEBPACK_IMPORTED_MODULE_8__components_settings_Settings_vue__["a" /* default */] },

    //Notifications Page
    { path: 'Notifications', component: __WEBPACK_IMPORTED_MODULE_9__components_Notification_Notifications_vue__["default"] }, { path: 'Notification/:itemId', component: __WEBPACK_IMPORTED_MODULE_10__components_Notification_NotificationSingle_vue__["a" /* default */] }]
  },

  //Error Page Links
  { path: '/Error', component: __WEBPACK_IMPORTED_MODULE_38__Error_vue__["a" /* default */], name: 'Error' }, { path: "*", component: __WEBPACK_IMPORTED_MODULE_38__Error_vue__["a" /* default */] }]
});

router.beforeEach(function (to, from, next) {
  if (to.meta.requiresAuth) {
    if (__WEBPACK_IMPORTED_MODULE_2__auth_index__["a" /* auth */].checkAuth()) {
      next();
    } else {
      next({ path: '/login' });
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 215 */,
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__ = __webpack_require__(112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a742ca5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__ = __webpack_require__(218);
function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a742ca5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a742ca5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"BackgroundStyle-2",attrs:{"flat":"","dark":""}},[_c('v-toolbar-title',[_vm._v("MyWalletWatcher")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ path: '/Login' })}}},[_vm._v("\n        Login\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"orange"},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ path: '/Registration' })}}},[_vm._v("\n        Sign up\n      ")])],1),_vm._v(" "),_c('v-container',{staticClass:"pa-5",attrs:{"fill-height":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md4":"","text-xs-center":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('img',{staticClass:"img-circle",attrs:{"src":__webpack_require__(219),"alt":"Mww Logo","width":"100%"}})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md8":""}},[_c('div',{staticClass:"pa-1"},[_c('span',{staticClass:"homeheadline grey--text"},[_vm._v(" "+_vm._s(_vm.homeheadline)+"  ")])]),_vm._v(" "),_c('div',{staticClass:"pa-1"},[_c('span',{staticClass:"homesubheadline grey--text"},[_vm._v(_vm._s(_vm.homesubheadline))])]),_vm._v(" "),_c('div',[_c('v-btn',{attrs:{"large":"","color":"teal"}},[_vm._v("\n            get started\n          ")])],1)])],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.cards),function(card){return _c('v-flex',{key:card.title,attrs:{"xs8":"","sm12":"","md4":"","offset-xs2":"","offset-sm0":""}},[_c('v-card',{staticClass:"elevation-5"},[_c('v-img',{attrs:{"src":card.src,"height":"200px"}}),_vm._v(" "),_c('v-card-title',[_c('div',{staticClass:"text-xs-center"},[_c('div',{staticClass:"headline"},[_vm._v(" "+_vm._s(card.title)+" ")]),_vm._v(" "),_c('span',{staticClass:"grey--text"},[_vm._v(" "+_vm._s(card.featureDescription))])])])],1)],1)}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/android-chrome-192x192.fd5b2bf.png";

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(113);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b09ee756_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(264);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b09ee756_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-toolbar',{staticClass:"BackgroundStyle-2",attrs:{"flat":"","dark":""}},[_c('v-toolbar-title',[_vm._v("MyWalletWatcher")])],1),_vm._v(" "),_c('v-container',{staticClass:"BackgroundStyle-2",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('div',{staticClass:"Logo1",attrs:{"width":"100%"}},[_c('img',{attrs:{"src":__webpack_require__(120),"alt":"My Wallet Watcher","align-center":""}})]),_vm._v(" "),_c('v-card',{staticClass:"elevation-3",attrs:{"transition":"scale-transition"}},[_c('v-card-text',[_c('v-form',[_c('div',[_c('v-alert',{attrs:{"type":"error","dismissible":"","value":true},model:{value:(_vm.showErrorMessage),callback:function ($$v) {_vm.showErrorMessage=$$v},expression:"showErrorMessage"}},[_vm._v("\n                    "+_vm._s(_vm.errorMessage)+"\n                  ")])],1),_vm._v(" "),_c('div',[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"email","label":"Email","type":"text","error-messages":_vm.emailErrors},on:{"input":function($event){_vm.$v.user.email.$touch()},"blur":function($event){_vm.$v.user.email.$touch()}},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('div',[_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"password","label":"Password","id":"password","type":"password","error-messages":_vm.passwordErrors},on:{"input":function($event){_vm.$v.user.password.$touch()},"blur":function($event){_vm.$v.user.password.$touch()}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1)])],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","loading":_vm.loading,"block":""},on:{"click":function($event){$event.preventDefault();_vm.ValCheck(_vm.$v.user)}}},[_vm._v("\n                Login\n              ")])],1),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[_c('a',{staticClass:"my-link",attrs:{"href":"./PasswordRecovery"}},[_vm._v(" Having trouble signing in? ")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-divider',{attrs:{"light":""}})],1),_vm._v(" "),_c('v-card-text',[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","block":""},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ path: '/Registration' })}}},[_vm._v("\n              Sign up\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8046ea6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__ = __webpack_require__(271);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8046ea6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-toolbar',{staticClass:"BackgroundStyle-2",attrs:{"flat":"","dark":""}},[_c('v-toolbar-title',[_vm._v("MyWalletWatcher")])],1),_vm._v(" "),_c('v-content',[_c('v-container',{staticClass:"BackgroundStyle-2",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm9":"","md6":""}},[_c('div',{staticClass:"Logo1",attrs:{"width":"100%"}},[_c('img',{attrs:{"src":__webpack_require__(120),"alt":"My Wallet Watcher","align-center":""}})]),_vm._v(" "),_c('v-card',{staticClass:"elevation-3"},[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.stepper),callback:function ($$v) {_vm.stepper=$$v},expression:"stepper"}},[_c('v-stepper-step',{attrs:{"step":"1","icon":"fa fa-user-wo","complete":_vm.stepper > 1}},[_vm._v("Personal Details")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-5",attrs:{"height":"350px"}},[_c('div',[_c('v-text-field',{attrs:{"label":"UserName","error-messages":_vm.userNameErrors},on:{"input":function($event){_vm.$v.user.userName.$touch()},"blur":function($event){_vm.$v.user.userName.$touch()}},model:{value:(_vm.user.userName),callback:function ($$v) {_vm.$set(_vm.user, "userName", $$v)},expression:"user.userName"}})],1),_vm._v(" "),_c('div',[_c('v-text-field',{attrs:{"label":"Email","error-messages":_vm.emailErrors},on:{"input":function($event){_vm.$v.user.email.$touch()},"blur":function($event){_vm.$v.user.email.$touch()}},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('div',[_c('v-autocomplete',{attrs:{"items":_vm.countries,"label":"Country","error-messages":_vm.countryNameErrors},on:{"input":function($event){_vm.$v.user.countryName.$touch()},"blur":function($event){_vm.$v.user.countryName.$touch()}},model:{value:(_vm.user.countryName),callback:function ($$v) {_vm.$set(_vm.user, "countryName", $$v)},expression:"user.countryName"}})],1),_vm._v(" "),_c('div',[_c('v-text-field',{attrs:{"label":"GCT","type":"number","error-messages":_vm.gctPercentageErrors},on:{"input":function($event){_vm.$v.user.gctPercentage.$touch()},"blur":function($event){_vm.$v.user.gctPercentage.$touch()}},model:{value:(_vm.user.gctPercentage),callback:function ($$v) {_vm.$set(_vm.user, "gctPercentage", $$v)},expression:"user.gctPercentage"}})],1),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Join Newsletter"},model:{value:(_vm.user.newsletter),callback:function ($$v) {_vm.$set(_vm.user, "newsletter", $$v)},expression:"user.newsletter"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"right",attrs:{"color":"primary","round":""},nativeOn:{"click":function($event){_vm.moveToSecondStep(_vm.$v.user)}}},[_vm._v("Continue")])],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","icon":"fa fa-unlock","complete":_vm.stepper > 2}},[_vm._v("Password")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-5",attrs:{"height":"350px"}},[_c('div',[_c('v-text-field',{attrs:{"label":"Password","append-icon":_vm.passwordShow ? 'visibility_off' : 'visibility',"type":_vm.passwordShow ? 'text' : 'password',"rules":[_vm.rules.strength],"error-messages":_vm.passwordErrors},on:{"input":function($event){_vm.$v.user.password.$touch()},"blur":function($event){_vm.$v.user.password.$touch()},"click:append":function($event){_vm.passwordShow = !_vm.passwordShow}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Confirm Password","append-icon":_vm.cpasswordShow ? 'visibility_off' : 'visibility',"type":_vm.cpasswordShow ? 'text' : 'password',"error-messages":_vm.cPasswordErrors},on:{"input":function($event){_vm.$v.user.cpassword.$touch()},"blur":function($event){_vm.$v.user.cpassword.$touch()},"click:append":function($event){_vm.cpasswordShow = !_vm.cpasswordShow}},model:{value:(_vm.user.cpassword),callback:function ($$v) {_vm.$set(_vm.user, "cpassword", $$v)},expression:"user.cpassword"}})],1)]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","round":""},nativeOn:{"click":function($event){_vm.stepper = 1}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{staticClass:"right",attrs:{"color":"primary","round":""},nativeOn:{"click":function($event){_vm.onComplete(_vm.$v.user)}}},[_vm._v("Finish")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","block":""},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ path: '/Login' })}}},[_vm._v("\n              Login\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_968d370c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__(273);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_968d370c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-container',{staticClass:"BackgroundStyle-1",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('div',{staticClass:"Logo1",attrs:{"width":"100%"}},[_c('img',{attrs:{"src":"/src/assets/Mww128.png","alt":"My Wallet Watcher","align-center":""}})]),_vm._v(" "),_c('v-card',{staticClass:"elevation-3"},[_c('v-card-text',[_c('v-card-title',{staticClass:"primary-title text-xs-center"},[_c('div',[_c('h3',{staticClass:"headline"},[_vm._v(" Set new password ")]),_vm._v(" "),_c('span',{staticClass:"grey--text"})])]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":true,"dismissible":""},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v("\n                Alert!\n              ")]),_vm._v(" "),_c('v-form',[_c('div',[_c('v-text-field',{attrs:{"prepend-icon":"lock_open","name":"password","label":"New Password","id":"newpassword","type":"password"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock_outline","name":"password","label":"Confirm Password","id":"confirmpassword","type":"password"}}),_vm._v(" "),_c('div')],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","block":""},on:{"click":function($event){$event.preventDefault();_vm.ValCheck(_vm.$v.user)}}},[_vm._v("\n                Change Password\n              ")])],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('div',[_c('br'),_vm._v("\n              have an account already? "),_c('a',{staticClass:"my-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ path: '/Login' })}}},[_vm._v(" Sign in ")])])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef8e9e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(275);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef8e9e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(124);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cdf33c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(286);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cdf33c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralSettings_vue__ = __webpack_require__(125);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688b3205_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralSettings_vue__ = __webpack_require__(279);
function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688b3205_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"height":"100%"},attrs:{"grid-list-md":"","justify-space-around":"True"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dense":""}},[_c('v-toolbar-title',[_vm._v("\n            MWW Options\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.editOptions)?_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.editOptions)?_c('v-btn',{attrs:{"slot":"activator","icon":""},nativeOn:{"click":function($event){_vm.editOptions = !_vm.editOptions}},slot:"activator"},[_c('v-icon',{attrs:{"small":"","color":"teal"}},[_vm._v("far fa-edit")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Edit")])],1):_vm._e(),_vm._v(" "),(!_vm.editOptions)?_c('v-tooltip',{attrs:{"bottom":""}},[(!_vm.editOptions)?_c('v-btn',{attrs:{"slot":"activator","icon":""},nativeOn:{"click":function($event){_vm.saveOptions = !_vm.saveOptions; _vm.editOptions = !_vm.editOptions}},slot:"activator"},[_c('v-icon',{attrs:{"small":"","color":"green"}},[_vm._v("far fa-save")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Save")])],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-list',{attrs:{"subheader":"","two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"subheader"},[_vm._v("Select currency")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","d-flex":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.editOptions,"items":_vm.currencies,"chips":!_vm.editOptions,"multiple":""},model:{value:(_vm.currency),callback:function ($$v) {_vm.currency=$$v},expression:"currency"}})],1)],1)],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"subheader"},[_vm._v("Tax (GCT) ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","d-flex":""}},[_c('v-text-field',{attrs:{"disabled":_vm.editOptions,"suffix":"%"},model:{value:(_vm.gct),callback:function ($$v) {_vm.gct=$$v},expression:"gct"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"subheader":"","three-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"subheader"},[_vm._v("Language preference")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","d-flex":""}},[_c('v-select',{attrs:{"color":"primary","solo":"","dense":"","disabled":true,"items":_vm.languages},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})],1)],1)],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"subheader"},[_vm._v("Country")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","d-flex":""}},[_c('v-autocomplete',{attrs:{"color":"primary","solo":"","dense":"","disabled":_vm.editOptions,"items":_vm.countries},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-card')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSettings_vue__ = __webpack_require__(126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f83d1ab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountSettings_vue__ = __webpack_require__(281);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f83d1ab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" Account ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecuritySettings_vue__ = __webpack_require__(127);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3375c246_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecuritySettings_vue__ = __webpack_require__(283);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecuritySettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3375c246_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecuritySettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" Security ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationSettings_vue__ = __webpack_require__(128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cec5302_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationSettings_vue__ = __webpack_require__(285);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cec5302_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"height":"100%"},attrs:{"grid-list-md":"","justify-space-around":"True"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dense":""}},[_c('v-toolbar-title',[_vm._v("\n            Alert Thresholds\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.editThreshod)?_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.editThreshod)?_c('v-btn',{attrs:{"slot":"activator","icon":""},nativeOn:{"click":function($event){_vm.editThreshod = !_vm.editThreshod}},slot:"activator"},[_c('v-icon',{attrs:{"small":"","color":"teal"}},[_vm._v("far fa-edit")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Edit")])],1):_vm._e(),_vm._v(" "),(!_vm.editThreshod)?_c('v-tooltip',{attrs:{"bottom":""}},[(!_vm.editThreshod)?_c('v-btn',{attrs:{"slot":"activator","icon":""},nativeOn:{"click":function($event){_vm.saveThreshod = !_vm.saveThreshod; _vm.editThreshod = !_vm.editThreshod}},slot:"activator"},[_c('v-icon',{attrs:{"small":"","color":"green"}},[_vm._v("far fa-save")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Save")])],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-switch',{attrs:{"disabled":_vm.editThreshod,"label":"Enable Alert Thresholds"},model:{value:(_vm.alertThreshods),callback:function ($$v) {_vm.alertThreshods=$$v},expression:"alertThreshods"}}),_vm._v(" "),(_vm.alertThreshods)?_c('v-list',{attrs:{"subheader":"","three-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"subheader"},[_vm._v("Send alert when balance drops below: ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","d-flex":""}},[_c('v-text-field',{attrs:{"disabled":_vm.editThreshod,"color":"red","prefix":"$"},model:{value:(_vm.lowbalance),callback:function ($$v) {_vm.lowbalance=$$v},expression:"lowbalance"}})],1)],1)],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"subheader"},[_vm._v("Send alert when transaction exceeds:  ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","d-flex":""}},[_c('v-text-field',{attrs:{"disabled":_vm.editThreshod,"color":"red","prefix":"$"},model:{value:(_vm.transactionlimit),callback:function ($$v) {_vm.transactionlimit=$$v},expression:"transactionlimit"}})],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"noPadding"},[_c('v-tabs',{attrs:{"slot":"extension","dense":"","slider-color":"orange"},slot:"extension",model:{value:(_vm.settingsmodel),callback:function ($$v) {_vm.settingsmodel=$$v},expression:"settingsmodel"}},[_c('v-tab',{attrs:{"href":'#GeneralSettings'}},[_vm._v("\n      General\n    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":'#AccountSettings'}},[_vm._v("\n      Account\n    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":'#SecuritySettings'}},[_vm._v("\n      Security\n    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":'#NotificationSettings'}},[_vm._v("\n      Notifications\n    ")]),_vm._v(" "),_c('v-tab-item',{attrs:{"id":'GeneralSettings'}},[_c('GeneralSettings')],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":'AccountSettings'}},[_c('AccountSettings')],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":'SecuritySettings'}},[_c('SecuritySettings')],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":'NotificationSettings'}},[_c('NotificationSettings')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b4e0b6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__(288);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b4e0b6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  This shows All Notifications\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationSingle_vue__ = __webpack_require__(130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c6a0c86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationSingle_vue__ = __webpack_require__(290);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationSingle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c6a0c86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationSingle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Single Notification Here\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44119493_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(298);
function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44119493_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomNav_vue__ = __webpack_require__(132);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c9b9c6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomNav_vue__ = __webpack_require__(295);
function injectStyle (ssrContext) {
  __webpack_require__(294)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c9b9c6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c9b9c6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-bottom-nav',{class:{'dark-mode':_vm.$store.state.NightMode.topNav == 'dark-mode','light-mode':_vm.$store.state.NightMode.topNav == 'light-mode'},attrs:{"value":true,"active":_vm.navSelection,"fixed":"","height":"62"},on:{"update:active":function($event){_vm.navSelection=$event}}},[_c('v-btn',{attrs:{"flat":"","value":"home"},on:{"click":function($event){_vm.$router.push({ path: '/dashboard/MainNav' })}}},[_c('span',[_vm._v("Home")]),_vm._v(" "),_c('v-badge',{attrs:{"color":"green","overlap":""}},[(_vm.mainMenuBadge !== '')?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(" "+_vm._s(_vm.mainMenuBadge)+" ")]):_vm._e(),_vm._v(" "),_c('v-icon',[_vm._v("home")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideNav_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f5c3e28_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideNav_vue__ = __webpack_require__(297);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f5c3e28_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{class:{'dark-mode':_vm.$store.state.NightMode.sideNav == 'dark-mode','light-mode':_vm.$store.state.NightMode.sideNav == 'light-mode', 'hidden-lg-and-up': 'hidden-lg-and-up'},attrs:{"flat":""}},[_c('v-toolbar-title',{staticClass:"ml-0",staticStyle:{"width":"260px"}},[_c('span',[_c('span',{staticStyle:{"color":"orange"}},[_vm._v("MyWallet")]),_vm._v("Watcher")])])],1),_vm._v(" "),_c('v-tabs',{attrs:{"grow":"","color":"SideNavTab"}},[_c('v-tabs-slider',{attrs:{"color":"orange"}}),_vm._v(" "),_c('v-tab',{class:{'dark-mode':_vm.$store.state.NightMode.sideNav == 'dark-mode','light-mode':_vm.$store.state.NightMode.sideNav == 'light-mode'},attrs:{"href":'#MainMenu'}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-badge',{attrs:{"slot":"activator","color":"green","overlap":""},slot:"activator"},[(_vm.mainMenuBadge !== '')?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(" "+_vm._s(_vm.mainMenuBadge)+" ")]):_vm._e(),_vm._v(" "),_c('v-icon',[_vm._v("home")])],1),_vm._v(" "),_c('span',[_vm._v("Home")])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":'MainMenu'}},[_c('v-list',{staticClass:"noPadding",attrs:{"dense":""}},[_vm._l((_vm.items),function(item){return [(item.children)?_c('v-list-group',{key:item.text,attrs:{"prepend-icon":item.model ? item.icon : item['icon-alt'],"append-icon":item.model ? item.iconend : item['iconend-alt']},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                  "+_vm._s(item.text)+"\n                ")])],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i,attrs:{"to":child.link},on:{"click":function($event){}}},[(child.icon)?_c('v-list-tile-action',{staticClass:"text-xs-center"},[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                  "+_vm._s(child.text)+"\n                ")])],1)],1)})],2):_c('v-list-tile',{key:item.text,attrs:{"to":item.link},on:{"click":function($event){}}},[_c('v-list-tile-action',{staticClass:"text-xs-center"},[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(item.text)+"\n              ")])],1)],1)]})],2)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":'Extensions'}},[[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('span',[_vm._v(" No Extensions ")])])],1)],1)]],2),_vm._v(" "),_c('v-tab-item',{attrs:{"id":'BudgetData'}},[[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('span',[_vm._v(" No Statistics ")])])],1)],1)]],2),_vm._v(" "),_c('v-tab-item',{attrs:{"id":'Notifications'}},[[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('span',[_vm._v(" No new Notifications ")])])],1)],1)]],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.$vuetify.dark}},[_c('v-navigation-drawer',{class:{'dark-mode':_vm.$store.state.NightMode.sideNav == 'dark-mode','light-mode':_vm.$store.state.NightMode.sideNav == 'light-mode'},attrs:{"touchless":"","clipped":_vm.$vuetify.breakpoint.lgAndUp,"app":"","width":"260","flat":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('SideNav')],1),_vm._v(" "),_c('v-toolbar',{class:{'dark-mode':_vm.$store.state.NightMode.topNav == 'dark-mode','light-mode':_vm.$store.state.NightMode.topNav == 'light-mode', 'topnav': 'topnav'},attrs:{"flat":"","app":"","clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"fixed":"","dense":""}},[_c('v-toolbar-title',{staticClass:"ml-0",staticStyle:{"width":"260px"}},[_c('v-toolbar-side-icon',{staticClass:"hidden-sm-and-down",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('span',[_c('span',{staticStyle:{"color":"orange"}},[_vm._v("MyWallet")]),_vm._v("Watcher")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","left":"","close-on-content-click":true}},[_c('v-btn',{attrs:{"slot":"activator","flat":""},on:{"click":function($event){_vm.dropdown = !_vm.dropdown}},slot:"activator"},[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('img',{attrs:{"src":__webpack_require__(135),"alt":"MWW"}})]),_vm._v(" "),(!_vm.dropdown)?_c('v-icon',[_vm._v(" arrow_drop_down")]):_c('v-icon',[_vm._v(" arrow_drop_up")])],1),_vm._v(" "),_c('v-card',{attrs:{"width":"255"}},[_c('v-list',{staticClass:"cktoolbar"},[_c('v-list-tile',{staticClass:"nohover",attrs:{"avatar":""},on:{"click":function($event){}}},[_c('v-list-tile-avatar',{attrs:{"icon":""}},[_c('img',{staticClass:"elevation-1",attrs:{"src":__webpack_require__(135),"alt":"DevTeam"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(" Dev Team ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Pro")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.account),function(item){return [(item.switch === 'switch')?_c('v-list-tile',{key:item.title,attrs:{"avatar":""},on:{"click":item.func}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-action',[_c('v-switch',{model:{value:(_vm.darkModeSwitch),callback:function ($$v) {_vm.darkModeSwitch=$$v},expression:"darkModeSwitch"}})],1)],1)],1):_c('v-list-tile',{key:item.title,attrs:{"avatar":""},on:{"click":item.func}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)]}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.mwwmenu),function(item){return _c('v-list-tile',{key:item.title,attrs:{"avatar":""},on:{"click":item.func}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.subtitle))])],1)],1)})],2)],1)],1)],1),_vm._v(" "),_c('v-content',[_c('v-container',{staticClass:"noPadding",staticStyle:{"height":"100%"},attrs:{"fluid":""}},[_c('v-layout',{staticClass:"noPadding",staticStyle:{"height":"100%"},attrs:{"justify-center":"","align-center":""}},[_c('v-container',{staticClass:"noPadding",staticStyle:{"height":"100%","overflow":"auto","padding-bottom":"50px"},attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticStyle:{"overflow-y":"auto","height":"100%"},attrs:{"drawer":_vm.drawer}})],1)],1)],1)],1),_vm._v(" "),_c('v-container',{staticClass:"hidden-md-and-up"},[_c('bottomnav')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardHome_vue__ = __webpack_require__(136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cddaf3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardHome_vue__ = __webpack_require__(300);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cddaf3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('span',[_vm._v(" Welcome To My   Wallet Watcher ")])])],1)],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetData_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetData_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f8efa4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetData_vue__ = __webpack_require__(302);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetData_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f8efa4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Feature Not Available")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Coming Soon")]),_vm._v(" "),_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-frown")])],1)],1)],1)],1)]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Extensions_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Extensions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Extensions_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_883a2d36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Extensions_vue__ = __webpack_require__(304);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Extensions_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_883a2d36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Extensions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Feature Not Available")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Coming Soon")]),_vm._v(" "),_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-frown")])],1)],1)],1)],1)]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainNav_vue__ = __webpack_require__(139);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5daf183f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainNav_vue__ = __webpack_require__(306);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5daf183f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"noPadding",staticStyle:{"height":"100%"},attrs:{"dense":""}},[_vm._l((_vm.items),function(item){return [(item.children)?_c('v-list-group',{key:item.text,attrs:{"prepend-icon":item.model ? item.icon : item['icon-alt'],"append-icon":item.model ? item.iconend : item['iconend-alt']},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n            "+_vm._s(item.text)+"\n          ")])],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i,attrs:{"to":child.link},on:{"click":function($event){}}},[(child.icon)?_c('v-list-tile-action',{staticClass:"text-xs-center"},[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n            "+_vm._s(child.text)+"\n          ")])],1)],1)})],2):_c('v-list-tile',{key:item.text,attrs:{"to":item.link},on:{"click":function($event){}}},[_c('v-list-tile-action',{staticClass:"text-xs-center"},[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])],1)],1)]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reminders_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reminders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reminders_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c958410e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reminders_vue__ = __webpack_require__(308);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reminders_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c958410e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reminders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Feature Not Available")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Coming Soon")]),_vm._v(" "),_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-frown")])],1)],1)],1)],1)]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewAccounts_vue__ = __webpack_require__(141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60f86030_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewAccounts_vue__ = __webpack_require__(318);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewAccounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60f86030_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewAccounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountData_vue__ = __webpack_require__(143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f115c7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountData_vue__ = __webpack_require__(312);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f115c7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n        Amount in account: "+_vm._s(_vm.account.accountCurrency)+" "+_vm._s(_vm.account.accountAmount)+"\n      ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n        Account Type: "+_vm._s(_vm.account.accountType)+"\n      ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n        Account Description: "+_vm._s(_vm.account.accountDescription)+"\n      ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetData_vue__ = __webpack_require__(144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa95658e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetData_vue__ = __webpack_require__(314);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa95658e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('v-progress-circular',{staticStyle:{"margin-left":"10px"},attrs:{"size":90,"width":15,"value":_vm.percentage(_vm.budget.amountSpent, _vm.budget.budgetAmount),"color":_vm.colorSelector(_vm.percentage(_vm.budget.amountSpent, _vm.budget.budgetAmount))}},[_vm._v("\n        "+_vm._s(_vm.percentage(_vm.budget.amountSpent, _vm.budget.budgetAmount))+"%\n      ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_vm._v(" Type: "+_vm._s(_vm.budget.budgetType)+" ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_vm._v(" Amount: "+_vm._s(_vm.budget.budgetAmount))]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_vm._v("Account: "+_vm._s(_vm.budget.account)+" ")]),_vm._v(" "),(_vm.budget.budget !== 'None')?_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_vm._v("Budget: "+_vm._s(_vm.budget.budget))]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_vm._v("Category: "+_vm._s(_vm.budget.category))]),_vm._v(" "),(_vm.budget.Type === 'OneTime')?[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_vm._v(" Date: "+_vm._s(_vm.budget.Date))]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_vm._v("Comment: "+_vm._s(_vm.budget.comment))])]:_vm._e(),_vm._v(" "),(_vm.budget.Type === 'Recurring')?[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_vm._v("Repeat Every "+_vm._s(_vm.budget.repeat)+" "+_vm._s(_vm.budget.cycle)+"   "),(_vm.budget.period === 'Forever')?_c('span',[_vm._v(" "+_vm._s(_vm.budget.period)+" ")]):_vm._e(),(_vm.budget.period !== 'Forever')?_c('span',[_vm._v("For "+_vm._s(_vm.budget.numberOfCycles)+" "+_vm._s(_vm.budget.cycle)+"s")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_vm._v("Goes Off First On: "+_vm._s(_vm.budget.goesOffFirst))]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_vm._v("Comment: "+_vm._s(_vm.budget.comment))])]:_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferData_vue__ = __webpack_require__(145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cc05a3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferData_vue__ = __webpack_require__(316);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cc05a3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("This is transfer data")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"padContainer",attrs:{"xs12":"","md6":"","lg4":""}},[_c('v-card',{class:{'dark-mode':_vm.$store.state.NightMode.sideNav == 'dark-mode','light-mode':_vm.$store.state.NightMode.sideNav == 'light-mode'},staticStyle:{"width":"100%","margin-bottom":"1px"},nativeOn:{"click":function($event){_vm.lItem.show = !_vm.lItem.show}}},[_c('v-container',{staticStyle:{"padding":"10px"},attrs:{"fluid":""}},[_c('v-card-text',{staticStyle:{"padding":"2px"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticStyle:{"font-size":"1.3em"}},[_vm._v(_vm._s(_vm.lItem.name))])]),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"right"},attrs:{"xs6":""}},[(_vm.lItem.date !== '')?_c('span',[_vm._v(_vm._s(_vm.lItem.date))]):_vm._e(),_vm._v(" "),(_vm.lItem.type !== '' && _vm.lItem.date === '')?_c('span',[_vm._v(_vm._s(_vm.lItem.type))]):_vm._e()]),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"right"},attrs:{"xs12":""}},[_c('span',[_vm._v(_vm._s(_vm.lItem.currency)+" "+_vm._s(_vm.lItem.amount))])])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.lItem.show),callback:function ($$v) {_vm.$set(_vm.lItem, "show", $$v)},expression:"lItem.show"}},[_c('v-card',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.lItem.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"icon":"","flat":""},nativeOn:{"click":function($event){_vm.lItem.show = false}}},[_c('v-icon',[_vm._v("fas fa-backspace")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticStyle:{"width":"170px","margin-left":"auto","margin-right":"auto","border-radius":"0 0 28px 28px"},attrs:{"flat":""}},[_c('v-btn',{staticClass:"mx-0",staticStyle:{"margin-left":"15px !important"},attrs:{"icon":""},on:{"click":function($event){$event.preventDefault();_vm.redirectToEditPage(_vm.lItem.id)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",staticStyle:{"margin-right":"15px !important"},attrs:{"icon":""},on:{"click":function($event){$event.preventDefault();_vm.DeleteItem(_vm.lItem.id)}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"100%"}},[(_vm.liItem.type === 'account')?_c('AccountData',{attrs:{"accountId":_vm.lItem.id}}):_vm._e(),_vm._v(" "),(_vm.liItem.type === 'budget')?_c('BudgetData',{attrs:{"budgetId":_vm.lItem.id}}):_vm._e(),_vm._v(" "),(_vm.liItem.type === 'transfer')?_c('TransferData',{attrs:{"transferId":_vm.lItem.id}}):_vm._e()],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"card-flex-toolbar noPadding",staticStyle:{"width":"100%"},attrs:{"fluid":"","scrollable":""}},[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Accounts")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","flat":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ path: '/dashboard/addaccount' })}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-plus")])],1),_vm._v(" "),_c('span',[_vm._v("Add Account")])],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"direction":_vm.direction,"transition":_vm.transition},model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","small":"","fab":""},slot:"activator",model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-icon',[_vm._v("fas fa-ellipsis-v")]),_vm._v(" "),_c('v-icon',[_vm._v("fas fa-times")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewSearch = !_vm.viewSearch}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-search")])],1),_vm._v(" "),_c('span',[_vm._v("Search")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewFilter = !_vm.viewFilter}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-filter")])],1),_vm._v(" "),_c('span',[_vm._v("Filter")])],1)],1)],1),_vm._v(" "),_c('v-container',{class:{'padContent': !_vm.drawer},staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.viewSearch && !_vm.viewFilter)?[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Search","append-icon":"fas fa-search"},on:{"change":_vm.getSearchItems,"input":_vm.getSearchItems},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]:_vm._e(),_vm._v(" "),(_vm.itemsMinusDeleted.length === 0)?[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Sorry, There is currently no data to display here")]),_vm._v(" "),_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-frown")])],1)],1)],1)],1)]:_vm._e(),_vm._v(" "),_vm._l((_vm.itemsMinusDeleted),function(itemMinus){return _c('ListItem',{key:itemMinus.id,ref:"listItem",refInFor:true,attrs:{"liItem":{type: 'account',data: itemMinus}},on:{"Edit":function($event){_vm.redirectToEditPage($event)},"Delete":function($event){_vm.DeleteAccount($event)}}})})],2)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete")]),_vm._v(" "),_c('v-card-text',[_vm._v("Are you sure you want to delete "),_c('b',[_vm._v("\""+_vm._s(_vm.deleteAccount.accountName)+"\"")]),_vm._v("?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.DeleteAccountAccept()}}},[_vm._v("Yes")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAccounts_vue__ = __webpack_require__(146);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_baceba68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAccounts_vue__ = __webpack_require__(320);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAccounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_baceba68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAccounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("New Account")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.AddAccountCheck(_vm.$v.currentAccount)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/account' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Account Name","error-messages":_vm.accountNameErrors},on:{"input":function($event){_vm.$v.currentAccount.accountName.$touch()},"blur":function($event){_vm.$v.currentAccount.accountName.$touch()}},model:{value:(_vm.currentAccount.accountName),callback:function ($$v) {_vm.$set(_vm.currentAccount, "accountName", $$v)},expression:"currentAccount.accountName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.types,"label":"Account Type","error-messages":_vm.accountTypeErrors},on:{"input":function($event){_vm.$v.currentAccount.accountType.$touch()},"blur":function($event){_vm.$v.currentAccount.accountType.$touch()}},model:{value:(_vm.currentAccount.accountType),callback:function ($$v) {_vm.$set(_vm.currentAccount, "accountType", $$v)},expression:"currentAccount.accountType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Account Description"},model:{value:(_vm.currentAccount.accountDescription),callback:function ($$v) {_vm.$set(_vm.currentAccount, "accountDescription", $$v)},expression:"currentAccount.accountDescription"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Account Amount","type":"number","min":"0"},model:{value:(_vm.currentAccount.accountAmount),callback:function ($$v) {_vm.$set(_vm.currentAccount, "accountAmount", $$v)},expression:"currentAccount.accountAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":"Account Currency","items":_vm.curriences,"error-messages":_vm.accountCurrencyErrors},on:{"input":function($event){_vm.$v.currentAccount.accountCurrency.$touch()},"blur":function($event){_vm.$v.currentAccount.accountCurrency.$touch()}},model:{value:(_vm.currentAccount.accountCurrency),callback:function ($$v) {_vm.$set(_vm.currentAccount, "accountCurrency", $$v)},expression:"currentAccount.accountCurrency"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAccounts_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca9b116_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAccounts_vue__ = __webpack_require__(322);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAccounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca9b116_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAccounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Edit Account")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.UpdateEditedAccount(_vm.$v.editAccount)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/account' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-top":"0"}},[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Account Name","error-messages":_vm.accountNameErrors},on:{"input":function($event){_vm.$v.editAccount.accountName.$touch()},"blur":function($event){_vm.$v.editAccount.accountName.$touch()}},model:{value:(_vm.editAccount.accountName),callback:function ($$v) {_vm.$set(_vm.editAccount, "accountName", $$v)},expression:"editAccount.accountName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.types,"label":"Account Type","error-messages":_vm.accountTypeErrors},on:{"input":function($event){_vm.$v.editAccount.accountType.$touch()},"blur":function($event){_vm.$v.editAccount.accountType.$touch()}},model:{value:(_vm.editAccount.accountType),callback:function ($$v) {_vm.$set(_vm.editAccount, "accountType", $$v)},expression:"editAccount.accountType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Account Description"},model:{value:(_vm.editAccount.accountDescription),callback:function ($$v) {_vm.$set(_vm.editAccount, "accountDescription", $$v)},expression:"editAccount.accountDescription"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":"Account Currency","items":_vm.curriences,"error-messages":_vm.accountCurrencyErrors},on:{"input":function($event){_vm.$v.editAccount.accountCurrency.$touch()},"blur":function($event){_vm.$v.editAccount.accountCurrency.$touch()}},model:{value:(_vm.editAccount.accountCurrency),callback:function ($$v) {_vm.$set(_vm.editAccount, "accountCurrency", $$v)},expression:"editAccount.accountCurrency"}})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewIncomes_vue__ = __webpack_require__(148);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba1efc1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewIncomes_vue__ = __webpack_require__(334);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewIncomes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba1efc1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewIncomes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 324 */,
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
  version: '', //Cache App Version
  AccountType: '', //Account Type of Current User
  Accounts: [],
  Bills: [],
  Budgets: [],
  Categories: [],
  Currencies: [],
  CurrencyConversions: [],
  Expenses: [],
  Incomes: [],
  Items: [],
  Notifications: [],
  Transactions: [],
  TransactionItems: [],
  Transfers: [],

  //Saves Night Mode Selection on device
  NightMode: {
    switch: '',
    topNav: 'light-mode',
    sideNav: 'light-mode',
    itemCard: 'itemCardlight'
  }

};

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(134);
var _this = this;



var mutations = {

  //////////////////////////////////////////////////////////////////////////
  //LocalStorage Mutations
  //////////////////////////////////////////////////////////////////////////

  initialiseStore: function initialiseStore(state) {
    // Check if the store exists
    if (localStorage.getItem('store')) {
      var store = JSON.parse(localStorage.getItem('store'));

      // Check the version stored against current. If different, don't
      // load the cached version
      if (store.version === __WEBPACK_IMPORTED_MODULE_0__version__["a" /* version */]) {
        this.replaceState(Object.assign(state, store));
      } else {
        state.version = __WEBPACK_IMPORTED_MODULE_0__version__["a" /* version */];
      }
    }
  },


  //////////////////////////////////////////////////////////////////////////
  //End Of LocalStorage Mutations
  //////////////////////////////////////////////////////////////////////////


  //////////////////////////////////////////////////////////////////////////
  //Account Mutations
  //////////////////////////////////////////////////////////////////////////

  //checkifAccountAlreadyExist: function (state, account) {
  //  if (state.Accounts.length === 0) { return false }

  //  for (var x = 0; x < state.Accounts.length; x++) {
  //    if (state.Accounts[x].id === account.id) { return false }
  //  }
  //  return true
  // },
  updateStoreWithAccountsDataFromAPI: function updateStoreWithAccountsDataFromAPI(state, accounts) {
    if (accounts.length > 0) {
      for (var i = 0; i < accounts.length; i++) {
        var ifExist = true;

        for (var x = 0; x < state.Accounts.length; x++) {
          if (state.Accounts[x].id === accounts[i].id) {
            ifExist = false;
          }
        }

        if (ifExist) {
          state.Accounts.push(accounts[i]);
        }
      }
    }
  },
  addNewAccountToStore: function addNewAccountToStore(state, account) {
    state.Accounts.push(account);
  },
  updateAccountinStore: function updateAccountinStore(state, account) {
    for (var i = 0; i < state.Accounts.length; i++) {
      if (state.Accounts[i].id === account.id) {
        state.Accounts[i].accountName = account.accountName;
        state.Accounts[i].accountType = account.accountType;
        state.Accounts[i].objectState = account.objectState;
        break;
      }
    }
  },
  markAccountAsDeleted: function markAccountAsDeleted(state, account) {
    for (var i = 0; i < state.Accounts.length; i++) {
      if (state.Accounts[i].id === account.id) {
        state.Accounts[i].objectState = account.objectState;
        break;
      }
    }
  },
  deleteAccountfromStore: function deleteAccountfromStore(state, account) {
    for (var i = 0; i < state.Accounts.length; i++) {
      if (state.Accounts[i].id === account.id) {
        state.Accounts.splice(i, 1);
        break;
      }
    }
  },

  addAmountToAccount: function addAmountToAccount(state, data) {
    //Find Account
    for (var i = 0; i < state.Accounts.length; i++) {
      if (state.Accounts[i].accountName === data.account) {

        if (state.Accounts[i].accountAmount === null || state.Accounts[i].accountAmount === '' || state.Accounts[i].accountAmount === undefined) {
          state.Accounts[i].accountAmount = 0;
        }

        //Add Amount to Account
        state.Accounts[i].accountAmount = parseFloat(state.Accounts[i].accountAmount) + parseFloat(data.amount);
      }
    }
  },
  subtractAmountFromAccount: function subtractAmountFromAccount(state, data) {
    //Find Account
    for (var i = 0; i < state.Accounts.length; i++) {
      if (state.Accounts[i].accountName === data.account) {

        if (state.Accounts[i].accountAmount === null || state.Accounts[i].accountAmount === '' || state.Accounts[i].accountAmount === undefined) {
          state.Accounts[i].accountAmount = 0;
        }

        //Subtract Amount from Account
        state.Accounts[i].accountAmount = parseFloat(state.Accounts[i].accountAmount) - parseFloat(data.amount);
      }
    }
  },

  //////////////////////////////////////////////////////////////////////////
  //End Of Account Mutations
  //////////////////////////////////////////////////////////////////////////


  //////////////////////////////////////////////////////////////////////////
  //Income Mutations
  //////////////////////////////////////////////////////////////////////////

  //checkIfIncomeAlreadyExist: function (state, income) {
  //  if (state.Incomes.length === 0) { return false }

  //  for (var x = 0; x < state.Incomes.length; x++) {
  //    if (state.Incomes[x].id === income.id) { return false }
  //  }
  //  return true
  //},
  updateStoreWithIncomeDataFromAPI: function updateStoreWithIncomeDataFromAPI(state, data) {

    var incomes = data[0];
    var accounts = data[1];

    if (incomes.length > 0) {
      for (var i = 0; i < incomes.length; i++) {
        var ifExist = true;

        for (var x = 0; x < state.Incomes.length; x++) {
          if (state.Incomes[x].id === incomes[i].id) {
            ifExist = false;
          }
        }

        if (ifExist) {
          state.Incomes.push(incomes[i]);
        }
      }
    }

    _this.updateStoreWithAccountsDataFromAPI(accounts);
  },
  addNewIncomeToStore: function addNewIncomeToStore(state, income) {
    state.Incomes.push(income);
  },
  updateIncomeinStore: function updateIncomeinStore(state, income) {
    for (var i = 0; i < state.Incomes.length; i++) {
      if (state.Incomes[i].id === income.id) {
        state.Incomes[i].incomeName = income.incomeName;
        state.Incomes[i].incomeType = income.incomeType;
        state.Incomes[i].incomeAmount = income.incomeAmount;
        state.Incomes[i].incomeDate = income.incomeDate;
        state.Incomes[i].comment = income.comment;
        state.Incomes[i].category = income.category;
        state.Incomes[i].account = income.account;
        state.Incomes[i].repeat = income.repeat;
        state.Incomes[i].cycle = income.cycle;
        state.Incomes[i].period = income.period;
        state.Incomes[i].numberOfCycles = income.numberOfCycles;
        state.Incomes[i].goesOffFirst = income.goesOffFirst;
        state.Incomes[i].objectState = income.objectState;
        break;
      }
    }
  },
  markIncomeAsDeleted: function markIncomeAsDeleted(state, income) {
    for (var i = 0; i < state.Incomes.length; i++) {
      if (state.Incomes[i].id === income.id) {
        state.Incomes[i].objectState = income.objectState;
        break;
      }
    }
  },
  deleteIncomefromStore: function deleteIncomefromStore(state, income) {
    for (var i = 0; i < state.Incomes.length; i++) {
      if (state.Incomes[i].id === income.id) {
        state.Incomes.splice(i, 1);
        break;
      }
    }
  },

  //////////////////////////////////////////////////////////////////////////
  //End Of Income Mutations
  //////////////////////////////////////////////////////////////////////////


  //////////////////////////////////////////////////////////////////////////
  //Expense Mutations
  //////////////////////////////////////////////////////////////////////////

  //checkIfExpenseAlreadyExist: function (state, expense) {
  //  if (state.Expenses.length === 0) { return false }

  //  for (var x = 0; x < state.Expenses.length; x++) {
  //    if (state.Expenses[x].id === expense.id) { return false }
  //  }
  //  return true
  //},
  updateStoreWithExpenseDataFromAPI: function updateStoreWithExpenseDataFromAPI(state, data) {

    var expenses = data[0];
    var accounts = data[1];

    if (expenses.length > 0) {
      for (var i = 0; i < expenses.length; i++) {
        var ifExist = true;

        for (var x = 0; x < state.Expenses.length; x++) {
          if (state.Expenses[x].id === expenses[i].id) {
            ifExist = false;
          }
        }

        if (ifExist) {
          state.Expenses.push(expenses[i]);
        }
      }
    }

    _this.updateStoreWithAccountsDataFromAPI(accounts);
  },
  addNewExpenseToStore: function addNewExpenseToStore(state, expense) {
    state.Expenses.push(expense);
  },
  updateExpenseinStore: function updateExpenseinStore(state, expense) {
    for (var i = 0; i < state.Expenses.length; i++) {
      if (state.Expenses[i].id === expense.id) {
        state.Expenses[i].expenseName = expense.expenseName;
        state.Expenses[i].expenseType = expense.expenseType;
        state.Expenses[i].expenseAmount = expense.expenseAmount;
        state.Expenses[i].expenseDate = expense.expenseDate;
        state.Expenses[i].comment = expense.comment;
        state.Expenses[i].category = expense.category;
        state.Expenses[i].account = expense.account;
        state.Expenses[i].repeat = expense.repeat;
        state.Expenses[i].cycle = expense.cycle;
        state.Expenses[i].period = expense.period;
        state.Expenses[i].numberOfCycles = expense.numberOfCycles;
        state.Expenses[i].goesOffFirst = expense.goesOffFirst;
        state.Expenses[i].objectState = expense.objectState;
        break;
      }
    }
  },
  markExpenseAsDeleted: function markExpenseAsDeleted(state, expense) {
    for (var i = 0; i < state.Expenses.length; i++) {
      if (state.Expenses[i].id === expense.id) {
        state.Expenses[i].objectState = expense.objectState;
        break;
      }
    }
  },
  deleteExpensefromStore: function deleteExpensefromStore(state, expense) {
    for (var i = 0; i < state.Expenses.length; i++) {
      if (state.Expenses[i].id === expense.id) {
        state.Expenses.splice(i, 1);
        break;
      }
    }
  },

  //////////////////////////////////////////////////////////////////////////
  //End Of Expense Mutations
  //////////////////////////////////////////////////////////////////////////


  //////////////////////////////////////////////////////////////////////////
  //Budget Mutations
  //////////////////////////////////////////////////////////////////////////

  updateStoreWithBudgetDataFromAPI: function updateStoreWithBudgetDataFromAPI(state, data) {},
  addNewBudgetToStore: function addNewBudgetToStore(state, budget) {
    state.Budgets.push(budget);
  },
  updateBudgetinStore: function updateBudgetinStore(state, budget) {
    for (var i = 0; i < state.Budgets.length; i++) {
      if (state.Budgets[i].id === budget.id) {
        state.Budgets[i].budgetName = budget.budgetName;
        state.Budgets[i].budgetType = budget.budgetType;
        state.Budgets[i].budgetAmount = budget.budgetAmount;
        state.Budgets[i].comment = budget.comment;
        state.Budgets[i].category = budget.category;
        state.Budgets[i].account = budget.account;
        state.Budgets[i].amountSpent = budget.amountSpent;
        state.Budgets[i].refillAmount = budget.refillAmount;
        state.Budgets[i].budgetOverspent = budget.budgetOverspent;
        state.Budgets[i].OverspendingRisk = budget.OverspendingRisk;
        state.Budgets[i].objectState = budget.objectState;
        break;
      }
    }
  },
  markBudgetAsDeleted: function markBudgetAsDeleted(state, budget) {
    for (var i = 0; i < state.Budgets.length; i++) {
      if (state.Budgets[i].id === budget.id) {
        state.Budgets[i].objectState = budget.objectState;
        break;
      }
    }
  },
  deleteBudgetfromStore: function deleteBudgetfromStore(state, budget) {
    for (var i = 0; i < state.Budgets.length; i++) {
      if (state.Budgets[i].id === budget.id) {
        state.Budgets.splice(i, 1);
        break;
      }
    }
  },

  //////////////////////////////////////////////////////////////////////////
  //End Of Budget Mutations
  //////////////////////////////////////////////////////////////////////////


  //////////////////////////////////////////////////////////////////////////
  //Transaction Mutations
  //////////////////////////////////////////////////////////////////////////

  updateStoreWithTransactionDataFromAPI: function updateStoreWithTransactionDataFromAPI(state, data) {},
  addNewTransactionToStore: function addNewTransactionToStore(state, transaction) {
    state.Transactions.push(transaction);
  },
  updateTransactioninStore: function updateTransactioninStore(state, transaction) {
    for (var i = 0; i < state.Transactions.length; i++) {
      if (state.Transactions[i].id === transaction.id) {
        state.Transactions[i].budget = transaction.budget;
        state.Transactions[i].cycle = transaction.cycle;
        state.Transactions[i].goesOffFirst = transaction.goesOffFirst;
        state.Transactions[i].items = transaction.items;
        state.Transactions[i].numberOfCycles = transaction.numberOfCycles;
        state.Transactions[i].paymentType = transaction.paymentType;
        state.Transactions[i].period = transaction.period;
        state.Transactions[i].recurringTransaction = transaction.recurringTransaction;
        state.Transactions[i].repeat = transaction.repeat;
        state.Transactions[i].show = transaction.show;
        state.Transactions[i].transactionType = transaction.transactionType;
        state.Transactions[i].transactionAmount = transaction.transactionAmount;
        state.Transactions[i].comment = transaction.comment;
        state.Transactions[i].category = transaction.category;
        state.Transactions[i].account = transaction.account;
        state.Transactions[i].currency = transaction.currency;
        state.Transactions[i].transactionDate = transaction.transactionDate;
        state.Transactions[i].transactionTime = transaction.transactionTime;
        state.Transactions[i].transactionName = transaction.transactionName;
        state.Transactions[i].transferFrom = transaction.transferFrom;
        state.Transactions[i].transferTo = transaction.transferTo;
        state.Transactions[i].objectState = transaction.objectState;
        break;
      }
    }
  },
  markTransactionAsDeleted: function markTransactionAsDeleted(state, transaction) {
    for (var i = 0; i < state.Transactions.length; i++) {
      if (state.Transactions[i].id === transaction.id) {
        state.Transactions[i].objectState = transaction.objectState;
        break;
      }
    }
  },
  deleteTransactionfromStore: function deleteTransactionfromStore(state, transaction) {
    for (var i = 0; i < state.Transactions.length; i++) {
      if (state.Transactions[i].id === transaction.id) {
        state.Transactions.splice(i, 1);
        break;
      }
    }
  },

  //////////////////////////////////////////////////////////////////////////
  //End Of Transaction Mutations
  //////////////////////////////////////////////////////////////////////////


  //////////////////////////////////////////////////////////////////////////
  //Item Mutations
  //////////////////////////////////////////////////////////////////////////

  updateStoreWithItemDataFromAPI: function updateStoreWithItemDataFromAPI(state, data) {},
  addNewItemToStore: function addNewItemToStore(state, item) {
    state.Items.push(item);
  },
  updateIteminStore: function updateIteminStore(state, item) {
    for (var i = 0; i < state.Items.length; i++) {
      if (state.Items[i].id === item.id) {
        state.Items[i].itemName = item.itemName;
        state.Items[i].itemPrice = item.itemPrice;
        state.Items[i].itemCurrency = item.itemCurrency;
        state.Items[i].isTaxed = item.isTaxed;
        state.Items[i].taxedPrice = item.taxedPrice;
        state.Items[i].dateChanged = item.dateChanged;
        state.Items[i].objectState = item.objectState;
        break;
      }
    }
  },

  //////////////////////////////////////////////////////////////////////////
  //End Of Item Mutations
  //////////////////////////////////////////////////////////////////////////


  //////////////////////////////////////////////////////////////////////////
  //Currency Conversion Mutations
  //////////////////////////////////////////////////////////////////////////

  addNewCurrencyConversionToStore: function addNewCurrencyConversionToStore(state, conversion) {
    state.CurrencyConversions.push(conversion);
  },

  //////////////////////////////////////////////////////////////////////////
  //End Of Currency Conversion Mutations
  //////////////////////////////////////////////////////////////////////////


  //////////////////////////////////////////////////////////////////////////
  //Transfer Mutations
  //////////////////////////////////////////////////////////////////////////

  addNewTransferToStore: function addNewTransferToStore(state, transfer) {
    state.Transfers.push(transfer);
  },
  updateTransferinStore: function updateTransferinStore(state, transfer) {
    for (var i = 0; i < state.Transfers.length; i++) {
      if (state.Transfers.id === transfer.id) {
        state.Transfers[i].currency = transfer.currency;
        state.Transfers[i].transferName = transfer.transferName;
        state.Transfers[i].category = transfer.category;
        state.Transfers[i].transferAmount = transfer.transferAmount;
        state.Transfers[i].comment = transfer.comment;
        state.Transfers[i].paymentType = transfer.paymentType;
        state.Transfers[i].transferFrom = transfer.transferFrom;
        state.Transfers[i].transferTo = transfer.transferTo;
        state.Transfers[i].transferDate = transfer.transferDate;
        state.Transfers[i].transferTime = transfer.transferTime;
        state.Transfers[i].objectState = transfer.objectState;
        break;
      }
    }
  },
  markTransferAsDeleted: function markTransferAsDeleted(state, transfer) {
    for (var i = 0; i < state.Transfers.length; i++) {
      if (state.Transfers[i].id === transfer.id) {
        state.Transfers[i].objectState = transfer.objectState;
        break;
      }
    }
  },

  //////////////////////////////////////////////////////////////////////////
  //End Of Item Mutations
  //////////////////////////////////////////////////////////////////////////


  //////////////////////////////////////////////////////////////////////////
  //Update Night Mode Selection
  //////////////////////////////////////////////////////////////////////////

  UpdateNightModeSelection: function UpdateNightModeSelection(state, selection) {
    state.NightMode.switch = selection;
  }

  //////////////////////////////////////////////////////////////////////////
  //End Of Update Night Mode Selection
  //////////////////////////////////////////////////////////////////////////


};

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {};

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_httpGet__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_httpPost__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_httpPut__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_httpDelete__ = __webpack_require__(332);
//API imports





var actions = {

  /////////////////////////////////////////////////////////
  //Actions For Updating API 
  /////////////////////////////////////////////////////////

  syncStoreWithDatabaseAfterComingOnline: function syncStoreWithDatabaseAfterComingOnline(context) {
    //Write Code to Sync Offline changes With API Here
  },
  makeChangesToAPI: function makeChangesToAPI(context, mutationType) {

    if (mutationType === 'initialiseStore') {
      context.dispatch('getDataFromAPIIfNeeded');
    } else if (mutationType.substring(0, 3) === 'add') {
      context.dispatch('addDataForAPIIfNeeded', mutationType);
    } else if (mutationType.substring(0, 6) === 'update') {
      context.dispatch('updateDataForAPIIfNeeded', mutationType);
    } else if (mutationType.substring(0, 4) === 'mark') {
      context.dispatch('deleteDataFromAPIIfNeeded', mutationType);
    }
  },

  ///GET DATA

  getDataFromAPIIfNeeded: function getDataFromAPIIfNeeded(context) {
    //Gets Data from Account If Needed
    context.dispatch('getDataFromAccountIfNeeded');

    //Gets Data from Income If Needed
    context.dispatch('getDataFromIncomeIfNeeded');

    //Get Data from Expense If Needed
    context.dispatch('getDataFromExpenseIfNeeded');
  },

  getDataFromAccountIfNeeded: function getDataFromAccountIfNeeded(context) {
    if (context.state.Accounts.length === 0) {
      context.dispatch('getAccountDataFromAPI');
    }
  },
  getDataFromIncomeIfNeeded: function getDataFromIncomeIfNeeded(context) {
    if (context.state.Incomes.length === 0) {
      context.dispatch('getIncomeDataFromAPI');
    }
  },
  getDataFromExpenseIfNeeded: function getDataFromExpenseIfNeeded(context) {
    if (context.state.Expenses.length === 0) {
      context.dispatch('getExpenseDataFromAPI');
    }
  },
  getDataFromBudgetIfNeeded: function getDataFromBudgetIfNeeded(context) {
    if (context.state.Budgets.length === 0) {
      context.dispatch('getBudgetDataFromAPI');
    }
  },

  ///END OF GET DATA

  ///ADD DATA

  addDataForAPIIfNeeded: function addDataForAPIIfNeeded(context, mutationType) {

    if (mutationType.indexOf("Account") !== -1) {
      //Gets Data from Account If Needed
      context.dispatch('addDataForAccountIfNeeded');
    } else if (mutationType.indexOf("Income") !== -1) {
      //Gets Data from Income If Needed
      context.dispatch('addDataForIncomeIfNeeded');
    } else if (mutationType.indexOf("Expense") !== -1) {
      //Gets Data from Expense If Needed
      context.dispatch('addDataForExpenseIfNeeded');
    } else if (mutationType.indexOf("Budget") !== -1) {
      //Gets Data from Expense If Needed
      context.dispatch('addDataForBudgetIfNeeded');
    }
  },

  addDataForAccountIfNeeded: function addDataForAccountIfNeeded(context) {
    var newAccounts = [];

    for (var i = 0; i < context.state.Accounts.length; i++) {
      if (context.state.Accounts[i].objectState === "New") {
        newAccounts.push(context.state.Accounts[i]);
      }
    }

    context.dispatch('addNewAccountToDatabase', newAccounts);
  },
  addDataForIncomeIfNeeded: function addDataForIncomeIfNeeded(context) {
    var newIncomes = [];

    for (var i = 0; i < context.state.Incomes.length; i++) {
      if (context.state.Incomes[i].objectState === "New") {
        newIncomes.push(context.state.Incomes[i]);
      }
    }

    context.dispatch('addNewIncomeToDatabase', newIncomes);
  },
  addDataForExpenseIfNeeded: function addDataForExpenseIfNeeded(context) {
    var newExpenses = [];

    for (var i = 0; i < context.state.Expenses.length; i++) {
      if (context.state.Expenses[i].objectState === "New") {
        newExpenses.push(context.state.Expenses[i]);
      }
    }

    context.dispatch('addNewExpenseToDatabase', newExpenses);
  },
  addDataForBudgetIfNeeded: function addDataForBudgetIfNeeded(context) {
    var newBudgets = [];

    for (var i = 0; i < context.state.Budgets.length; i++) {
      if (context.state.Budgets[i].objectState === "New") {
        newBudgets.push(context.state.Budgets[i]);
      }
    }

    context.dispatch('addNewBudgetToDatabase', newBudgets);
  },

  ///END OF ADD DATA

  //UPDATE DATA

  updateDataForAPIIfNeeded: function updateDataForAPIIfNeeded(context, mutationType) {

    if (mutationType.indexOf("Account") !== -1) {
      //Gets Data from Account If Needed
      context.dispatch('updateDataForAccountIfNeeded');
    } else if (mutationType.indexOf("Income") !== -1) {
      //Gets Data from Income If Needed
      context.dispatch('updateDataForIncomeIfNeeded');
    } else if (mutationType.indexOf("Expense") !== -1) {
      //Gets Data from Expense If Needed
      context.dispatch('updateDataForExpenseIfNeeded');
    } else if (mutationType.indexOf("Budget") !== -1) {
      //Gets Data from Expense If Needed
      context.dispatch('updateDataForBudgetIfNeeded');
    }
  },

  updateDataForAccountIfNeeded: function updateDataForAccountIfNeeded(context) {
    var updateAccounts = [];

    for (var i = 0; i < context.state.Accounts.length; i++) {
      if (context.state.Accounts[i].objectState === "Update") {
        updateAccounts.push(context.state.Accounts[i]);
      }
    }

    context.dispatch('updateAccountinDatabase', updateAccounts);
  },
  updateDataForIncomeIfNeeded: function updateDataForIncomeIfNeeded(context) {
    var updateIncomes = [];

    for (var i = 0; i < context.state.Incomes.length; i++) {
      if (context.state.Incomes[i].objectState === "Update") {
        updateIncomes.push(context.state.Incomes[i]);
      }
    }

    context.dispatch('updateIncomeInDatabase', updateIncomes);
  },
  updateDataForExpenseIfNeeded: function updateDataForExpenseIfNeeded(context) {
    var updateExpenses = [];

    for (var i = 0; i < context.state.Expenses.length; i++) {
      if (context.state.Expenses[i].objectState === "Update") {
        updateExpenses.push(context.state.Expenses[i]);
      }
    }

    context.dispatch('updateExpenseInDatabase', updateExpenses);
  },
  updateDataForBudgetIfNeeded: function updateDataForBudgetIfNeeded(context) {
    var updateBudgets = [];

    for (var i = 0; i < context.state.Budgets.length; i++) {
      if (context.state.Budgets[i].objectState === "Update") {
        updateBudgets.push(context.state.Budgets[i]);
      }
    }

    context.dispatch('updateBudgetInDatabase', updateBudgets);
  },

  //END OF UPDATE DATA

  //DELETE DATA

  deleteDataFromAPIIfNeeded: function deleteDataFromAPIIfNeeded(context, mutationType) {
    if (mutationType.indexOf("Account") !== -1) {
      //Gets Data from Account If Needed
      context.dispatch('deleteDataForAccountIfNeeded');
    } else if (mutationType.indexOf("Income") !== -1) {
      //Gets Data from Income If Needed
      context.dispatch('deleteDataForIncomeIfNeeded');
    } else if (mutationType.indexOf("Expense") !== -1) {
      //Gets Data from Expense If Needed
      context.dispatch('deleteDataForExpenseIfNeeded');
    }
  },

  deleteDataForAccountIfNeeded: function deleteDataForAccountIfNeeded(context) {
    var deleteAccounts = [];

    for (var i = 0; i < context.state.Accounts.length; i++) {
      if (context.state.Accounts[i].objectState === "Delete") {
        deleteAccounts.push(context.state.Accounts[i]);
      }
    }

    context.dispatch('deleteAccountinDatabase', deleteAccounts);
  },
  deleteDataForIncomeIfNeeded: function deleteDataForIncomeIfNeeded(context) {
    var deleteIncomes = [];

    for (var i = 0; i < context.state.Incomes.length; i++) {
      if (context.state.Incomes[i].objectState === "Delete") {
        deleteIncomes.push(context.state.Incomes[i]);
      }
    }

    context.dispatch('deleteIncomeInDatabase', deleteIncomes);
  },
  deleteDataForExpenseIfNeeded: function deleteDataForExpenseIfNeeded(context) {
    var deleteExpenses = [];

    for (var i = 0; i < context.state.Expenses.length; i++) {
      if (context.state.Expenses[i].objectState === "Delete") {
        deleteExpenses.push(context.state.Expenses[i]);
      }
    }

    context.dispatch('deleteExpenseinDatabase', deleteExpenses);
  },

  //END OF DELETE DATA

  /////////////////// //////////////////////////////////////
  //End Of Actions For Updating API 
  /////////////////////////////////////////////////////////


  /////////////////////////////////////////////////////////
  //Account Actions
  /////////////////////////////////////////////////////////

  getAccountDataFromAPI: function getAccountDataFromAPI(context) {

    var p1 = new Promise(
    // The resolver function is called with the ability to resolve or
    // reject the promise
    function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__api_httpGet__["a" /* httpGet */].getAccounts(function (data) {
        context.commit('updateStoreWithAccountsDataFromAPI', data);
      });
    });
  },
  addNewAccountToDatabase: function addNewAccountToDatabase(context, accountData) {
    var _loop = function _loop(i) {
      var a1 = new Promise(
      // The resolver function is called with the ability to resolve or reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api_httpPost__["a" /* httpPost */].postNewAccount(accountData[i], function (data) {
          for (var j = 0; j < context.state.Accounts.length; j++) {
            if (context.state.Accounts[j].accountName === accountData[i].accountName) {
              context.state.Accounts[j].id = data;
              context.state.Accounts[j].objectState = "Current";
            }
          }
        });
      });
    };

    //context.commit('addNewAccountToStore', accountData)

    for (var i = 0; i < accountData.length; i++) {
      _loop(i);
    }
  },
  updateAccountinDatabase: function updateAccountinDatabase(context, accountData) {
    var _loop2 = function _loop2(i) {
      var u1 = new Promise(
      // The resolver function is called with the ability to resolve or reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api_httpPut__["a" /* httpPut */].updateAccount(accountData[i], function (data) {
          if (data === 200) {
            for (var j = 0; j < context.state.Accounts.length; j++) {
              if (context.state.Accounts[j].id === accountData[i].id) {
                //context.state.Accounts[j].id = data
                context.state.Accounts[j].objectState = "Current";
              }
            }
          }
        });
      });
    };

    //context.commit('updateAccountinStore', accountData)

    for (var i = 0; i < accountData.length; i++) {
      _loop2(i);
    }
  },
  deleteAccountinDatabase: function deleteAccountinDatabase(context, accountData) {
    var _loop3 = function _loop3(i) {
      var d1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api_httpDelete__["a" /* httpDelete */].deleteAccount(accountData[i], function (data) {
          if (data === 200) {
            context.commit('deleteAccountfromStore', accountData[i]);
          }
        });
      });
    };

    //context.commit('updateAccountinStore', accountData)

    for (var i = 0; i < accountData.length; i++) {
      _loop3(i);
    }
  },

  /////////////////////////////////////////////////////////
  //End Of Account Actions
  /////////////////////////////////////////////////////////


  /////////////////////////////////////////////////////////
  //Income Actions
  /////////////////////////////////////////////////////////

  getIncomeDataFromAPI: function getIncomeDataFromAPI(context) {
    var p1 = new Promise(
    // The resolver function is called with the ability to resolve or
    // reject the promise
    function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__api_httpGet__["a" /* httpGet */].getIncomes(function (data) {
        context.commit('updateStoreWithIncomeDataFromAPI', data);
      });
    });
  },
  addNewIncomeToDatabase: function addNewIncomeToDatabase(context, incomeData) {
    var _loop4 = function _loop4(i) {
      var a1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api_httpPost__["a" /* httpPost */].postNewIncome(incomeData, function (data) {
          for (var j = 0; j < context.state.Incomes.length; j++) {
            if (context.state.Incomes[j].incomeName === incomeData[i].incomeName) {
              context.state.Incomes[j].id = data;
              context.state.Incomes[j].objectState = "Current";
            }
          }
        });
      });
    };

    //context.commit('addNewIncomeToStore', incomeData)

    for (var i = 0; i < incomeData.length; i++) {
      _loop4(i);
    }
  },
  updateIncomeInDatabase: function updateIncomeInDatabase(context, incomeData) {
    var _loop5 = function _loop5(i) {
      var u1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api_httpPut__["a" /* httpPut */].updateIncome(incomeData, function (data) {
          if (data === 200) {
            for (var j = 0; j < context.state.Incomes.length; j++) {
              if (context.state.Incomes[j].id === incomeData[i].id) {
                context.state.Incomes[j].objectState = "Current";
              }
            }
          }
        });
      });
    };

    //context.commit('updateIncomeinStore', incomeData)

    for (var i = 0; i < incomeData.length; i++) {
      _loop5(i);
    }
  },
  deleteIncomeInDatabase: function deleteIncomeInDatabase(context, incomeData) {
    //context.commit('updateIncomeinStore', incomeData)

    for (var i = 0; i < incomeData.length; i++) {
      var d1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api_httpDelete__["a" /* httpDelete */].deleteIncome(incomeData, function (data) {
          if (data === 200) {
            context.commit('deleteIncomefromStore', incomeData);
          }
        });
      });
    }
  },

  /////////////////////////////////////////////////////////
  //End Of Income Actions
  /////////////////////////////////////////////////////////


  /////////////////////////////////////////////////////////
  //Expense Actions
  /////////////////////////////////////////////////////////

  getExpenseDataFromAPI: function getExpenseDataFromAPI(context) {
    var p1 = new Promise(
    // The resolver function is called with the ability to resolve or
    // reject the promise
    function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__api_httpGet__["a" /* httpGet */].getExpenses(function (data) {
        context.commit('updateStoreWithExpenseDataFromAPI', data);
      });
    });
  },
  addNewExpenseToDatabase: function addNewExpenseToDatabase(context, expenseData) {
    var _loop6 = function _loop6(i) {
      var a1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api_httpPost__["a" /* httpPost */].postNewExpense(expenseData, function (data) {
          for (var j = 0; j < context.state.Expenses.length; j++) {
            if (context.state.Expenses[j].expenseName === expenseData[i].expenseName) {
              context.state.Expenses[j].id = data;
              context.state.Expenses[j].objectState = "Current";
            }
          }
        });
      });
    };

    //context.commit('addNewExpenseToStore', expenseData)

    for (var i = 0; i < expenseData.length; i++) {
      _loop6(i);
    }
  },
  updateExpenseInDatabase: function updateExpenseInDatabase(context, expenseData) {
    var _loop7 = function _loop7(i) {
      var u1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api_httpPut__["a" /* httpPut */].updateExpense(expenseData, function (data) {
          if (data === 200) {
            for (var j = 0; j < context.state.Expenses.length; j++) {
              if (context.state.Expenses[j].id === expenseData[i].id) {
                context.state.Expenses[j].objectState = "Current";
              }
            }
          }
        });
      });
    };

    //context.commit('updateExpenseinStore', expenseData)

    for (var i = 0; i < expenseData.length; i++) {
      _loop7(i);
    }
  },
  deleteExpenseinDatabase: function deleteExpenseinDatabase(context, expenseData) {

    for (var i = 0; i < expenseData.length; i++) {
      var d1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api_httpDelete__["a" /* httpDelete */].deleteExpense(expenseData, function (data) {
          if (data === 200) {
            context.commit('deleteExpensefromStore', expenseData);
          }
        });
      });
    }
  },

  /////////////////////////////////////////////////////////
  //End Of Expense Actions
  /////////////////////////////////////////////////////////


  /////////////////////////////////////////////////////////
  //Budget Actions
  /////////////////////////////////////////////////////////

  getBudgetDataFromAPI: function getBudgetDataFromAPI(context) {
    var p1 = new Promise(
    // The resolver function is called with the ability to resolve or
    // reject the promise
    function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__api_httpGet__["a" /* httpGet */].getExpenses(function (data) {
        context.commit('updateStoreWithBudgetDataFromAPI', data);
      });
    });
  },
  addNewBudgetToDatabase: function addNewBudgetToDatabase(context, budgetData) {
    var _loop8 = function _loop8(i) {
      var a1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api_httpPost__["a" /* httpPost */].postNewBudget(budgetData, function (data) {
          for (var j = 0; j < context.state.Budgets.length; j++) {
            if (context.state.Budgets[j].budgetName === budgetData[i].budgetName) {
              context.state.Budgets[j].id = data;
              context.state.Budgets[j].objectState = "Current";
            }
          }
        });
      });
    };

    for (var i = 0; i < budgetData.length; i++) {
      _loop8(i);
    }
  },
  updateBudgetInDatabase: function updateBudgetInDatabase(context, budgetData) {
    var _loop9 = function _loop9(i) {
      var u1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api_httpPut__["a" /* httpPut */].updateBudget(budgetData, function (data) {
          if (data === 200) {
            for (var j = 0; j < context.state.Budgets.length; j++) {
              if (context.state.Budgets[j].id === budgetData[i].id) {
                context.state.Budgets[j].objectState = "Current";
              }
            }
          }
        });
      });
    };

    for (var i = 0; i < budgetData.length; i++) {
      _loop9(i);
    }
  },
  deleteBudgetinDatabase: function deleteBudgetinDatabase(context, budgetData) {

    for (var i = 0; i < budgetData.length; i++) {
      var d1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api_httpDelete__["a" /* httpDelete */].deleteBudget(budgetData, function (data) {
          if (data === 200) {
            context.commit('deleteBudgetfromStore', budgetData);
          }
        });
      });
    }
  }

  /////////////////////////////////////////////////////////
  //End Of Budget Actions
  /////////////////////////////////////////////////////////


};

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpGet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__httpCommon__ = __webpack_require__(49);


var httpGet = {

  ////////////////////////////////////////////
  ///ACCOUNTS
  ////////////////////////////////////////////

  //Get Accounts
  getAccounts: function getAccounts(callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].get('Accounts').then(function (response) {
      // JSON responses are automatically parsed.
      callback(response.data);
    }).catch(function (e) {
      //this.errors.push(e)
    });
  },


  ////////////////////////////////////////////
  ///INCOMES
  ////////////////////////////////////////////

  //Get Incomes
  getIncomes: function getIncomes(callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].get('Incomes').then(function (response) {
      // JSON responses are automatically parsed.
      callback(response.data);
    }).catch(function (e) {
      //this.errors.push(e)
    });
  },


  ////////////////////////////////////////////
  ///EXPENSES
  ////////////////////////////////////////////

  //Get Expenses
  getExpenses: function getExpenses(callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].get('Expenses').then(function (response) {
      // JSON responses are automatically parsed.
      callback(response.data);
    }).catch(function (e) {
      //this.errors.push(e)
    });
  }
};

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpPost; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__httpCommon__ = __webpack_require__(49);


var httpPost = {

  ////////////////////////////////////////////
  ///ACCOUNTS
  ////////////////////////////////////////////

  //Post Account
  postNewAccount: function postNewAccount(account, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].post('Accounts', account).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  },


  ////////////////////////////////////////////
  ///INCOME
  ////////////////////////////////////////////

  //Post Income
  postNewIncome: function postNewIncome(income, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].post('Incomes', income).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  },


  ////////////////////////////////////////////
  ///EXPENSE
  ////////////////////////////////////////////

  //Post Expense
  postNewExpense: function postNewExpense(expense, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].post('Expenses', expense).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  },


  ////////////////////////////////////////////
  ///BUDGET
  ////////////////////////////////////////////

  //Post Budget
  postNewBudget: function postNewBudget(budget, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].post('Budgets', budget).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  }
};

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpPut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__httpCommon__ = __webpack_require__(49);


var httpPut = {

  ////////////////////////////////////////////
  ///ACCOUNTS
  ////////////////////////////////////////////

  //Update Account
  updateAccount: function updateAccount(account, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].put('Accounts/' + account.id, account).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  },


  ////////////////////////////////////////////
  ///INCOMES
  ////////////////////////////////////////////

  //Update Income
  updateIncome: function updateIncome(income, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].put('Incomes/' + income.id, income).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  },


  ////////////////////////////////////////////
  ///EXPENSES
  ////////////////////////////////////////////

  //Update Expenses
  updateExpense: function updateExpense(expense, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].put('Expenses/' + expense.id, expense).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  },


  ////////////////////////////////////////////
  ///BUDGETS
  ////////////////////////////////////////////

  //Update Budgets
  updateBudget: function updateBudget(budget, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].put('Budgets/' + budget.id, budget).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  }
};

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__httpCommon__ = __webpack_require__(49);


var httpDelete = {

  ////////////////////////////////////////////
  ///ACCOUNTS
  ////////////////////////////////////////////

  //Delete Account
  deleteAccount: function deleteAccount(account, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].delete('Accounts/' + account.id).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  },


  ////////////////////////////////////////////
  ///INCOMES
  ////////////////////////////////////////////

  //Delete Income
  deleteIncome: function deleteIncome(income, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].delete('Incomes/' + income.id).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  },


  ////////////////////////////////////////////
  ///EXPENSES
  ////////////////////////////////////////////

  //Delete Expense
  deleteExpense: function deleteExpense(expense, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].delete('Expenses/' + expense.id).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  },


  ////////////////////////////////////////////
  ///BUDGETS
  ////////////////////////////////////////////

  //Delete Budget
  deleteBudget: function deleteBudget(budget, callback) {
    __WEBPACK_IMPORTED_MODULE_0__httpCommon__["a" /* HTTP */].delete('Budgets/' + budget.id).then(function (response) {
      callback(response.status);
    }).catch(function (e) {
      //this.errors.push(e)
      console.log(e);
    });
  }
};

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return plugins; });

var plugins = function plugins(store) {
  // Subscribe to store updates
  store.subscribe(function (mutation, state) {
    // Store the state object as a JSON string
    localStorage.setItem('store', JSON.stringify(state));

    store.dispatch('makeChangesToAPI', mutation.type);
  });
};

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"card-flex-toolbar noPadding",staticStyle:{"width":"100%"},attrs:{"fluid":"","scrollable":""}},[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Incomes")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","flat":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ path: '/dashboard/addincome' })}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-plus")])],1),_vm._v(" "),_c('span',[_vm._v("Add Income")])],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"direction":_vm.direction,"transition":_vm.transition},model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","small":"","fab":""},slot:"activator",model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-icon',[_vm._v("fas fa-ellipsis-v")]),_vm._v(" "),_c('v-icon',[_vm._v("fas fa-times")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewSearch = !_vm.viewSearch}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-search")])],1),_vm._v(" "),_c('span',[_vm._v("Search")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewFilter = !_vm.viewFilter}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-filter")])],1),_vm._v(" "),_c('span',[_vm._v("Filter")])],1)],1)],1),_vm._v(" "),_c('v-container',{class:{'padContent': !_vm.drawer},staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.viewSearch === true)?[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Search"},on:{"change":_vm.getSearchItems,"input":_vm.getSearchItems},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]:_vm._e(),_vm._v(" "),(_vm.viewFilter === true)?[_c('v-flex',{attrs:{"xs12":""}})]:_vm._e(),_vm._v(" "),(_vm.itemsMinusDeleted.length === 0)?[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Sorry, There is currently no data to display here")]),_vm._v(" "),_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-frown")])],1)],1)],1)],1)]:_vm._e(),_vm._v(" "),_vm._l((_vm.itemsMinusDeleted),function(itemMinus){return _c('ListItem',{key:itemMinus.id,ref:"listItem",refInFor:true,attrs:{"liItem":{type: 'income',data: itemMinus}},on:{"Edit":function($event){_vm.redirectToEditPage($event)},"Delete":function($event){_vm.DeleteIncome($event)}}})})],2)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete")]),_vm._v(" "),_c('v-card-text',[_vm._v("Are you sure you want to delete "),_c('b',[_vm._v("\""+_vm._s(_vm.deleteIncome.incomeName)+"\"")]),_vm._v("?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.DeleteIncomeAccept()}}},[_vm._v("Yes")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddIncomes_vue__ = __webpack_require__(149);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34bca786_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddIncomes_vue__ = __webpack_require__(340);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddIncomes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34bca786_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddIncomes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"scrollable":"","max-width":"600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Currency Conversion")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-actions',[(_vm.newConversion)?_c('v-btn',{staticStyle:{"margin-left":"10px"},attrs:{"slot":"activator","fab":"","flat":"","middle":"","right":"","color":"green"},on:{"click":function($event){$event.preventDefault();_vm.checkNewConversion(_vm.$v.currentConversion)}},slot:"activator"},[_c('v-icon',[_vm._v("far fa-save")])],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.newConversion)?_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","flat":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.createNewConversion()}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-plus")])],1):_vm._e(),_vm._v(" "),(_vm.newConversion)?_c('v-btn',{attrs:{"slot":"activator","fab":"","flat":"","middle":"","right":"","color":"red"},on:{"click":function($event){$event.preventDefault();_vm.closeNewConversionWindow()}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-times")])],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"400px"}},[(_vm.newConversion)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.currencies,"label":"Convert From","error-messages":_vm.covertFromErrors},on:{"input":function($event){_vm.$v.currentConversion.convertFrom.$touch()},"blur":function($event){_vm.$v.currentConversion.convertFrom.$touch()}},model:{value:(_vm.currentConversion.convertFrom),callback:function ($$v) {_vm.$set(_vm.currentConversion, "convertFrom", $$v)},expression:"currentConversion.convertFrom"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.currencies,"label":"Convert To","error-messages":_vm.convertToErrors},on:{"input":function($event){_vm.$v.currentConversion.convertTo.$touch()},"blur":function($event){_vm.$v.currentConversion.convertTo.$touch()}},model:{value:(_vm.currentConversion.convertTo),callback:function ($$v) {_vm.$set(_vm.currentConversion, "convertTo", $$v)},expression:"currentConversion.convertTo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Conversion Rate","error-messages":_vm.conversionRateErrors},on:{"input":function($event){_vm.$v.currentConversion.conversionRate.$touch()},"blur":function($event){_vm.$v.currentConversion.conversionRate.$touch()}},model:{value:(_vm.currentConversion.conversionRate),callback:function ($$v) {_vm.$set(_vm.currentConversion, "conversionRate", $$v)},expression:"currentConversion.conversionRate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-menu',{ref:"menu1",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date"},slot:"activator",model:{value:(_vm.currentConversion.date),callback:function ($$v) {_vm.$set(_vm.currentConversion, "date", $$v)},expression:"currentConversion.date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},on:{"input":function($event){_vm.menu1 = false}},model:{value:(_vm.currentConversion.date),callback:function ($$v) {_vm.$set(_vm.currentConversion, "date", $$v)},expression:"currentConversion.date"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.listConversion)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-list',{staticStyle:{"width":"100%"},attrs:{"two-line":""}},[_c('v-divider'),_vm._v(" "),_vm._l((_vm.conversions),function(item,index){return [_c('v-list-tile',{key:item.id,on:{"click":function($event){_vm.returnSelectedConversion(item)}}},[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("\n                        Convert From: "+_vm._s(item.convertFrom)+"\n                      ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_vm._v("\n                        Convert To: "+_vm._s(item.convertTo)+"\n                      ")])],1)],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Rate: "+_vm._s(item.conversionRate))])],1)],1),_vm._v(" "),_c('v-divider')]})],2)],1):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoneyCalculator_vue__ = __webpack_require__(151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a550f44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MoneyCalculator_vue__ = __webpack_require__(339);
function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a550f44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoneyCalculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a550f44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MoneyCalculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"550"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',{staticStyle:{"padding":"0"}},[_c('v-text-field',{staticClass:"noHeight",attrs:{"solo":"","reverse":"","disabled":""},model:{value:(_vm.topDisplay),callback:function ($$v) {_vm.topDisplay=$$v},expression:"topDisplay"}}),_vm._v(" "),_c('v-text-field',{attrs:{"solo":"","reverse":"","disabled":""},model:{value:(_vm.bottomDisplay),callback:function ($$v) {_vm.bottomDisplay=$$v},expression:"bottomDisplay"}}),_vm._v(" "),_c('v-container',{staticStyle:{"padding":"4px 22px 4px 4px"},attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.bottomDisplay = 0}}},[_vm._v("CE")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.bottomDisplay = 0; _vm.topDisplay = 0;}}},[_vm._v("C")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',[_vm._v("\n                back\n              ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateTopDisplay('/')}}},[_vm._v("/")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateBottomDisplay('7')}}},[_vm._v("7")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateBottomDisplay('8')}}},[_vm._v("8")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateBottomDisplay('9')}}},[_vm._v("9")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateTopDisplay('*')}}},[_vm._v("x")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateBottomDisplay('4')}}},[_vm._v("4")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateBottomDisplay('5')}}},[_vm._v("5")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateBottomDisplay('6')}}},[_vm._v("6")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateTopDisplay('-')}}},[_vm._v("-")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateBottomDisplay('1')}}},[_vm._v("1")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateBottomDisplay('2')}}},[_vm._v("2")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateBottomDisplay('3')}}},[_vm._v("3")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateTopDisplay('+')}}},[_vm._v("+")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateBottomDisplay('0')}}},[_vm._v("0")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.updateBottomDisplay('.')}}},[_vm._v(".")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":function($event){_vm.evaluateCalculation()}}},[_vm._v("=")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',[_vm._v("accept")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("New Income")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.addIncomeCheck(_vm.$v.currentIncome)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/income' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-top":"0"}},[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"x12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.curriencies,"label":"Currency","chips":"","hint":"What Currency is this Income in?","persistent-hint":"","error-messages":_vm.currencyErrors},on:{"input":function($event){_vm.$v.currentIncome.currency.$touch(), _vm.adjustCurrency()},"blur":function($event){_vm.$v.currentIncome.currency.$touch()}},model:{value:(_vm.currentIncome.currency),callback:function ($$v) {_vm.$set(_vm.currentIncome, "currency", $$v)},expression:"currentIncome.currency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Income Name","error-messages":_vm.incomeNameErrors},on:{"input":function($event){_vm.$v.currentIncome.incomeName.$touch()},"blur":function($event){_vm.$v.currentIncome.incomeName.$touch()}},model:{value:(_vm.currentIncome.incomeName),callback:function ($$v) {_vm.$set(_vm.currentIncome, "incomeName", $$v)},expression:"currentIncome.incomeName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.account,"label":"Account","chips":"","prepend-icon":"fas fa-university","hint":"What Account does this belong to?","persistent-hint":"","error-messages":_vm.accountErrors},on:{"input":function($event){_vm.$v.currentIncome.account.$touch(), _vm.adjustCurrency()},"blur":function($event){_vm.$v.currentIncome.account.$touch()}},model:{value:(_vm.currentIncome.account),callback:function ($$v) {_vm.$set(_vm.currentIncome, "account", $$v)},expression:"currentIncome.account"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.category,"label":"Category","chips":"","prepend-icon":"fa-tag","hint":"What Category does this belong to?","persistent-hint":"","error-messages":_vm.categoryErrors},on:{"input":function($event){_vm.$v.currentIncome.category.$touch()},"blur":function($event){_vm.$v.currentIncome.category.$touch()}},model:{value:(_vm.currentIncome.category),callback:function ($$v) {_vm.$set(_vm.currentIncome, "category", $$v)},expression:"currentIncome.category"}})],1),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Currency Conversion","prepend-icon":"fas fa-balance-scale","error-messages":_vm.currencyConversionErrors},on:{"click":function($event){$event.preventDefault();_vm.getCurrencyConvertionRate()},"focus":function($event){_vm.getCurrencyConvertionRate()},"input":function($event){_vm.$v.currentIncome.currencyConversion.$touch()},"blur":function($event){_vm.$v.currentIncome.currencyConversion.$touch()}},model:{value:(_vm.currentIncome.currencyConversion.conversionRate),callback:function ($$v) {_vm.$set(_vm.currentIncome.currencyConversion, "conversionRate", $$v)},expression:"currentIncome.currencyConversion.conversionRate"}}),_vm._v(" "),_c('CurrencyConverter',{ref:"converter",on:{"conversionRate":function($event){_vm.setCurrencyConversionRate($event)}}})],1):_vm._e(),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Amount","prepend-icon":"fas fa-money-bill","type":"number","min":"1","error-messages":_vm.foreignCurrencyAmountErrors},on:{"input":function($event){_vm.$v.currentIncome.foreignCurrencyAmount.$touch(), _vm.calculateConvertedAmount()},"blur":function($event){_vm.$v.currentIncome.foreignCurrencyAmount.$touch()}},model:{value:(_vm.currentIncome.foreignCurrencyAmount),callback:function ($$v) {_vm.$set(_vm.currentIncome, "foreignCurrencyAmount", $$v)},expression:"currentIncome.foreignCurrencyAmount"}})],1):_vm._e(),_vm._v(" "),(!_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Income Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.incomeAmountErrors},on:{"input":function($event){_vm.$v.currentIncome.incomeAmount.$touch()},"blur":function($event){_vm.$v.currentIncome.incomeAmount.$touch()}},model:{value:(_vm.currentIncome.incomeAmount),callback:function ($$v) {_vm.$set(_vm.currentIncome, "incomeAmount", $$v)},expression:"currentIncome.incomeAmount"}})],1):_vm._e(),_vm._v(" "),(_vm.calculator)?_c('MoneyCalculator'):_vm._e(),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Converted Amount","prepend-icon":"fa-money-bill-alt"},model:{value:(_vm.currentIncome.incomeAmount),callback:function ($$v) {_vm.$set(_vm.currentIncome, "incomeAmount", $$v)},expression:"currentIncome.incomeAmount"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Comment","prepend-icon":"fa-comment"},model:{value:(_vm.currentIncome.comment),callback:function ($$v) {_vm.$set(_vm.currentIncome, "comment", $$v)},expression:"currentIncome.comment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":"Recurring Income"},model:{value:(_vm.recurringIncome),callback:function ($$v) {_vm.recurringIncome=$$v},expression:"recurringIncome"}})],1),_vm._v(" "),(!_vm.recurringIncome)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"dialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.currentIncome.incomeDate},on:{"update:returnValue":function($event){_vm.$set(_vm.currentIncome, "incomeDate", $event)}},model:{value:(_vm.addModelIncomeDate),callback:function ($$v) {_vm.addModelIncomeDate=$$v},expression:"addModelIncomeDate"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Income Date","prepend-icon":"event","error-messages":_vm.incomeDateErrors,"readonly":""},on:{"input":function($event){_vm.$v.currentIncome.incomeDate.$touch()},"blur":function($event){_vm.$v.currentIncome.incomeDate.$touch()}},slot:"activator",model:{value:(_vm.currentIncome.incomeDate),callback:function ($$v) {_vm.$set(_vm.currentIncome, "incomeDate", $$v)},expression:"currentIncome.incomeDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.currentIncome.incomeDate),callback:function ($$v) {_vm.$set(_vm.currentIncome, "incomeDate", $$v)},expression:"currentIncome.incomeDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.addModelIncomeDate = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.dialog.save(_vm.currentIncome.incomeDate)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.recurringIncome)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"timemenu",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.currentIncome.incomeTime},on:{"update:returnValue":function($event){_vm.$set(_vm.currentIncome, "incomeTime", $event)}},model:{value:(_vm.timemenuvisibilty),callback:function ($$v) {_vm.timemenuvisibilty=$$v},expression:"timemenuvisibilty"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Time Picker","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.currentIncome.incomeTime),callback:function ($$v) {_vm.$set(_vm.currentIncome, "incomeTime", $$v)},expression:"currentIncome.incomeTime"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"actions":""},model:{value:(_vm.currentIncome.incomeTime),callback:function ($$v) {_vm.$set(_vm.currentIncome, "incomeTime", $$v)},expression:"currentIncome.incomeTime"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timemenuvisibilty = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.timemenu.save(_vm.currentIncome.incomeTime)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.recurringIncome)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Repeat Every","type":"number","min":"1","max":"60"},model:{value:(_vm.currentIncome.repeat),callback:function ($$v) {_vm.$set(_vm.currentIncome, "repeat", $$v)},expression:"currentIncome.repeat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":['Day','Week','Month','Year']},model:{value:(_vm.currentIncome.cycle),callback:function ($$v) {_vm.$set(_vm.currentIncome, "cycle", $$v)},expression:"currentIncome.cycle"}})],1)],1),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.currentIncome.period),callback:function ($$v) {_vm.$set(_vm.currentIncome, "period", $$v)},expression:"currentIncome.period"}},[_c('v-radio',{attrs:{"label":"Forever","value":"Forever"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"For Number of cycles","value":"For"}})],1),_vm._v(" "),(_vm.currentIncome.period === 'For')?_c('v-text-field',{attrs:{"label":"Number of cycles","type":"number","min":"1","max":"60"},model:{value:(_vm.currentIncome.numberOfCycles),callback:function ($$v) {_vm.$set(_vm.currentIncome, "numberOfCycles", $$v)},expression:"currentIncome.numberOfCycles"}}):_vm._e(),_vm._v(" "),_c('v-dialog',{ref:"goesOff",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.currentIncome.goesOffFirst},on:{"update:returnValue":function($event){_vm.$set(_vm.currentIncome, "goesOffFirst", $event)}},model:{value:(_vm.addModelGoesOff),callback:function ($$v) {_vm.addModelGoesOff=$$v},expression:"addModelGoesOff"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentIncome.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.currentIncome, "goesOffFirst", $$v)},expression:"currentIncome.goesOffFirst"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.currentIncome.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.currentIncome, "goesOffFirst", $$v)},expression:"currentIncome.goesOffFirst"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.addModelGoesOff = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.goesOff.save(_vm.currentIncome.goesOffFirst)}}},[_vm._v("OK")])],1)],1)],1):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditIncomes_vue__ = __webpack_require__(152);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f9267e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditIncomes_vue__ = __webpack_require__(342);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditIncomes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f9267e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditIncomes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Edit Income")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.updateEditedIncome(_vm.$v.editIncome)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/income' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-top":"0"}},[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"x12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.curriencies,"label":"Currency","chips":"","error-messages":_vm.currencyErrors},on:{"input":function($event){_vm.$v.editIncome.currency.$touch(), _vm.adjustCurrency()},"blur":function($event){_vm.$v.editIncome.currency.$touch()}},model:{value:(_vm.editIncome.currency),callback:function ($$v) {_vm.$set(_vm.editIncome, "currency", $$v)},expression:"editIncome.currency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Income Name","error-messages":_vm.incomeNameErrors},on:{"input":function($event){_vm.$v.editIncome.incomeName.$touch()},"blur":function($event){_vm.$v.editIncome.incomeName.$touch()}},model:{value:(_vm.editIncome.incomeName),callback:function ($$v) {_vm.$set(_vm.editIncome, "incomeName", $$v)},expression:"editIncome.incomeName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.account,"label":"Account","chips":"","prepend-icon":"fa-balance-scale","hint":"What Account does this belong to?","persistent-hint":"","error-messages":_vm.accountErrors},on:{"input":function($event){_vm.$v.editIncome.account.$touch()},"blur":function($event){_vm.$v.editIncome.account.$touch()}},model:{value:(_vm.editIncome.account),callback:function ($$v) {_vm.$set(_vm.editIncome, "account", $$v)},expression:"editIncome.account"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.category,"label":"Category","chips":"","prepend-icon":"fa-tag","hint":"What Category does this belong to?","persistent-hint":"","error-messages":_vm.categoryErrors},on:{"input":function($event){_vm.$v.editIncome.category.$touch()},"blur":function($event){_vm.$v.editIncome.category.$touch()}},model:{value:(_vm.editIncome.category),callback:function ($$v) {_vm.$set(_vm.editIncome, "category", $$v)},expression:"editIncome.category"}})],1),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Currency Conversion","prepend-icon":"fas fa-balance-scale","error-messages":_vm.currencyConversionErrors},on:{"click":function($event){$event.preventDefault();_vm.getCurrencyConvertionRate()},"focus":function($event){_vm.getCurrencyConvertionRate()},"input":function($event){_vm.$v.editIncome.currencyConversion.$touch()},"blur":function($event){_vm.$v.editIncome.currencyConversion.$touch()}},model:{value:(_vm.editIncome.currencyConversion.conversionRate),callback:function ($$v) {_vm.$set(_vm.editIncome.currencyConversion, "conversionRate", $$v)},expression:"editIncome.currencyConversion.conversionRate"}}),_vm._v(" "),_c('CurrencyConverter',{ref:"converter",on:{"conversionRate":function($event){_vm.setCurrencyConversionRate($event)}}})],1):_vm._e(),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Amount","prepend-icon":"fas fa-money-bill","type":"number","min":"1","error-messages":_vm.foreignCurrencyAmountErrors},on:{"input":function($event){_vm.$v.editIncome.foreignCurrencyAmount.$touch(), _vm.calculateConvertedAmount()},"blur":function($event){_vm.$v.editIncome.foreignCurrencyAmount.$touch()}},model:{value:(_vm.editIncome.foreignCurrencyAmount),callback:function ($$v) {_vm.$set(_vm.editIncome, "foreignCurrencyAmount", $$v)},expression:"editIncome.foreignCurrencyAmount"}})],1):_vm._e(),_vm._v(" "),(!_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Income Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.incomeAmountErrors},on:{"input":function($event){_vm.$v.editIncome.incomeAmount.$touch()},"blur":function($event){_vm.$v.editIncome.incomeAmount.$touch()}},model:{value:(_vm.editIncome.incomeAmount),callback:function ($$v) {_vm.$set(_vm.editIncome, "incomeAmount", $$v)},expression:"editIncome.incomeAmount"}})],1):_vm._e(),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Converted Amount","prepend-icon":"fa-money-bill-alt"},model:{value:(_vm.editIncome.incomeAmount),callback:function ($$v) {_vm.$set(_vm.editIncome, "incomeAmount", $$v)},expression:"editIncome.incomeAmount"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Comment","prepend-icon":"fa-comment"},model:{value:(_vm.editIncome.comment),callback:function ($$v) {_vm.$set(_vm.editIncome, "comment", $$v)},expression:"editIncome.comment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":"Recurring Income"},model:{value:(_vm.recurringIncome),callback:function ($$v) {_vm.recurringIncome=$$v},expression:"recurringIncome"}})],1),_vm._v(" "),(!_vm.recurringIncome)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"dialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.editIncome.incomeDate},on:{"update:returnValue":function($event){_vm.$set(_vm.editIncome, "incomeDate", $event)}},model:{value:(_vm.editModelIncomeDate),callback:function ($$v) {_vm.editModelIncomeDate=$$v},expression:"editModelIncomeDate"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Income Date","prepend-icon":"event","error-messages":_vm.incomeDateErrors,"readonly":""},on:{"input":function($event){_vm.$v.editIncome.incomeDate.$touch()},"blur":function($event){_vm.$v.editIncome.incomeDate.$touch()}},slot:"activator",model:{value:(_vm.editIncome.incomeDate),callback:function ($$v) {_vm.$set(_vm.editIncome, "incomeDate", $$v)},expression:"editIncome.incomeDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.editIncome.incomeDate),callback:function ($$v) {_vm.$set(_vm.editIncome, "incomeDate", $$v)},expression:"editIncome.incomeDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.editModelIncomeDate = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.dialog.save(_vm.editIncome.incomeDate)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.recurringIncome)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"timemenu",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.editIncome.incomeTime},on:{"update:returnValue":function($event){_vm.$set(_vm.editIncome, "incomeTime", $event)}},model:{value:(_vm.timemenuvisibilty),callback:function ($$v) {_vm.timemenuvisibilty=$$v},expression:"timemenuvisibilty"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Time Picker","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.editIncome.incomeTime),callback:function ($$v) {_vm.$set(_vm.editIncome, "incomeTime", $$v)},expression:"editIncome.incomeTime"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"actions":""},model:{value:(_vm.editIncome.incomeTime),callback:function ($$v) {_vm.$set(_vm.editIncome, "incomeTime", $$v)},expression:"editIncome.incomeTime"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timemenuvisibilty = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.timemenu.save(_vm.editIncome.incomeTime)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.recurringIncome)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Repeat Every","type":"number","min":"1","max":"60"},model:{value:(_vm.editIncome.repeat),callback:function ($$v) {_vm.$set(_vm.editIncome, "repeat", $$v)},expression:"editIncome.repeat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":['Day','Week','Month','Year']},model:{value:(_vm.editIncome.cycle),callback:function ($$v) {_vm.$set(_vm.editIncome, "cycle", $$v)},expression:"editIncome.cycle"}})],1)],1),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.editIncome.period),callback:function ($$v) {_vm.$set(_vm.editIncome, "period", $$v)},expression:"editIncome.period"}},[_c('v-radio',{attrs:{"label":"Forever","value":"Forever"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"For Number of cycles","value":"For"}})],1),_vm._v(" "),(_vm.editIncome.period === 'For')?_c('v-text-field',{attrs:{"label":"Number of cycles","type":"number","min":"1","max":"60"},model:{value:(_vm.editIncome.numberOfCycles),callback:function ($$v) {_vm.$set(_vm.editIncome, "numberOfCycles", $$v)},expression:"editIncome.numberOfCycles"}}):_vm._e(),_vm._v(" "),_c('v-dialog',{ref:"goesOff",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.editIncome.goesOffFirst},on:{"update:returnValue":function($event){_vm.$set(_vm.editIncome, "goesOffFirst", $event)}},model:{value:(_vm.editModelGoesOff),callback:function ($$v) {_vm.editModelGoesOff=$$v},expression:"editModelGoesOff"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.editIncome.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.editIncome, "goesOffFirst", $$v)},expression:"editIncome.goesOffFirst"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.editIncome.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.editIncome, "goesOffFirst", $$v)},expression:"editIncome.goesOffFirst"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.editModelGoesOff = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.goesOff.save(_vm.editIncome.goesOffFirst)}}},[_vm._v("OK")])],1)],1)],1):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewExpenses_vue__ = __webpack_require__(153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e98a9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewExpenses_vue__ = __webpack_require__(344);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewExpenses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e98a9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewExpenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"card-flex-toolbar noPadding",staticStyle:{"width":"100%"},attrs:{"fluid":"","scrollable":""}},[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Expenses")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","flat":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ path: '/dashboard/addexpense' })}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-plus")])],1),_vm._v(" "),_c('span',[_vm._v("Add Expense")])],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"direction":_vm.direction,"transition":_vm.transition},model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","small":"","fab":""},slot:"activator",model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-icon',[_vm._v("fas fa-ellipsis-v")]),_vm._v(" "),_c('v-icon',[_vm._v("fas fa-times")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewSearch = !_vm.viewSearch}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-search")])],1),_vm._v(" "),_c('span',[_vm._v("Search")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewFilter = !_vm.viewFilter}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-filter")])],1),_vm._v(" "),_c('span',[_vm._v("Filter")])],1)],1)],1),_vm._v(" "),_c('v-container',{class:{'padContent': !_vm.drawer},staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.viewSearch === true)?[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Search"},on:{"change":_vm.getSearchItems,"input":_vm.getSearchItems},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]:_vm._e(),_vm._v(" "),(_vm.viewFilter === true)?[_c('v-flex',{attrs:{"xs12":""}})]:_vm._e(),_vm._v(" "),(_vm.itemsMinusDeleted.length === 0)?[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Sorry, There is currently no data to display here")]),_vm._v(" "),_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-frown")])],1)],1)],1)],1)]:_vm._e(),_vm._v(" "),_vm._l((_vm.itemsMinusDeleted),function(itemMinus){return _c('ListItem',{key:itemMinus.id,ref:"listItem",refInFor:true,attrs:{"liItem":{type: 'expense',data: itemMinus}},on:{"Edit":function($event){_vm.redirectToEditPage($event)},"Delete":function($event){_vm.DeleteExpense($event)}}})})],2)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete")]),_vm._v(" "),_c('v-card-text',[_vm._v("Are you sure you want to delete "),_c('b',[_vm._v("\""+_vm._s(_vm.deleteExpense.expenseName)+"\"")]),_vm._v("?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.DeleteExpenseAccept()}}},[_vm._v("Yes")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddExpenses_vue__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae54ec8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddExpenses_vue__ = __webpack_require__(349);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddExpenses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae54ec8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddExpenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Items_vue__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c7698e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Items_vue__ = __webpack_require__(348);
function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07c7698e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Items_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c7698e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Items_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-expansion-panel',{attrs:{"popout":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b',[_vm._v("Items")])]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.ItemsSearch),callback:function ($$v) {_vm.ItemsSearch=$$v},expression:"ItemsSearch"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticStyle:{"float":"right"},attrs:{"slot":"activator","small":"","fab":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.addItem = true}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-plus")])],1),_vm._v(" "),_c('span',[_vm._v("Add Item")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":""}},[_c('v-card',{class:{'dark-mode':_vm.$store.state.NightMode.sideNav == 'dark-mode','light-mode':_vm.$store.state.NightMode.sideNav == 'light-mode'},staticStyle:{"width":"100%","margin-bottom":"1px"}},[_c('v-container',{staticStyle:{"padding":"10px"},attrs:{"fluid":""}},[_c('v-card-text',{staticStyle:{"padding":"2px"}},_vm._l((_vm.items),function(item){return _c('v-layout',{key:item.id,attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""},on:{"click":function($event){$event.preventDefault();item.show = !item.show}}},[_c('div',[_vm._v(_vm._s(item.itemName))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""},on:{"click":function($event){$event.preventDefault();item.show = !item.show}}},[_c('span',[_vm._v(_vm._s(item.itemPrice)+" "+_vm._s(item.itemCurrency))])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(item.show),expression:"item.show"}],attrs:{"xs12":""}},[_c('v-slide-y-transition',[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-toolbar',{staticStyle:{"width":"170px","margin-left":"auto","margin-right":"auto","border-radius":"28px"},attrs:{"flat":""}},[_c('v-btn',{staticClass:"mx-0",staticStyle:{"margin-left":"15px !important"},attrs:{"icon":""},on:{"click":function($event){$event.preventDefault();_vm.editItem(item.id)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",staticStyle:{"margin-right":"15px !important"},attrs:{"icon":""},on:{"click":function($event){$event.preventDefault();_vm.deleteItem(item)}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("delete")])],1)],1),_vm._v(" "),(item.taxedPrice !== '' && item.taxedPrice !== 0)?_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Total With Tax: "+_vm._s(item.taxedPrice))]):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider')],1)}))],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"500px"},model:{value:(_vm.addItem),callback:function ($$v) {_vm.addItem=$$v},expression:"addItem"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("New Item")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.addItemCheck(_vm.$v.ItemTemp)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.addItem = false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-combobox',{attrs:{"items":_vm.ItemsNames,"chips":"","label":"Item Name"},model:{value:(_vm.ItemTemp.itemName),callback:function ($$v) {_vm.$set(_vm.ItemTemp, "itemName", $$v)},expression:"ItemTemp.itemName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Item Price","type":"number","min":"1","error-messages":_vm.ItemPriceErrors},on:{"input":function($event){_vm.$v.ItemTemp.itemPrice.$touch()},"blur":function($event){_vm.$v.ItemTemp.itemPrice.$touch()}},model:{value:(_vm.ItemTemp.itemPrice),callback:function ($$v) {_vm.$set(_vm.ItemTemp, "itemPrice", $$v)},expression:"ItemTemp.itemPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":_vm.curriencies,"label":"Currency","single-line":"","error-messages":_vm.ItemCurrencyErrors},on:{"input":function($event){_vm.$v.ItemTemp.itemCurrency.$touch()},"blur":function($event){_vm.$v.ItemTemp.itemCurrency.$touch()}},model:{value:(_vm.ItemTemp.itemCurrency),callback:function ($$v) {_vm.$set(_vm.ItemTemp, "itemCurrency", $$v)},expression:"ItemTemp.itemCurrency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"Add Tax to item?"},model:{value:(_vm.ItemTemp.isTaxed),callback:function ($$v) {_vm.$set(_vm.ItemTemp, "isTaxed", $$v)},expression:"ItemTemp.isTaxed"}})],1),_vm._v(" "),(_vm.ItemTemp.isTaxed)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Total WIth Tax","type":"number"},model:{value:(_vm.ItemTemp.taxedPrice),callback:function ($$v) {_vm.$set(_vm.ItemTemp, "taxedPrice", $$v)},expression:"ItemTemp.taxedPrice"}})],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"500px"},model:{value:(_vm.editItems),callback:function ($$v) {_vm.editItems=$$v},expression:"editItems"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Edit Item")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.editItemCheck(_vm.$v.editItemTemp)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.editItems = false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-combobox',{attrs:{"items":_vm.ItemsNames,"chips":"","label":"Item Name"},model:{value:(_vm.editItemTemp.itemName),callback:function ($$v) {_vm.$set(_vm.editItemTemp, "itemName", $$v)},expression:"editItemTemp.itemName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Item Price","type":"number","min":"1","error-messages":_vm.ItemPriceErrors},on:{"input":function($event){_vm.$v.editItemTemp.itemPrice.$touch()},"blur":function($event){_vm.$v.editItemTemp.itemPrice.$touch()}},model:{value:(_vm.editItemTemp.itemPrice),callback:function ($$v) {_vm.$set(_vm.editItemTemp, "itemPrice", $$v)},expression:"editItemTemp.itemPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":_vm.curriencies,"label":"Currency","single-line":"","error-messages":_vm.ItemCurrencyErrors},on:{"input":function($event){_vm.$v.editItemTemp.itemCurrency.$touch()},"blur":function($event){_vm.$v.editItemTemp.itemCurrency.$touch()}},model:{value:(_vm.editItemTemp.itemCurrency),callback:function ($$v) {_vm.$set(_vm.editItemTemp, "itemCurrency", $$v)},expression:"editItemTemp.itemCurrency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"Add Tax to item?"},model:{value:(_vm.editItemTemp.isTaxed),callback:function ($$v) {_vm.$set(_vm.editItemTemp, "isTaxed", $$v)},expression:"editItemTemp.isTaxed"}})],1),_vm._v(" "),(_vm.editItemTemp.isTaxed)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Total WIth Tax","type":"number"},model:{value:(_vm.editItemTemp.taxedPrice),callback:function ($$v) {_vm.$set(_vm.editItemTemp, "taxedPrice", $$v)},expression:"editItemTemp.taxedPrice"}})],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete")]),_vm._v(" "),_c('v-card-text',[_vm._v("Are you sure you want to delete "),_c('b',[_vm._v("\""+_vm._s(_vm.deleteItemTemp.itemName)+"\"")]),_vm._v("?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.deleteItemAccept()}}},[_vm._v("Yes")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("New Expense")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.addExpenseCheck(_vm.$v.currentExpense)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/expense' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-top":"0"}},[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.curriencies,"label":"Currency","chips":"","hint":"What Currency is this Expense in?","persistent-hint":"","error-messages":_vm.currencyErrors},on:{"input":function($event){_vm.$v.currentExpense.currency.$touch(), _vm.adjustCurrency()},"blur":function($event){_vm.$v.currentExpense.currency.$touch()}},model:{value:(_vm.currentExpense.currency),callback:function ($$v) {_vm.$set(_vm.currentExpense, "currency", $$v)},expression:"currentExpense.currency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Expense Name","error-messages":_vm.expenseNameErrors,"clearable":""},on:{"input":function($event){_vm.$v.currentExpense.expenseName.$touch()},"blur":function($event){_vm.$v.currentExpense.expenseName.$touch()}},model:{value:(_vm.currentExpense.expenseName),callback:function ($$v) {_vm.$set(_vm.currentExpense, "expenseName", $$v)},expression:"currentExpense.expenseName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.account,"label":"Account","chips":"","prepend-icon":"fa-balance-scale","hint":"What Account does this belong to?","persistent-hint":"","error-messages":_vm.accountErrors},on:{"change":_vm.clearBudgetOnAccountChange,"input":function($event){_vm.$v.currentExpense.account.$touch(), _vm.adjustCurrency(), _vm.clearBudgetOnAccountChange()},"blur":function($event){_vm.$v.currentExpense.account.$touch()}},model:{value:(_vm.currentExpense.account),callback:function ($$v) {_vm.$set(_vm.currentExpense, "account", $$v)},expression:"currentExpense.account"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.budget,"label":"Budget","chips":"","prepend-icon":"fas fa-calculator","hint":"What Budget does this belong to?","persistent-hint":"","error-messages":_vm.budgetErrors},on:{"change":_vm.adjustAccountToMatchBudgetOnBudgetChange,"input":function($event){_vm.$v.currentExpense.budget.$touch(); _vm.adjustAccountToMatchBudgetOnBudgetChange()},"blur":function($event){_vm.$v.currentExpense.budget.$touch()}},model:{value:(_vm.currentExpense.budget),callback:function ($$v) {_vm.$set(_vm.currentExpense, "budget", $$v)},expression:"currentExpense.budget"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.category,"label":"Category","chips":"","prepend-icon":"fa-tag","hint":"What Category does this belong to?","persistent-hint":"","error-messages":_vm.categoryErrors},on:{"input":function($event){_vm.$v.currentExpense.category.$touch()},"blur":function($event){_vm.$v.currentExpense.category.$touch()}},model:{value:(_vm.currentExpense.category),callback:function ($$v) {_vm.$set(_vm.currentExpense, "category", $$v)},expression:"currentExpense.category"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('Items',{attrs:{"itype":'expense'},on:{"ItemToAdd":function($event){_vm.addItemToExpense($event)}}})],1),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Currency Conversion","prepend-icon":"fas fa-balance-scale","error-messages":_vm.currencyConversionErrors},on:{"click":function($event){$event.preventDefault();_vm.getCurrencyConvertionRate()},"focus":function($event){_vm.getCurrencyConvertionRate()},"input":function($event){_vm.$v.currentExpense.currencyConversion.$touch()},"blur":function($event){_vm.$v.currentExpense.currencyConversion.$touch()}},model:{value:(_vm.currentExpense.currencyConversion.conversionRate),callback:function ($$v) {_vm.$set(_vm.currentExpense.currencyConversion, "conversionRate", $$v)},expression:"currentExpense.currencyConversion.conversionRate"}}),_vm._v(" "),_c('CurrencyConverter',{ref:"converter",on:{"conversionRate":function($event){_vm.setCurrencyConversionRate($event)}}})],1):_vm._e(),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Amount","prepend-icon":"fas fa-money-bill","type":"number","min":"1","error-messages":_vm.foreignCurrencyAmountErrors},on:{"input":function($event){_vm.$v.currentExpense.foreignCurrencyAmount.$touch(), _vm.calculateConvertedAmount()},"blur":function($event){_vm.$v.currentExpense.foreignCurrencyAmount.$touch()}},model:{value:(_vm.currentExpense.foreignCurrencyAmount),callback:function ($$v) {_vm.$set(_vm.currentExpense, "foreignCurrencyAmount", $$v)},expression:"currentExpense.foreignCurrencyAmount"}})],1):_vm._e(),_vm._v(" "),(!_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Expense Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.expenseAmountErrors},on:{"input":function($event){_vm.$v.currentExpense.expenseAmount.$touch()},"blur":function($event){_vm.$v.currentExpense.expenseAmount.$touch()}},model:{value:(_vm.currentExpense.expenseAmount),callback:function ($$v) {_vm.$set(_vm.currentExpense, "expenseAmount", $$v)},expression:"currentExpense.expenseAmount"}})],1):_vm._e(),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Converted Amount","prepend-icon":"fa-money-bill-alt"},model:{value:(_vm.currentExpense.expenseAmount),callback:function ($$v) {_vm.$set(_vm.currentExpense, "expenseAmount", $$v)},expression:"currentExpense.expenseAmount"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Comment","prepend-icon":"fa-comment","clearable":""},model:{value:(_vm.currentExpense.comment),callback:function ($$v) {_vm.$set(_vm.currentExpense, "comment", $$v)},expression:"currentExpense.comment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":"Recurring Expense"},model:{value:(_vm.recurringExpense),callback:function ($$v) {_vm.recurringExpense=$$v},expression:"recurringExpense"}})],1),_vm._v(" "),(!_vm.recurringExpense)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"dialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.currentExpense.expenseDate},on:{"update:returnValue":function($event){_vm.$set(_vm.currentExpense, "expenseDate", $event)}},model:{value:(_vm.addModelExpenseDate),callback:function ($$v) {_vm.addModelExpenseDate=$$v},expression:"addModelExpenseDate"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Expense Date","prepend-icon":"event","error-messages":_vm.expenseDateErrors,"readonly":""},on:{"input":function($event){_vm.$v.currentExpense.expenseDate.$touch()},"blur":function($event){_vm.$v.currentExpense.expenseDate.$touch()}},slot:"activator",model:{value:(_vm.currentExpense.expenseDate),callback:function ($$v) {_vm.$set(_vm.currentExpense, "expenseDate", $$v)},expression:"currentExpense.expenseDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.currentExpense.expenseDate),callback:function ($$v) {_vm.$set(_vm.currentExpense, "expenseDate", $$v)},expression:"currentExpense.expenseDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.addModelExpenseDate = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.dialog.save(_vm.currentExpense.expenseDate)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.recurringExpense)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"timemenu",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.currentExpense.expenseTime},on:{"update:returnValue":function($event){_vm.$set(_vm.currentExpense, "expenseTime", $event)}},model:{value:(_vm.timemenuvisibilty),callback:function ($$v) {_vm.timemenuvisibilty=$$v},expression:"timemenuvisibilty"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Time Picker","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.currentExpense.expenseTime),callback:function ($$v) {_vm.$set(_vm.currentExpense, "expenseTime", $$v)},expression:"currentExpense.expenseTime"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"actions":""},model:{value:(_vm.currentExpense.expenseTime),callback:function ($$v) {_vm.$set(_vm.currentExpense, "expenseTime", $$v)},expression:"currentExpense.expenseTime"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timemenuvisibilty = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.timemenu.save(_vm.currentExpense.expenseTime)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.recurringExpense)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Repeat Every","type":"number","min":"1","max":"60"},model:{value:(_vm.currentExpense.repeat),callback:function ($$v) {_vm.$set(_vm.currentExpense, "repeat", $$v)},expression:"currentExpense.repeat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":['Day','Week','Month','Year']},model:{value:(_vm.currentExpense.cycle),callback:function ($$v) {_vm.$set(_vm.currentExpense, "cycle", $$v)},expression:"currentExpense.cycle"}})],1)],1),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.currentExpense.period),callback:function ($$v) {_vm.$set(_vm.currentExpense, "period", $$v)},expression:"currentExpense.period"}},[_c('v-radio',{attrs:{"label":"Forever","value":"Forever"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"For Number of cycles","value":"For"}})],1),_vm._v(" "),(_vm.currentExpense.period === 'For')?_c('v-text-field',{attrs:{"label":"Number of cycles","type":"number","min":"1","max":"60"},model:{value:(_vm.currentExpense.numberOfCycles),callback:function ($$v) {_vm.$set(_vm.currentExpense, "numberOfCycles", $$v)},expression:"currentExpense.numberOfCycles"}}):_vm._e(),_vm._v(" "),_c('v-dialog',{ref:"goesOff",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.currentExpense.goesOffFirst},on:{"update:returnValue":function($event){_vm.$set(_vm.currentExpense, "goesOffFirst", $event)}},model:{value:(_vm.addModelGoesOff),callback:function ($$v) {_vm.addModelGoesOff=$$v},expression:"addModelGoesOff"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentExpense.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.currentExpense, "goesOffFirst", $$v)},expression:"currentExpense.goesOffFirst"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.currentExpense.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.currentExpense, "goesOffFirst", $$v)},expression:"currentExpense.goesOffFirst"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.addModelGoesOff = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.goesOff.save(_vm.currentExpense.goesOffFirst)}}},[_vm._v("OK")])],1)],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.error),callback:function ($$v) {_vm.error=$$v},expression:"error"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline red--text"},[_c('i',{staticClass:"fas fa-exclamation-triangle red--text"}),_vm._v(" Error")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.error=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditExpenses_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bbefcf1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditExpenses_vue__ = __webpack_require__(351);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditExpenses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bbefcf1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditExpenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Edit Expense")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.UpdateEditedExpense(_vm.$v.editExpense)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/expense' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-top":"0"}},[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"x12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.curriencies,"label":"Currency","chips":"","error-messages":_vm.currencyErrors},on:{"input":function($event){_vm.$v.editExpense.currency.$touch(), _vm.adjustCurrency()},"blur":function($event){_vm.$v.editExpense.currency.$touch()}},model:{value:(_vm.editExpense.currency),callback:function ($$v) {_vm.$set(_vm.editExpense, "currency", $$v)},expression:"editExpense.currency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Expense Name","error-messages":_vm.expenseNameErrors},on:{"input":function($event){_vm.$v.editExpense.expenseName.$touch()},"blur":function($event){_vm.$v.editExpense.expenseName.$touch()}},model:{value:(_vm.editExpense.expenseName),callback:function ($$v) {_vm.$set(_vm.editExpense, "expenseName", $$v)},expression:"editExpense.expenseName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.account,"label":"Account","auto":"","prepend-icon":"fa-balance-scale","hint":"What Account does this belong to?","persistent-hint":"","error-messages":_vm.accountErrors},on:{"input":function($event){_vm.$v.editExpense.account.$touch()},"blur":function($event){_vm.$v.editExpense.account.$touch()}},model:{value:(_vm.editExpense.account),callback:function ($$v) {_vm.$set(_vm.editExpense, "account", $$v)},expression:"editExpense.account"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.budget,"label":"Budget","chips":"","prepend-icon":"fas fa-calculator","hint":"What Budget does this belong to?","persistent-hint":"","error-messages":_vm.budgetErrors},on:{"input":function($event){_vm.$v.editExpense.budget.$touch()},"blur":function($event){_vm.$v.editExpense.budget.$touch()}},model:{value:(_vm.editExpense.budget),callback:function ($$v) {_vm.$set(_vm.editExpense, "budget", $$v)},expression:"editExpense.budget"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.category,"label":"Category","chips":"","prepend-icon":"fa-tag","hint":"What Category does this belong to?","persistent-hint":"","error-messages":_vm.categoryErrors},on:{"input":function($event){_vm.$v.editExpense.category.$touch()},"blur":function($event){_vm.$v.editExpense.category.$touch()}},model:{value:(_vm.editExpense.category),callback:function ($$v) {_vm.$set(_vm.editExpense, "category", $$v)},expression:"editExpense.category"}})],1),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Currency Conversion","prepend-icon":"fas fa-balance-scale","error-messages":_vm.currencyConversionErrors},on:{"click":function($event){$event.preventDefault();_vm.getCurrencyConvertionRate()},"focus":function($event){_vm.getCurrencyConvertionRate()},"input":function($event){_vm.$v.editExpense.currencyConversion.$touch()},"blur":function($event){_vm.$v.editExpense.currencyConversion.$touch()}},model:{value:(_vm.editExpense.currencyConversion),callback:function ($$v) {_vm.$set(_vm.editExpense, "currencyConversion", $$v)},expression:"editExpense.currencyConversion"}}),_vm._v(" "),_c('CurrencyConverter',{ref:"converter",on:{"conversionRate":function($event){_vm.setCurrencyConversionRate($event)}}})],1):_vm._e(),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Amount","prepend-icon":"fas fa-money-bill","type":"number","min":"1","error-messages":_vm.foreignCurrencyAmountErrors},on:{"input":function($event){_vm.$v.editExpense.foreignCurrencyAmount.$touch(), _vm.calculateConvertedAmount()},"blur":function($event){_vm.$v.editExpense.foreignCurrencyAmount.$touch()}},model:{value:(_vm.editExpense.foreignCurrencyAmount),callback:function ($$v) {_vm.$set(_vm.editExpense, "foreignCurrencyAmount", $$v)},expression:"editExpense.foreignCurrencyAmount"}})],1):_vm._e(),_vm._v(" "),(!_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Expense Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.expenseAmountErrors},on:{"input":function($event){_vm.$v.editExpense.expenseAmount.$touch()},"blur":function($event){_vm.$v.editExpense.expenseAmount.$touch()}},model:{value:(_vm.editExpense.expenseAmount),callback:function ($$v) {_vm.$set(_vm.editExpense, "expenseAmount", $$v)},expression:"editExpense.expenseAmount"}})],1):_vm._e(),_vm._v(" "),(_vm.conversion)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Converted Amount","prepend-icon":"fa-money-bill-alt"},model:{value:(_vm.editExpense.expenseAmount),callback:function ($$v) {_vm.$set(_vm.editExpense, "expenseAmount", $$v)},expression:"editExpense.expenseAmount"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Comment","prepend-icon":"fa-comment"},model:{value:(_vm.editExpense.comment),callback:function ($$v) {_vm.$set(_vm.editExpense, "comment", $$v)},expression:"editExpense.comment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":"Recurring Expense"},model:{value:(_vm.recurringExpense),callback:function ($$v) {_vm.recurringExpense=$$v},expression:"recurringExpense"}})],1),_vm._v(" "),(!_vm.recurringExpense)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"dialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.editExpense.expenseDate},on:{"update:returnValue":function($event){_vm.$set(_vm.editExpense, "expenseDate", $event)}},model:{value:(_vm.editModelExpenseDate),callback:function ($$v) {_vm.editModelExpenseDate=$$v},expression:"editModelExpenseDate"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Expense Date","prepend-icon":"event","error-messages":_vm.expenseDateErrors,"readonly":""},on:{"input":function($event){_vm.$v.editExpense.expenseDate.$touch()},"blur":function($event){_vm.$v.editExpense.expenseDate.$touch()}},slot:"activator",model:{value:(_vm.editExpense.expenseDate),callback:function ($$v) {_vm.$set(_vm.editExpense, "expenseDate", $$v)},expression:"editExpense.expenseDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.editExpense.expenseDate),callback:function ($$v) {_vm.$set(_vm.editExpense, "expenseDate", $$v)},expression:"editExpense.expenseDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.editModelExpenseDate = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.dialog.save(_vm.editExpense.expenseDate)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.recurringExpense)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"timemenu",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.editExpense.expenseTime},on:{"update:returnValue":function($event){_vm.$set(_vm.editExpense, "expenseTime", $event)}},model:{value:(_vm.timemenuvisibilty),callback:function ($$v) {_vm.timemenuvisibilty=$$v},expression:"timemenuvisibilty"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Time Picker","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.editExpense.expenseTime),callback:function ($$v) {_vm.$set(_vm.editExpense, "expenseTime", $$v)},expression:"editExpense.expenseTime"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"actions":""},model:{value:(_vm.editExpense.expenseTime),callback:function ($$v) {_vm.$set(_vm.editExpense, "expenseTime", $$v)},expression:"editExpense.expenseTime"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timemenuvisibilty = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.timemenu.save(_vm.editExpense.expenseTime)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.recurringExpense)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Repeat Every","type":"number","min":"1","max":"60"},model:{value:(_vm.editExpense.repeat),callback:function ($$v) {_vm.$set(_vm.editExpense, "repeat", $$v)},expression:"editExpense.repeat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":['Day','Week','Month','Year']},model:{value:(_vm.editExpense.cycle),callback:function ($$v) {_vm.$set(_vm.editExpense, "cycle", $$v)},expression:"editExpense.cycle"}})],1)],1),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.editExpense.period),callback:function ($$v) {_vm.$set(_vm.editExpense, "period", $$v)},expression:"editExpense.period"}},[_c('v-radio',{attrs:{"label":"Forever","value":"Forever"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"For Number of cycles","value":"For"}})],1),_vm._v(" "),(_vm.editExpense.period === 'For')?_c('v-text-field',{attrs:{"label":"Number of cycles","type":"number","min":"1","max":"60"},model:{value:(_vm.editExpense.numberOfCycles),callback:function ($$v) {_vm.$set(_vm.editExpense, "numberOfCycles", $$v)},expression:"editExpense.numberOfCycles"}}):_vm._e(),_vm._v(" "),_c('v-dialog',{ref:"goesOff",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.editExpense.goesOffFirst},on:{"update:returnValue":function($event){_vm.$set(_vm.editExpense, "goesOffFirst", $event)}},model:{value:(_vm.addModelGoesOff),callback:function ($$v) {_vm.addModelGoesOff=$$v},expression:"addModelGoesOff"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.editExpense.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.editExpense, "goesOffFirst", $$v)},expression:"editExpense.goesOffFirst"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.editExpense.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.editExpense, "goesOffFirst", $$v)},expression:"editExpense.goesOffFirst"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.addModelGoesOff = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.goesOff.save(_vm.editExpense.goesOffFirst)}}},[_vm._v("OK")])],1)],1)],1):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewBudgets_vue__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ceb200b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewBudgets_vue__ = __webpack_require__(353);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewBudgets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ceb200b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewBudgets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"card-flex-toolbar noPadding",staticStyle:{"width":"100%"},attrs:{"fluid":"","scrollable":""}},[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Budgets")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","flat":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ path: '/dashboard/addbudget' })}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-plus")])],1),_vm._v(" "),_c('span',[_vm._v("Add Budget")])],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"direction":_vm.direction,"transition":_vm.transition},model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","small":"","fab":""},slot:"activator",model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-icon',[_vm._v("fas fa-ellipsis-v")]),_vm._v(" "),_c('v-icon',[_vm._v("fas fa-times")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewSearch = !_vm.viewSearch}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-search")])],1),_vm._v(" "),_c('span',[_vm._v("Search")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewFilter = !_vm.viewFilter}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-filter")])],1),_vm._v(" "),_c('span',[_vm._v("Filter")])],1)],1)],1),_vm._v(" "),_c('v-container',{class:{'padContent': !_vm.drawer},staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.itemsMinusDeleted),function(itemMinus){return _c('ListItem',{key:itemMinus.id,ref:"listItem",refInFor:true,attrs:{"liItem":{type: 'budget',data: itemMinus}},on:{"Edit":function($event){_vm.redirectToEditPage($event)},"Delete":function($event){_vm.DeleteBudget($event)}}})}))],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete")]),_vm._v(" "),_c('v-card-text',[_vm._v("Are you sure you want to delete "),_c('b',[_vm._v("\""+_vm._s(_vm.deleteBudget.budgetName)+"\"")]),_vm._v("?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.DeleteBudgetAccept()}}},[_vm._v("Yes")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBudgets_vue__ = __webpack_require__(158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a80631f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBudgets_vue__ = __webpack_require__(355);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBudgets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a80631f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBudgets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("New Budget")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.AddBudgetCheck(_vm.$v.currentBudget)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/budget' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-top":"0"}},[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"x12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.curriencies,"label":"Currency","chips":"","hint":"What Currency is this Income in?","persistent-hint":"","error-messages":_vm.currencyErrors},on:{"input":function($event){_vm.$v.currentBudget.currency.$touch(), _vm.adjustCurrency()},"blur":function($event){_vm.$v.currentBudget.currency.$touch()}},model:{value:(_vm.currentBudget.currency),callback:function ($$v) {_vm.$set(_vm.currentBudget, "currency", $$v)},expression:"currentBudget.currency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Budget Name","error-messages":_vm.budgetNameErrors},on:{"input":function($event){_vm.$v.currentBudget.budgetName.$touch()},"blur":function($event){_vm.$v.currentBudget.budgetName.$touch()}},model:{value:(_vm.currentBudget.budgetName),callback:function ($$v) {_vm.$set(_vm.currentBudget, "budgetName", $$v)},expression:"currentBudget.budgetName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.account,"label":"Account","chips":"","prepend-icon":"fa-balance-scale","hint":"What Account does this belong to?","persistent-hint":"","error-messages":_vm.accountErrors},on:{"input":function($event){_vm.$v.currentBudget.account.$touch()},"blur":function($event){_vm.$v.currentBudget.account.$touch()}},model:{value:(_vm.currentBudget.account),callback:function ($$v) {_vm.$set(_vm.currentBudget, "account", $$v)},expression:"currentBudget.account"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.category,"label":"Category","multiple":"","chips":"","prepend-icon":"fa-tags","hint":"What Category does this belong to?","persistent-hint":"","error-messages":_vm.categoryErrors},on:{"input":function($event){_vm.$v.currentBudget.category.$touch()},"blur":function($event){_vm.$v.currentBudget.category.$touch()}},model:{value:(_vm.currentBudget.category),callback:function ($$v) {_vm.$set(_vm.currentBudget, "category", $$v)},expression:"currentBudget.category"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.type,"label":"budget Type","chips":"","prepend-icon":"fa-tag","hint":"What Budget Type is this?","persistent-hint":"","error-messages":_vm.budgetTypeErrors},on:{"input":function($event){_vm.$v.currentBudget.budgetType.$touch()},"blur":function($event){_vm.$v.currentBudget.budgetType.$touch()}},model:{value:(_vm.currentBudget.budgetType),callback:function ($$v) {_vm.$set(_vm.currentBudget, "budgetType", $$v)},expression:"currentBudget.budgetType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Budget Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.budgetAmountErrors},on:{"change":_vm.copyBudgetAmountToRefillAmount,"input":function($event){_vm.$v.currentBudget.budgetAmount.$touch()},"blur":function($event){_vm.$v.currentBudget.budgetAmount.$touch()}},model:{value:(_vm.currentBudget.budgetAmount),callback:function ($$v) {_vm.$set(_vm.currentBudget, "budgetAmount", $$v)},expression:"currentBudget.budgetAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Refill Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.refillAmountErrors},on:{"input":function($event){_vm.$v.currentBudget.refillAmount.$touch(), _vm.stopCopyBudgetAmountToRefillAmount()},"blur":function($event){_vm.$v.currentBudget.refillAmount.$touch()}},model:{value:(_vm.currentBudget.refillAmount),callback:function ($$v) {_vm.$set(_vm.currentBudget, "refillAmount", $$v)},expression:"currentBudget.refillAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Comment","prepend-icon":"fa-comment"},model:{value:(_vm.currentBudget.comment),callback:function ($$v) {_vm.$set(_vm.currentBudget, "comment", $$v)},expression:"currentBudget.comment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',[_c('b',[_vm._v("Budget Overspent")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","lg4":""}},[_c('p',[_vm._v("Notify me when amount spent has exceeded budgeted amount")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg8":""}},[_c('v-switch',{model:{value:(_vm.currentBudget.budgetOverspent),callback:function ($$v) {_vm.$set(_vm.currentBudget, "budgetOverspent", $$v)},expression:"currentBudget.budgetOverspent"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',[_c('b',[_vm._v("Overspending Risk")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","lg4":""}},[_c('p',[_vm._v("Notify me when there is a risk of overspending")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg8":""}},[_c('v-switch',{model:{value:(_vm.currentBudget.OverspendingRisk),callback:function ($$v) {_vm.$set(_vm.currentBudget, "OverspendingRisk", $$v)},expression:"currentBudget.OverspendingRisk"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBudgets_vue__ = __webpack_require__(159);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf2fd3d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBudgets_vue__ = __webpack_require__(357);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBudgets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf2fd3d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBudgets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Edit Budget")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.UpdateEditedBudget(_vm.$v.editBudget)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/budget' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-top":"0"}},[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"x12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.curriencies,"label":"Currency","chips":"","hint":"What Currency is this Income in?","persistent-hint":"","error-messages":_vm.currencyErrors},on:{"input":function($event){_vm.$v.editBudget.currency.$touch(), _vm.adjustCurrency()},"blur":function($event){_vm.$v.editBudget.currency.$touch()}},model:{value:(_vm.editBudget.currency),callback:function ($$v) {_vm.$set(_vm.editBudget, "currency", $$v)},expression:"editBudget.currency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Budget Name","error-messages":_vm.budgetNameErrors},on:{"input":function($event){_vm.$v.editBudget.budgetName.$touch()},"blur":function($event){_vm.$v.editBudget.budgetName.$touch()}},model:{value:(_vm.editBudget.budgetName),callback:function ($$v) {_vm.$set(_vm.editBudget, "budgetName", $$v)},expression:"editBudget.budgetName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.account,"label":"Account","chips":"","prepend-icon":"fa-balance-scale","hint":"What Account does this belong to?","persistent-hint":"","error-messages":_vm.accountErrors},on:{"input":function($event){_vm.$v.editBudget.account.$touch()},"blur":function($event){_vm.$v.editBudget.account.$touch()}},model:{value:(_vm.editBudget.account),callback:function ($$v) {_vm.$set(_vm.editBudget, "account", $$v)},expression:"editBudget.account"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.category,"label":"Category","multiple":"","chips":"","prepend-icon":"fa-tags","hint":"What Category does this belong to?","persistent-hint":"","error-messages":_vm.categoryErrors},on:{"input":function($event){_vm.$v.editBudget.category.$touch()},"blur":function($event){_vm.$v.editBudget.category.$touch()}},model:{value:(_vm.editBudget.category),callback:function ($$v) {_vm.$set(_vm.editBudget, "category", $$v)},expression:"editBudget.category"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.type,"label":"budget Type","chips":"","prepend-icon":"fa-tag","hint":"What Budget Type is this?","persistent-hint":"","error-messages":_vm.budgetTypeErrors},on:{"input":function($event){_vm.$v.editBudget.budgetType.$touch()},"blur":function($event){_vm.$v.editBudget.budgetType.$touch()}},model:{value:(_vm.editBudget.budgetType),callback:function ($$v) {_vm.$set(_vm.editBudget, "budgetType", $$v)},expression:"editBudget.budgetType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Budget Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.budgetAmountErrors},on:{"change":_vm.copyBudgetAmountToRefillAmount,"input":function($event){_vm.$v.editBudget.budgetAmount.$touch()},"blur":function($event){_vm.$v.editBudget.budgetAmount.$touch()}},model:{value:(_vm.editBudget.budgetAmount),callback:function ($$v) {_vm.$set(_vm.editBudget, "budgetAmount", $$v)},expression:"editBudget.budgetAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Refill Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.refillAmountErrors},on:{"input":function($event){_vm.$v.editBudget.refillAmount.$touch(), _vm.stopCopyBudgetAmountToRefillAmount()},"blur":function($event){_vm.$v.editBudget.refillAmount.$touch()}},model:{value:(_vm.editBudget.refillAmount),callback:function ($$v) {_vm.$set(_vm.editBudget, "refillAmount", $$v)},expression:"editBudget.refillAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Comment","prepend-icon":"fa-comment"},model:{value:(_vm.editBudget.comment),callback:function ($$v) {_vm.$set(_vm.editBudget, "comment", $$v)},expression:"editBudget.comment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',[_c('b',[_vm._v("Budget Overspent")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","lg4":""}},[_c('p',[_vm._v("Notify me when amount spent has exceeded budgeted amount")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg8":""}},[_c('v-switch',{model:{value:(_vm.editBudget.budgetOverspent),callback:function ($$v) {_vm.$set(_vm.editBudget, "budgetOverspent", $$v)},expression:"editBudget.budgetOverspent"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',[_c('b',[_vm._v("Overspending Risk")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","lg4":""}},[_c('p',[_vm._v("Notify me when there is a risk of overspending")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg8":""}},[_c('v-switch',{model:{value:(_vm.editBudget.OverspendingRisk),callback:function ($$v) {_vm.$set(_vm.editBudget, "OverspendingRisk", $$v)},expression:"editBudget.OverspendingRisk"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewTransactions_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c58bb1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewTransactions_vue__ = __webpack_require__(361);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewTransactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c58bb1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewTransactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e5347c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__ = __webpack_require__(360);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e5347c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":"","max-width":"600px"},model:{value:(_vm.viewFilter),callback:function ($$v) {_vm.viewFilter=$$v},expression:"viewFilter"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Filter")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.setfilteredData()}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.viewFilter = false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":['None','Income', 'Expense', 'Transfer'],"label":"Transaction Type","chips":""},model:{value:(_vm.filterBy.transactionType),callback:function ($$v) {_vm.$set(_vm.filterBy, "transactionType", $$v)},expression:"filterBy.transactionType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":"Budget","items":_vm.budget,"chips":""},model:{value:(_vm.filterBy.budget),callback:function ($$v) {_vm.$set(_vm.filterBy, "budget", $$v)},expression:"filterBy.budget"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.category,"chips":"","label":"Category"},model:{value:(_vm.filterBy.category),callback:function ($$v) {_vm.$set(_vm.filterBy, "category", $$v)},expression:"filterBy.category"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.currency,"label":"Currency","chips":""},model:{value:(_vm.filterBy.currency),callback:function ($$v) {_vm.$set(_vm.filterBy, "currency", $$v)},expression:"filterBy.currency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.paymentType,"chips":"","label":"Payment Type"},model:{value:(_vm.filterBy.paymentType),callback:function ($$v) {_vm.$set(_vm.filterBy, "paymentType", $$v)},expression:"filterBy.paymentType"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"card-flex-toolbar noPadding",staticStyle:{"width":"100%"},attrs:{"fluid":"","scrollable":""}},[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Transactions")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","flat":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ path: '/dashboard/addtransaction' })}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-plus")])],1),_vm._v(" "),_c('span',[_vm._v("Add Transaction")])],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"direction":_vm.direction,"transition":_vm.transition},model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","small":"","fab":""},slot:"activator",model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-icon',[_vm._v("fas fa-ellipsis-v")]),_vm._v(" "),_c('v-icon',[_vm._v("fas fa-times")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewSearch = !_vm.viewSearch}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-search")])],1),_vm._v(" "),_c('span',[_vm._v("Search")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewFilter = !_vm.viewFilter}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-filter")])],1),_vm._v(" "),_c('span',[_vm._v("Filter")])],1)],1)],1),_vm._v(" "),_c('v-container',{class:{'padContent': !_vm.drawer},staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.viewSearch && !_vm.viewFilter)?[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Search","append-icon":"fas fa-search"},on:{"change":_vm.getSearchItems,"input":_vm.getSearchItems},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]:_vm._e(),_vm._v(" "),(_vm.viewFilter)?[_c('MyFilter',{attrs:{"filterBy":_vm.filterBy},on:{"filterData":function($event){_vm.getfilteredData($event)}}})]:_vm._e(),_vm._v(" "),(_vm.itemsMinusDeleted.length === 0)?[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Sorry, There is currently no data to display here")]),_vm._v(" "),_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-frown")])],1)],1)],1)],1)]:_vm._e(),_vm._v(" "),_vm._l((_vm.itemsMinusDeleted),function(itemMinus){return _c('ListItem',{key:itemMinus.id,ref:"listItem",refInFor:true,attrs:{"liItem":{type: 'transaction',data: itemMinus}},on:{"Edit":function($event){_vm.redirectToEditPage($event)},"Delete":function($event){_vm.DeleteTransaction($event)}}})})],2)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete")]),_vm._v(" "),_c('v-card-text',[_vm._v("Are you sure you want to delete this Transaction?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Disagree")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.DeleteTransactionAccept(_vm.$v.deleteTransaction)}}},[_vm._v("Agree")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTransaction_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08dd7a94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTransaction_vue__ = __webpack_require__(363);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTransaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08dd7a94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTransaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("New Transaction")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.AddTransactionCheck(_vm.$v.currentTransaction)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/transaction' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-btn-toggle',{staticStyle:{"width":"100%","margin-top":"15px"},attrs:{"mandatory":""},model:{value:(_vm.currentTransaction.transactionType),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "transactionType", $$v)},expression:"currentTransaction.transactionType"}},[_c('v-btn',{staticStyle:{"width":"33.33%"},attrs:{"flat":"","color":"blue","value":"income"}},[_vm._v("\n                Income\n              ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"width":"33.33%"},attrs:{"flat":"","color":"blue","value":"expense"}},[_vm._v("\n                Expense\n              ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"width":"33.33%"},attrs:{"flat":"","color":"blue","value":"transfer"}},[_vm._v("\n                Transfer\n              ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.currency,"label":"Currency","error-messages":_vm.currencyErrors},on:{"input":function($event){_vm.$v.currentTransaction.currency.$touch()},"blur":function($event){_vm.$v.currentTransaction.currency.$touch()},"change":_vm.selectedCurrencyChanged},model:{value:(_vm.currentTransaction.currency),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "currency", $$v)},expression:"currentTransaction.currency"}})],1),_vm._v(" "),(_vm.convert)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-expansion-panel',{attrs:{"popout":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b',[_vm._v("Conversion Rates")])]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.conversions),function(item){return [_c('v-divider'),_vm._v(" "),_c('v-list-tile',{key:item.title},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.convertFrom)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.convertTo)}})],1)],1)]})],2)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Transaction Name","error-messages":_vm.transactionNameErrors},on:{"input":function($event){_vm.$v.currentTransaction.transactionName.$touch()},"blur":function($event){_vm.$v.currentTransaction.transactionName.$touch()}},model:{value:(_vm.currentTransaction.transactionName),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "transactionName", $$v)},expression:"currentTransaction.transactionName"}})],1),_vm._v(" "),(_vm.currentTransaction.transactionType !== 'transfer')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":"Account","items":_vm.account,"item-text":"accountName","item-value":"accountName","chips":"","prepend-icon":"fas fa-university","hint":"What Account does this belong to?","persistent-hint":"","change":_vm.adjustAccountToMatchBudget,"error-messages":_vm.accountErrors,"max-height":"auto"},on:{"input":function($event){_vm.$v.currentTransaction.account.$touch()},"blur":function($event){_vm.$v.currentTransaction.account.$touch()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_vm._v("\n\n                  "+_vm._s(data.item.accountName)+"\n                ")])]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(data.item.accountName)}})],1)]]}}]),model:{value:(_vm.currentTransaction.account),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "account", $$v)},expression:"currentTransaction.account"}})],1):_vm._e(),_vm._v(" "),(_vm.currentTransaction.transactionType === 'expense')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":"Budget","items":_vm.budget,"chips":"","prepend-icon":"fa-money-bill-alt","hint":"What Budget does this belong to?","persistent-hint":"","change":_vm.selectAndHideAccount},model:{value:(_vm.currentTransaction.budget),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "budget", $$v)},expression:"currentTransaction.budget"}})],1):_vm._e(),_vm._v(" "),(_vm.currentTransaction.transactionType === 'transfer')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.transferAccount,"label":"Transfer From Account","item-text":"accountName","item-value":"accountName","chips":"","prepend-icon":"fa-balance-scale","hint":"Transfer from Account?","persistent-hint":"","error-messages":_vm.transferFromErrors,"max-height":"auto"},on:{"input":function($event){_vm.$v.currentTransaction.transferFrom.$touch()},"blur":function($event){_vm.$v.currentTransaction.transferFrom.$touch()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_vm._v("\n\n                  "+_vm._s(data.item.accountName)+"\n                ")])]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(data.item.accountName)}})],1)]]}}]),model:{value:(_vm.currentTransaction.transferFrom),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "transferFrom", $$v)},expression:"currentTransaction.transferFrom"}})],1):_vm._e(),_vm._v(" "),(_vm.currentTransaction.transactionType === 'transfer')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.transferAccount,"label":"Transfer To Account","item-text":"accountName","item-value":"accountName","chips":"","prepend-icon":"fa-balance-scale","hint":"Transfer To Account?","persistent-hint":"","error-messages":_vm.transferToErrors,"max-height":"auto"},on:{"input":function($event){_vm.$v.currentTransaction.transferTo.$touch()},"blur":function($event){_vm.$v.currentTransaction.transferTo.$touch()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_vm._v("\n\n                  "+_vm._s(data.item.accountName)+"\n                ")])]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(data.item.accountName)}})],1)]]}}]),model:{value:(_vm.currentTransaction.transferTo),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "transferTo", $$v)},expression:"currentTransaction.transferTo"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.category,"label":"Category","chips":"","prepend-icon":"fa-tags","hint":"What Category does this belong to?","persistent-hint":"","error-messages":_vm.categoryErrors},on:{"input":function($event){_vm.$v.currentTransaction.category.$touch()},"blur":function($event){_vm.$v.currentTransaction.category.$touch()}},model:{value:(_vm.currentTransaction.category),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "category", $$v)},expression:"currentTransaction.category"}})],1),_vm._v(" "),(_vm.currentTransaction.transactionType === 'expense')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-expansion-panel',{attrs:{"popout":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b',[_vm._v("Items")])]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.transactionItemsSearch),callback:function ($$v) {_vm.transactionItemsSearch=$$v},expression:"transactionItemsSearch"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticStyle:{"float":"right"},attrs:{"slot":"activator","dark":"","small":"","fab":"","middle":"","right":"","color":"red"},on:{"click":function($event){$event.preventDefault();_vm.addItem = true}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Add Item")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.transactionItemheaders,"items":_vm.currentTransaction.items,"hide-actions":"","item-key":"itemName","search":_vm.transactionItemsSearch},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){props.expanded = !props.expanded}}},[_c('td',[_vm._v(_vm._s(props.item.itemName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.itemPrice))])])]}},{key:"expand",fn:function(props){return [_c('v-card',{attrs:{"flat":""}},[_c('v-divider'),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"color":"warning"},on:{"click":function($event){$event.preventDefault();_vm.EditItem(props.item)}}},[_c('v-icon',{staticStyle:{"font-size":"18px","padding-right":"5px"}},[_vm._v("fa-edit")]),_vm._v("Edit")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"color":"error"},on:{"click":function($event){$event.preventDefault();_vm.DeleteItem(props.item)}}},[_c('v-icon',{staticStyle:{"font-size":"18px","padding-right":"5px"}},[_vm._v("fa-trash")]),_vm._v("Delete")],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"}},[_c('tr',[_c('td',[_c('v-subheader',[_vm._v("Currency:")])],1),_vm._v(" "),_c('td',[_c('v-subheader',[_vm._v(_vm._s(props.item.itemCurrency))])],1)]),_vm._v(" "),_c('tr',[_c('td',[_c('v-subheader',[_vm._v("Category:")])],1),_vm._v(" "),_c('td',[_c('v-subheader',[_vm._v(_vm._s())])],1)]),_vm._v(" "),(props.item.isTaxed)?_c('tr',[_c('td',[_c('v-subheader',[_vm._v("Total With Tax:")])],1),_vm._v(" "),_c('td',[_c('v-subheader',[_vm._v(_vm._s(props.item.taxedPrice))])],1)]):_vm._e()])],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n                        No results found for search \""+_vm._s(_vm.transactionItemsSearch)+"\" .\n                      ")])],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Transaction Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.transactionAmountErrors},on:{"input":function($event){_vm.$v.currentTransaction.transactionAmount.$touch()},"blur":function($event){_vm.$v.currentTransaction.transactionAmount.$touch()}},model:{value:(_vm.currentTransaction.transactionAmount),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "transactionAmount", $$v)},expression:"currentTransaction.transactionAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Comment","prepend-icon":"fa-comment"},model:{value:(_vm.currentTransaction.comment),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "comment", $$v)},expression:"currentTransaction.comment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":"Recurring Transaction"},model:{value:(_vm.currentTransaction.recurringTransaction),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "recurringTransaction", $$v)},expression:"currentTransaction.recurringTransaction"}})],1),_vm._v(" "),(_vm.currentTransaction.recurringTransaction)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Repeat Every","type":"number","min":"1","max":"60"},model:{value:(_vm.currentTransaction.repeat),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "repeat", $$v)},expression:"currentTransaction.repeat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":['Day','Week','Month','Year']},model:{value:(_vm.currentTransaction.cycle),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "cycle", $$v)},expression:"currentTransaction.cycle"}})],1)],1),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.currentTransaction.period),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "period", $$v)},expression:"currentTransaction.period"}},[_c('v-radio',{attrs:{"label":"Forever","value":"Forever"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"For Number of cycles","value":"For"}})],1),_vm._v(" "),(_vm.currentTransaction.period === 'For')?_c('v-text-field',{attrs:{"label":"Number of cycles","type":"number","min":"1","max":"60"},model:{value:(_vm.currentTransaction.numberOfCycles),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "numberOfCycles", $$v)},expression:"currentTransaction.numberOfCycles"}}):_vm._e(),_vm._v(" "),_c('v-dialog',{ref:"goesOff",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.currentTransaction.goesOffFirst},on:{"update:returnValue":function($event){_vm.$set(_vm.currentTransaction, "goesOffFirst", $event)}},model:{value:(_vm.addModelGoesOff),callback:function ($$v) {_vm.addModelGoesOff=$$v},expression:"addModelGoesOff"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentTransaction.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "goesOffFirst", $$v)},expression:"currentTransaction.goesOffFirst"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.currentTransaction.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "goesOffFirst", $$v)},expression:"currentTransaction.goesOffFirst"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.addModelGoesOff = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.goesOff.save(_vm.currentTransaction.goesOffFirst)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.currentTransaction.recurringTransaction)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-menu',{ref:"datemenu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px","return-value":_vm.currentTransaction.transactionDate},on:{"update:returnValue":function($event){_vm.$set(_vm.currentTransaction, "transactionDate", $event)}},model:{value:(_vm.datemenu),callback:function ($$v) {_vm.datemenu=$$v},expression:"datemenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date Picker","prepend-icon":"fa-calendar","readonly":""},slot:"activator",model:{value:(_vm.currentTransaction.transactionDate),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "transactionDate", $$v)},expression:"currentTransaction.transactionDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.currentTransaction.transactionDate),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "transactionDate", $$v)},expression:"currentTransaction.transactionDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.datemenu = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.datemenu.save(_vm.currentTransaction.transactionDate)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.currentTransaction.recurringTransaction)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"timemenu",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.currentTransaction.transactionTime},on:{"update:returnValue":function($event){_vm.$set(_vm.currentTransaction, "transactionTime", $event)}},model:{value:(_vm.timemenuvisibilty),callback:function ($$v) {_vm.timemenuvisibilty=$$v},expression:"timemenuvisibilty"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Time Picker","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.currentTransaction.transactionTime),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "transactionTime", $$v)},expression:"currentTransaction.transactionTime"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"actions":""},model:{value:(_vm.currentTransaction.transactionTime),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "transactionTime", $$v)},expression:"currentTransaction.transactionTime"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timemenuvisibilty = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.timemenu.save(_vm.currentTransaction.transactionTime)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.paymentType,"label":"Payment Type","chips":"","error-messages":_vm.paymentTypeErrors},on:{"input":function($event){_vm.$v.currentTransaction.paymentType.$touch()},"blur":function($event){_vm.$v.currentTransaction.paymentType.$touch()}},model:{value:(_vm.currentTransaction.paymentType),callback:function ($$v) {_vm.$set(_vm.currentTransaction, "paymentType", $$v)},expression:"currentTransaction.paymentType"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"500px"},model:{value:(_vm.addItem),callback:function ($$v) {_vm.addItem=$$v},expression:"addItem"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("New Item")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.addItemCheck(_vm.$v.transactionItemTemp)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.addItem = false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-combobox',{attrs:{"items":_vm.transactionItemsNames,"chips":"","label":"Item Name"},model:{value:(_vm.transactionItemTemp.itemName),callback:function ($$v) {_vm.$set(_vm.transactionItemTemp, "itemName", $$v)},expression:"transactionItemTemp.itemName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Item Price","type":"number","min":"1","error-messages":_vm.transactionItemPriceErrors},on:{"input":function($event){_vm.$v.transactionItemTemp.itemPrice.$touch()},"blur":function($event){_vm.$v.transactionItemTemp.itemPrice.$touch()}},model:{value:(_vm.transactionItemTemp.itemPrice),callback:function ($$v) {_vm.$set(_vm.transactionItemTemp, "itemPrice", $$v)},expression:"transactionItemTemp.itemPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":_vm.currency,"label":"Currency","single-line":"","error-messages":_vm.transactionItemCurrencyErrors},on:{"input":function($event){_vm.$v.transactionItemTemp.itemCurrency.$touch()},"blur":function($event){_vm.$v.transactionItemTemp.itemCurrency.$touch()}},model:{value:(_vm.transactionItemTemp.itemCurrency),callback:function ($$v) {_vm.$set(_vm.transactionItemTemp, "itemCurrency", $$v)},expression:"transactionItemTemp.itemCurrency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"Add Tax to item?"},model:{value:(_vm.transactionItemTemp.isTaxed),callback:function ($$v) {_vm.$set(_vm.transactionItemTemp, "isTaxed", $$v)},expression:"transactionItemTemp.isTaxed"}})],1),_vm._v(" "),(_vm.transactionItemTemp.isTaxed)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Total WIth Tax","type":"number"},model:{value:(_vm.transactionItemTemp.taxedPrice),callback:function ($$v) {_vm.$set(_vm.transactionItemTemp, "taxedPrice", $$v)},expression:"transactionItemTemp.taxedPrice"}})],1):_vm._e()],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditTransaction_vue__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_230db0c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditTransaction_vue__ = __webpack_require__(365);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditTransaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_230db0c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditTransaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Edit Transaction")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.editTransactionCheck(_vm.$v.editTransaction)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/transaction' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-btn-toggle',{staticStyle:{"width":"100%","margin-top":"15px"},attrs:{"mandatory":""},model:{value:(_vm.editTransaction.transactionType),callback:function ($$v) {_vm.$set(_vm.editTransaction, "transactionType", $$v)},expression:"editTransaction.transactionType"}},[_c('v-btn',{staticStyle:{"width":"33.33%"},attrs:{"flat":"","color":"blue","value":"income"}},[_vm._v("\n                Income\n              ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"width":"33.33%"},attrs:{"flat":"","color":"blue","value":"expense"}},[_vm._v("\n                Expense\n              ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"width":"33.33%"},attrs:{"flat":"","color":"blue","value":"transfer"}},[_vm._v("\n                Transfer\n              ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.currency,"label":"Currency","error-messages":_vm.currencyErrors},on:{"input":function($event){_vm.$v.editTransaction.currency.$touch()},"blur":function($event){_vm.$v.editTransaction.currency.$touch()},"change":_vm.selectedCurrencyChanged},model:{value:(_vm.editTransaction.currency),callback:function ($$v) {_vm.$set(_vm.editTransaction, "currency", $$v)},expression:"editTransaction.currency"}})],1),_vm._v(" "),(_vm.convert)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-expansion-panel',{attrs:{"popout":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b',[_vm._v("Conversion Rates")])]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.conversions),function(item){return [_c('v-divider'),_vm._v(" "),_c('v-list-tile',{key:item.title},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.convertFrom)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.convertTo)}})],1)],1)]})],2)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Transaction Name","error-messages":_vm.transactionNameErrors},on:{"input":function($event){_vm.$v.editTransaction.transactionName.$touch()},"blur":function($event){_vm.$v.editTransaction.transactionName.$touch()}},model:{value:(_vm.editTransaction.transactionName),callback:function ($$v) {_vm.$set(_vm.editTransaction, "transactionName", $$v)},expression:"editTransaction.transactionName"}})],1),_vm._v(" "),(_vm.editTransaction.transactionType !== 'transfer')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":"Account","items":_vm.account,"item-text":"accountName","item-value":"accountName","chips":"","prepend-icon":"fas fa-university","hint":"What Account does this belong to?","persistent-hint":"","change":_vm.adjustAccountToMatchBudget,"error-messages":_vm.accountErrors,"max-height":"auto"},on:{"input":function($event){_vm.$v.editTransaction.account.$touch()},"blur":function($event){_vm.$v.editTransaction.account.$touch()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_vm._v("\n\n                  "+_vm._s(data.item.accountName)+"\n                ")])]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(data.item.accountName)}})],1)]]}}]),model:{value:(_vm.editTransaction.account),callback:function ($$v) {_vm.$set(_vm.editTransaction, "account", $$v)},expression:"editTransaction.account"}})],1):_vm._e(),_vm._v(" "),(_vm.editTransaction.transactionType === 'expense')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":"Budget","items":_vm.budget,"chips":"","prepend-icon":"fa-money-bill-alt","hint":"What Budget does this belong to?","persistent-hint":"","change":_vm.selectAndHideAccount},model:{value:(_vm.editTransaction.budget),callback:function ($$v) {_vm.$set(_vm.editTransaction, "budget", $$v)},expression:"editTransaction.budget"}})],1):_vm._e(),_vm._v(" "),(_vm.editTransaction.transactionType === 'transfer')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.transferAccount,"label":"Transfer From Account","item-text":"accountName","item-value":"accountName","chips":"","prepend-icon":"fa-balance-scale","hint":"Transfer from Account?","persistent-hint":"","error-messages":_vm.transferFromErrors,"max-height":"auto","autocomplete":""},on:{"input":function($event){_vm.$v.editTransaction.transferFrom.$touch()},"blur":function($event){_vm.$v.editTransaction.transferFrom.$touch()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_vm._v("\n\n                  "+_vm._s(data.item.accountName)+"\n                ")])]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(data.item.accountName)}})],1)]]}}]),model:{value:(_vm.editTransaction.transferFrom),callback:function ($$v) {_vm.$set(_vm.editTransaction, "transferFrom", $$v)},expression:"editTransaction.transferFrom"}})],1):_vm._e(),_vm._v(" "),(_vm.editTransaction.transactionType === 'transfer')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.transferAccount,"label":"Transfer To Account","item-text":"accountName","item-value":"accountName","chips":"","prepend-icon":"fa-balance-scale","hint":"Transfer To Account?","persistent-hint":"","error-messages":_vm.transferToErrors,"max-height":"auto"},on:{"input":function($event){_vm.$v.editTransaction.transferTo.$touch()},"blur":function($event){_vm.$v.editTransaction.transferTo.$touch()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_vm._v("\n\n                  "+_vm._s(data.item.accountName)+"\n                ")])]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(data.item.accountName)}})],1)]]}}]),model:{value:(_vm.editTransaction.transferTo),callback:function ($$v) {_vm.$set(_vm.editTransaction, "transferTo", $$v)},expression:"editTransaction.transferTo"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.category,"label":"Category","chips":"","prepend-icon":"fa-tags","hint":"What Category does this belong to?","persistent-hint":"","error-messages":_vm.categoryErrors},on:{"input":function($event){_vm.$v.editTransaction.category.$touch()},"blur":function($event){_vm.$v.editTransaction.category.$touch()}},model:{value:(_vm.editTransaction.category),callback:function ($$v) {_vm.$set(_vm.editTransaction, "category", $$v)},expression:"editTransaction.category"}})],1),_vm._v(" "),(_vm.editTransaction.transactionType === 'expense')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-expansion-panel',{staticStyle:{"padding":"5px 0"},attrs:{"popout":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b',[_vm._v("Items")])]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.transactionItemsSearch),callback:function ($$v) {_vm.transactionItemsSearch=$$v},expression:"transactionItemsSearch"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticStyle:{"float":"right"},attrs:{"slot":"activator","dark":"","small":"","fab":"","middle":"","right":"","color":"red"},on:{"click":function($event){$event.preventDefault();_vm.addItem = true}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Add Item")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.transactionItemheaders,"items":_vm.editTransaction.items,"hide-actions":"","item-key":"itemName","search":_vm.transactionItemsSearch},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){props.expanded = !props.expanded}}},[_c('td',[_vm._v(_vm._s(props.item.itemName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.itemPrice))])])]}},{key:"expand",fn:function(props){return [_c('v-card',{attrs:{"flat":""}},[_c('v-divider'),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"color":"warning"},on:{"click":function($event){$event.preventDefault();_vm.EditItem(props.item)}}},[_c('v-icon',{staticStyle:{"font-size":"18px","padding-right":"5px"}},[_vm._v("fa-edit")]),_vm._v("Edit")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"color":"error"},on:{"click":function($event){$event.preventDefault();_vm.DeleteItem(props.item)}}},[_c('v-icon',{staticStyle:{"font-size":"18px","padding-right":"5px"}},[_vm._v("fa-trash")]),_vm._v("Delete")],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"}},[_c('tr',[_c('td',[_c('v-subheader',[_vm._v("Currency:")])],1),_vm._v(" "),_c('td',[_c('v-subheader',[_vm._v(_vm._s(props.item.itemCurrency))])],1)]),_vm._v(" "),_c('tr',[_c('td',[_c('v-subheader',[_vm._v("Category:")])],1),_vm._v(" "),_c('td',[_c('v-subheader',[_vm._v(_vm._s())])],1)]),_vm._v(" "),(props.item.isTaxed)?_c('tr',[_c('td',[_c('v-subheader',[_vm._v("Total With Tax:")])],1),_vm._v(" "),_c('td',[_c('v-subheader',[_vm._v(_vm._s(props.item.taxedPrice))])],1)]):_vm._e()])],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n                        No results found for search \""+_vm._s(_vm.transactionItemsSearch)+"\" .\n                      ")])],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Transaction Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.transactionAmountErrors},on:{"input":function($event){_vm.$v.editTransaction.transactionAmount.$touch()},"blur":function($event){_vm.$v.editTransaction.transactionAmount.$touch()}},model:{value:(_vm.editTransaction.transactionAmount),callback:function ($$v) {_vm.$set(_vm.editTransaction, "transactionAmount", $$v)},expression:"editTransaction.transactionAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Comment","prepend-icon":"fa-comment"},model:{value:(_vm.editTransaction.comment),callback:function ($$v) {_vm.$set(_vm.editTransaction, "comment", $$v)},expression:"editTransaction.comment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":"Recurring Transaction"},model:{value:(_vm.editTransaction.recurringTransaction),callback:function ($$v) {_vm.$set(_vm.editTransaction, "recurringTransaction", $$v)},expression:"editTransaction.recurringTransaction"}})],1),_vm._v(" "),(_vm.editTransaction.recurringTransaction)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Repeat Every","type":"number","min":"1","max":"60"},model:{value:(_vm.editTransaction.repeat),callback:function ($$v) {_vm.$set(_vm.editTransaction, "repeat", $$v)},expression:"editTransaction.repeat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":['Day','Week','Month','Year']},model:{value:(_vm.editTransaction.cycle),callback:function ($$v) {_vm.$set(_vm.editTransaction, "cycle", $$v)},expression:"editTransaction.cycle"}})],1)],1),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.editTransaction.period),callback:function ($$v) {_vm.$set(_vm.editTransaction, "period", $$v)},expression:"editTransaction.period"}},[_c('v-radio',{attrs:{"label":"Forever","value":"Forever"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"For Number of cycles","value":"For"}})],1),_vm._v(" "),(_vm.editTransaction.period === 'For')?_c('v-text-field',{attrs:{"label":"Number of cycles","type":"number","min":"1","max":"60"},model:{value:(_vm.editTransaction.numberOfCycles),callback:function ($$v) {_vm.$set(_vm.editTransaction, "numberOfCycles", $$v)},expression:"editTransaction.numberOfCycles"}}):_vm._e(),_vm._v(" "),_c('v-dialog',{ref:"goesOff",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.editTransaction.goesOffFirst},on:{"update:returnValue":function($event){_vm.$set(_vm.editTransaction, "goesOffFirst", $event)}},model:{value:(_vm.editModelGoesOff),callback:function ($$v) {_vm.editModelGoesOff=$$v},expression:"editModelGoesOff"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.editTransaction.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.editTransaction, "goesOffFirst", $$v)},expression:"editTransaction.goesOffFirst"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.editTransaction.goesOffFirst),callback:function ($$v) {_vm.$set(_vm.editTransaction, "goesOffFirst", $$v)},expression:"editTransaction.goesOffFirst"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.editModelGoesOff = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.goesOff.save(_vm.editTransaction.goesOffFirst)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.editTransaction.recurringTransaction)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-menu',{ref:"datemenu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px","return-value":_vm.editTransaction.transactionDate},on:{"update:returnValue":function($event){_vm.$set(_vm.editTransaction, "transactionDate", $event)}},model:{value:(_vm.datemenu),callback:function ($$v) {_vm.datemenu=$$v},expression:"datemenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date Picker","prepend-icon":"fa-calendar","readonly":""},slot:"activator",model:{value:(_vm.editTransaction.transactionDate),callback:function ($$v) {_vm.$set(_vm.editTransaction, "transactionDate", $$v)},expression:"editTransaction.transactionDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.editTransaction.transactionDate),callback:function ($$v) {_vm.$set(_vm.editTransaction, "transactionDate", $$v)},expression:"editTransaction.transactionDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.datemenu = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.datemenu.save(_vm.editTransaction.transactionDate)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.editTransaction.recurringTransaction)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"timemenu",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.editTransaction.transactionTime},on:{"update:returnValue":function($event){_vm.$set(_vm.editTransaction, "transactionTime", $event)}},model:{value:(_vm.timemenuvisibilty),callback:function ($$v) {_vm.timemenuvisibilty=$$v},expression:"timemenuvisibilty"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Time Picker","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.editTransaction.transactionTime),callback:function ($$v) {_vm.$set(_vm.editTransaction, "transactionTime", $$v)},expression:"editTransaction.transactionTime"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"actions":""},model:{value:(_vm.editTransaction.transactionTime),callback:function ($$v) {_vm.$set(_vm.editTransaction, "transactionTime", $$v)},expression:"editTransaction.transactionTime"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timemenuvisibilty = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.timemenu.save(_vm.editTransaction.transactionTime)}}},[_vm._v("OK")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.paymentType,"label":"Payment Type","chips":"","error-messages":_vm.paymentTypeErrors},on:{"input":function($event){_vm.$v.editTransaction.paymentType.$touch()},"blur":function($event){_vm.$v.editTransaction.paymentType.$touch()}},model:{value:(_vm.editTransaction.paymentType),callback:function ($$v) {_vm.$set(_vm.editTransaction, "paymentType", $$v)},expression:"editTransaction.paymentType"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"500px"},model:{value:(_vm.addItem),callback:function ($$v) {_vm.addItem=$$v},expression:"addItem"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("New Item")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.addItemCheck(_vm.$v.transactionItemTemp)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.addItem = false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-combobox',{attrs:{"items":_vm.transactionItemsNames,"chips":"","label":"Item Name"},model:{value:(_vm.transactionItemTemp.itemName),callback:function ($$v) {_vm.$set(_vm.transactionItemTemp, "itemName", $$v)},expression:"transactionItemTemp.itemName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Item Price","type":"number","min":"1","error-messages":_vm.transactionItemPriceErrors},on:{"input":function($event){_vm.$v.transactionItemTemp.itemPrice.$touch()},"blur":function($event){_vm.$v.transactionItemTemp.itemPrice.$touch()}},model:{value:(_vm.transactionItemTemp.itemPrice),callback:function ($$v) {_vm.$set(_vm.transactionItemTemp, "itemPrice", $$v)},expression:"transactionItemTemp.itemPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":_vm.currency,"label":"Currency","single-line":"","error-messages":_vm.transactionItemCurrencyErrors},on:{"input":function($event){_vm.$v.transactionItemTemp.itemCurrency.$touch()},"blur":function($event){_vm.$v.transactionItemTemp.itemCurrency.$touch()}},model:{value:(_vm.transactionItemTemp.itemCurrency),callback:function ($$v) {_vm.$set(_vm.transactionItemTemp, "itemCurrency", $$v)},expression:"transactionItemTemp.itemCurrency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"Add Tax to item?"},model:{value:(_vm.transactionItemTemp.isTaxed),callback:function ($$v) {_vm.$set(_vm.transactionItemTemp, "isTaxed", $$v)},expression:"transactionItemTemp.isTaxed"}})],1),_vm._v(" "),(_vm.transactionItemTemp.isTaxed)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Total WIth Tax","type":"number"},model:{value:(_vm.transactionItemTemp.taxedPrice),callback:function ($$v) {_vm.$set(_vm.transactionItemTemp, "taxedPrice", $$v)},expression:"transactionItemTemp.taxedPrice"}})],1):_vm._e()],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewTransfers_vue__ = __webpack_require__(164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8334f390_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewTransfers_vue__ = __webpack_require__(367);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewTransfers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8334f390_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewTransfers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"card-flex-toolbar noPadding",staticStyle:{"width":"100%"},attrs:{"fluid":"","scrollable":""}},[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Transfers")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","flat":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ path: '/dashboard/addtransfer' })}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-plus")])],1),_vm._v(" "),_c('span',[_vm._v("Add Budget")])],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"direction":_vm.direction,"transition":_vm.transition},model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","small":"","fab":""},slot:"activator",model:{value:(_vm.speedDial),callback:function ($$v) {_vm.speedDial=$$v},expression:"speedDial"}},[_c('v-icon',[_vm._v("fas fa-ellipsis-v")]),_vm._v(" "),_c('v-icon',[_vm._v("fas fa-times")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewSearch = !_vm.viewSearch}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-search")])],1),_vm._v(" "),_c('span',[_vm._v("Search")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","middle":"","right":""},on:{"click":function($event){$event.preventDefault();_vm.viewFilter = !_vm.viewFilter}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-filter")])],1),_vm._v(" "),_c('span',[_vm._v("Filter")])],1)],1)],1),_vm._v(" "),_c('v-container',{class:{'padContent': !_vm.drawer},staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.viewSearch === true)?[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Search"},on:{"change":_vm.getSearchItems,"input":_vm.getSearchItems},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]:_vm._e(),_vm._v(" "),(_vm.viewFilter === true)?[_c('v-flex',{attrs:{"xs12":""}})]:_vm._e(),_vm._v(" "),(_vm.itemsMinusDeleted.length === 0)?[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Sorry, There is currently no data to display here")]),_vm._v(" "),_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-frown")])],1)],1)],1)],1)]:_vm._e(),_vm._v(" "),_vm._l((_vm.itemsMinusDeleted),function(itemMinus){return _c('ListItem',{key:itemMinus.id,ref:"listItem",refInFor:true,attrs:{"liItem":{type: 'transfer',data: itemMinus}},on:{"Edit":function($event){_vm.redirectToEditPage($event)},"Delete":function($event){_vm.DeleteTransfer($event)}}})})],2)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete")]),_vm._v(" "),_c('v-card-text',[_vm._v("Are you sure you want to delete "),_c('b',[_vm._v("\""+_vm._s(_vm.deleteTransfer.transferName)+"\"")]),_vm._v("?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.DeleteTransferAccept()}}},[_vm._v("Yes")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTransfers_vue__ = __webpack_require__(165);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b76ec956_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTransfers_vue__ = __webpack_require__(369);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTransfers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b76ec956_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTransfers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("New Transfer")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.addTransferCheck(_vm.$v.currentTransfer)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/transfer' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-top":"0"}},[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.currency,"label":"Currency","error-messages":_vm.currencyErrors},on:{"input":function($event){_vm.$v.currentTransfer.currency.$touch()},"blur":function($event){_vm.$v.currentTransfer.currency.$touch()},"change":_vm.selectedCurrencyChanged},model:{value:(_vm.currentTransfer.currency),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "currency", $$v)},expression:"currentTransfer.currency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Transfer Name","error-messages":_vm.transferNameErrors},on:{"input":function($event){_vm.$v.currentTransfer.transferName.$touch()},"blur":function($event){_vm.$v.currentTransfer.transferName.$touch()}},model:{value:(_vm.currentTransfer.transferName),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "transferName", $$v)},expression:"currentTransfer.transferName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.account,"label":"Transfer From Account","item-text":"accountName","item-value":"accountName","chips":"","prepend-icon":"fa-balance-scale","hint":"Transfer from Account?","persistent-hint":"","error-messages":_vm.transferFromErrors},on:{"input":function($event){_vm.$v.currentTransfer.transferFrom.$touch()},"blur":function($event){_vm.$v.currentTransfer.transferFrom.$touch()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_vm._v("\n\n                "+_vm._s(data.item.accountName)+"\n              ")])]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(data.item.accountName)}})],1)]]}}]),model:{value:(_vm.currentTransfer.transferFrom),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "transferFrom", $$v)},expression:"currentTransfer.transferFrom"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.account,"label":"Transfer To Account","item-text":"accountName","item-value":"accountName","chips":"","prepend-icon":"fa-balance-scale","hint":"Transfer To Account?","persistent-hint":"","error-messages":_vm.transferToErrors},on:{"input":function($event){_vm.$v.currentTransfer.transferTo.$touch()},"blur":function($event){_vm.$v.currentTransfer.transferTo.$touch()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_vm._v("\n\n                "+_vm._s(data.item.accountName)+"\n              ")])]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(data.item.accountName)}})],1)]]}}]),model:{value:(_vm.currentTransfer.transferTo),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "transferTo", $$v)},expression:"currentTransfer.transferTo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.category,"label":"Category","chips":"","prepend-icon":"fa-tags","hint":"What Category does this belong to?","persistent-hint":"","error-messages":_vm.categoryErrors},on:{"input":function($event){_vm.$v.currentTransfer.category.$touch()},"blur":function($event){_vm.$v.currentTransfer.category.$touch()}},model:{value:(_vm.currentTransfer.category),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "category", $$v)},expression:"currentTransfer.category"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Transfer Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.transferAmountErrors},on:{"input":function($event){_vm.$v.currentTransfer.transferAmount.$touch()},"blur":function($event){_vm.$v.currentTransfer.transferAmount.$touch()}},model:{value:(_vm.currentTransfer.transferAmount),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "transferAmount", $$v)},expression:"currentTransfer.transferAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Comment","prepend-icon":"fa-comment"},model:{value:(_vm.currentTransfer.comment),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "comment", $$v)},expression:"currentTransfer.comment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-menu',{ref:"datemenu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px","return-value":_vm.currentTransfer.transferDate},on:{"update:returnValue":function($event){_vm.$set(_vm.currentTransfer, "transferDate", $event)}},model:{value:(_vm.datemenu),callback:function ($$v) {_vm.datemenu=$$v},expression:"datemenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date Picker","prepend-icon":"fa-calendar","readonly":""},slot:"activator",model:{value:(_vm.currentTransfer.transferDate),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "transferDate", $$v)},expression:"currentTransfer.transferDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.currentTransfer.transferDate),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "transferDate", $$v)},expression:"currentTransfer.transferDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.datemenu = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.datemenu.save(_vm.currentTransfer.transferDate)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"timemenu",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.currentTransfer.transferTime},on:{"update:returnValue":function($event){_vm.$set(_vm.currentTransfer, "transferTime", $event)}},model:{value:(_vm.timemenuvisibilty),callback:function ($$v) {_vm.timemenuvisibilty=$$v},expression:"timemenuvisibilty"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Time Picker","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.currentTransfer.transferTime),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "transferTime", $$v)},expression:"currentTransfer.transferTime"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"actions":""},model:{value:(_vm.currentTransfer.transferTime),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "transferTime", $$v)},expression:"currentTransfer.transferTime"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timemenuvisibilty = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.timemenu.save(_vm.currentTransfer.transferTime)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.paymentType,"label":"Payment Type","chips":"","error-messages":_vm.paymentTypeErrors},on:{"input":function($event){_vm.$v.currentTransfer.paymentType.$touch()},"blur":function($event){_vm.$v.currentTransfer.paymentType.$touch()}},model:{value:(_vm.currentTransfer.paymentType),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "paymentType", $$v)},expression:"currentTransfer.paymentType"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditTransfers_vue__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76267a43_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditTransfers_vue__ = __webpack_require__(371);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditTransfers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76267a43_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditTransfers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{class:{'fixedToolbar' : !_vm.drawer},staticStyle:{"z-index":"2"},attrs:{"card":"","prominent":"","top":"","offet-y":""}},[_c('v-toolbar-title',{staticClass:"headline grey-text"},[_vm._v("Edit Transfer")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.UpdateEditedTransfer(_vm.$v.editTransfer)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$router.push({ path: '/dashboard/transfer' })}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fas fa-times")])],1)],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-top":"0"}},[_c('v-container',{class:{'padContent': !_vm.drawer},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.currency,"label":"Currency","error-messages":_vm.currencyErrors},on:{"input":function($event){_vm.$v.editTransfer.currency.$touch()},"blur":function($event){_vm.$v.editTransfer.currency.$touch()},"change":_vm.selectedCurrencyChanged},model:{value:(_vm.editTransfer.currency),callback:function ($$v) {_vm.$set(_vm.editTransfer, "currency", $$v)},expression:"editTransfer.currency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Transfer Name","error-messages":_vm.transferNameErrors},on:{"input":function($event){_vm.$v.editTransfer.transferName.$touch()},"blur":function($event){_vm.$v.editTransfer.transferName.$touch()}},model:{value:(_vm.editTransfer.transferName),callback:function ($$v) {_vm.$set(_vm.editTransfer, "transferName", $$v)},expression:"editTransfer.transferName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.account,"label":"Transfer From Account","item-text":"accountName","item-value":"accountName","chips":"","prepend-icon":"fa-balance-scale","hint":"Transfer from Account?","persistent-hint":"","error-messages":_vm.transferFromErrors,"max-height":"auto"},on:{"input":function($event){_vm.$v.editTransfer.transferFrom.$touch()},"blur":function($event){_vm.$v.editTransfer.transferFrom.$touch()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_vm._v("\n\n                "+_vm._s(data.item.accountName)+"\n              ")])]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(data.item.accountName)}})],1)]]}}]),model:{value:(_vm.editTransfer.transferFrom),callback:function ($$v) {_vm.$set(_vm.editTransfer, "transferFrom", $$v)},expression:"editTransfer.transferFrom"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.account,"label":"Transfer To Account","item-text":"accountName","item-value":"accountName","chips":"","prepend-icon":"fa-balance-scale","hint":"Transfer To Account?","persistent-hint":"","error-messages":_vm.transferToErrors,"max-height":"auto"},on:{"input":function($event){_vm.$v.editTransfer.transferTo.$touch()},"blur":function($event){_vm.$v.editTransfer.transferTo.$touch()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_vm._v("\n\n                "+_vm._s(data.item.accountName)+"\n              ")])]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(data.item.accountName)}})],1)]]}}]),model:{value:(_vm.editTransfer.transferTo),callback:function ($$v) {_vm.$set(_vm.editTransfer, "transferTo", $$v)},expression:"editTransfer.transferTo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.category,"label":"Category","chips":"","prepend-icon":"fa-tags","hint":"What Category does this belong to?","persistent-hint":"","error-messages":_vm.categoryErrors},on:{"input":function($event){_vm.$v.editTransfer.category.$touch()},"blur":function($event){_vm.$v.editTransfer.category.$touch()}},model:{value:(_vm.editTransfer.category),callback:function ($$v) {_vm.$set(_vm.editTransfer, "category", $$v)},expression:"editTransfer.category"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Transfer Amount","prepend-icon":"fa-money-bill-alt","type":"number","min":"1","error-messages":_vm.transferAmountErrors},on:{"input":function($event){_vm.$v.editTransfer.transferAmount.$touch()},"blur":function($event){_vm.$v.editTransfer.transferAmount.$touch()}},model:{value:(_vm.editTransfer.transferAmount),callback:function ($$v) {_vm.$set(_vm.editTransfer, "transferAmount", $$v)},expression:"editTransfer.transferAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Comment","prepend-icon":"fa-comment"},model:{value:(_vm.editTransfer.comment),callback:function ($$v) {_vm.$set(_vm.editTransfer, "comment", $$v)},expression:"editTransfer.comment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-menu',{ref:"datemenu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px","return-value":_vm.editTransfer.transferDate},on:{"update:returnValue":function($event){_vm.$set(_vm.editTransfer, "transferDate", $event)}},model:{value:(_vm.datemenu),callback:function ($$v) {_vm.datemenu=$$v},expression:"datemenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date Picker","prepend-icon":"fa-calendar","readonly":""},slot:"activator",model:{value:(_vm.editTransfer.transferDate),callback:function ($$v) {_vm.$set(_vm.editTransfer, "transferDate", $$v)},expression:"editTransfer.transferDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.editTransfer.transferDate),callback:function ($$v) {_vm.$set(_vm.editTransfer, "transferDate", $$v)},expression:"editTransfer.transferDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.datemenu = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.datemenu.save(_vm.editTransfer.transferDate)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{ref:"timemenu",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.editTransfer.transferTime},on:{"update:returnValue":function($event){_vm.$set(_vm.editTransfer, "transferTime", $event)}},model:{value:(_vm.timemenuvisibilty),callback:function ($$v) {_vm.timemenuvisibilty=$$v},expression:"timemenuvisibilty"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Time Picker","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.editTransfer.transferTime),callback:function ($$v) {_vm.$set(_vm.editTransfer, "transferTime", $$v)},expression:"editTransfer.transferTime"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"actions":""},model:{value:(_vm.editTransfer.transferTime),callback:function ($$v) {_vm.$set(_vm.editTransfer, "transferTime", $$v)},expression:"editTransfer.transferTime"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timemenuvisibilty = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.timemenu.save(_vm.editTransfer.transferTime)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.paymentType,"label":"Payment Type","chips":"","error-messages":_vm.paymentTypeErrors},on:{"input":function($event){_vm.$v.editTransfer.paymentType.$touch()},"blur":function($event){_vm.$v.editTransfer.paymentType.$touch()}},model:{value:(_vm.editTransfer.paymentType),callback:function ($$v) {_vm.$set(_vm.editTransfer, "paymentType", $$v)},expression:"editTransfer.paymentType"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_415511ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_vue__ = __webpack_require__(373);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_415511ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Feature Not Available")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Coming Soon")]),_vm._v(" "),_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-frown")])],1)],1)],1)],1)]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suggestions_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suggestions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suggestions_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10bf33f5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Suggestions_vue__ = __webpack_require__(375);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suggestions_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10bf33f5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Suggestions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Feature Not Available")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Coming Soon")]),_vm._v(" "),_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-frown")])],1)],1)],1)],1)]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Issues_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Issues_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Issues_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fc18344_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Issues_vue__ = __webpack_require__(377);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Issues_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fc18344_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Issues_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Feature Not Available")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Coming Soon")]),_vm._v(" "),_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-frown")])],1)],1)],1)],1)]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12834458_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__(380);
function injectStyle (ssrContext) {
  __webpack_require__(379)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12834458_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid",attrs:{"id":"PageNotFound"}},[_c('div',{staticClass:"container error-container"},[_c('img',{staticClass:"img-responsive error-img",attrs:{"src":__webpack_require__(381),"alt":"404 Error"}})]),_vm._v(" "),_c('div',{staticClass:"container text-center"},[_c('p',{staticClass:"error-message"},[_vm._v("\n                The page you are looking for has been moved, deleted or possibly never existed.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"container text-center"},[_c('br')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.1f57eaa.png";

/***/ })
]),[204]);


// WEBPACK FOOTER //
// static/js/app.8f254fa7f30733dc2fd2.js